import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import RequestService from "../../../api/RequestService";
import { AuthContext } from "../../../context";
import {
  applyTheme,
  getTheme,
  setTheme,
  getSawWelcomeModal,
  setSawWelcomeModal,
  sendCommand,
  playAudio,
  showNotification,
  parseGetParameters,
  getQueryParams,
} from "../../../utils/service";
import {
  SideNav,
  SideNavItem,
  Button,
  Icon,
  Modal,
  Toast,
} from "react-materialize";
import NoAvatar from "../../../images/no-avatar.png";
import Verified from "../Verified/Verified";
import M from "materialize-css";
import ReactTyped from "react-typed";
import ChatWidget from "../ChatWidget/ChatWidget";

const Navbar = () => {
  const location = useLocation();
  const [themeIcon, setThemeIcon] = useState("light_mode");
  const [userData, setUserData] = useState({});
  const navigate = useNavigate();
  const params = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    isAuth,
    setIsAuth,
    isLoading,
    setLoading,
    ws,
    setWs,
    contentUpdateState,
    setContentUpdateState,
  } = useContext(AuthContext);
  const [noControls, setNoControls] = useState(1);

  // let socket = useRef(null);
  // socket.current = new WebSocket(ws);

  useEffect(() => {
    getUser();
  }, [contentUpdateState]);

  useEffect(() => {
    if (!userData.alias) {
      return;
    }

    let socket = new WebSocket(window.nott.info.ws + "?user=" + userData.alias);
    setWs(socket);

    // tm = setTimeout(() => {
    //   console.log("Имитация прерывания соединения");
    //   socket.current.close();
    // }, 10000);

    // socket.onopen = function () {
    //   console.log("[open] Соединение установлено");
    //   sendCommand(
    //     {
    //       action: "send_message",
    //     },
    //     socket
    //   );
    // };

    // socket.onclose = function (event) {
    //   console.log("Соединение закрыто", event.reason);
    // setTimeout(function () {
    //   wsConnect(true);
    // }, 1000);
    // };
    // socket.onerror = function (error) {
    //   alert(`[error] Не удалось установить соединение с сервером`);
    //   console.error(
    //     "Socket encountered error: ",
    //     error.message,
    //     "Closing socket"
    //   );
    //   console.log(error);
    //   socket.close();
    // };

    // return () => {
    //   ws.close();
    // };
  }, [userData]); //socket

  useEffect(() => {
    if (!ws) {
      return;
    }

    ws.onmessage = function (event) {
      // console.log(`[message] nav`);
      let receivedData = JSON.parse(event.data);
      // console.log(receivedData);
      if (receivedData.action == "updateMessages") {
        let pathnameClass = showNotification(
          receivedData.message,
          "Новое сообщение",
          receivedData.pathname
        );

        let toastPanelElements = document.querySelectorAll("." + pathnameClass);
        let toastCloseElements = document.querySelectorAll(
          ".close-" + pathnameClass
        );
        // console.log(toastElements);
        toastPanelElements.forEach((t) => {
          t.onclick = onNotificationClick;
        });
        toastCloseElements.forEach((t) => {
          t.onclick = onNotificationClose;
        });

        getUser();
      }
    };

    // return () => {
    //   ws.close();
    // };
  }, [ws]);

  useEffect(() => {
    getUser();
  }, [location]);

  useEffect(() => {
    applyTheme();
    const theme = getTheme();
    setThemeIcon(theme === "light" ? "dark_mode" : "light_mode");

    let welcomeModal = document.querySelector("#modal-welcome");
    if (
      welcomeModal &&
      !getSawWelcomeModal() &&
      searchParams.get("no_controls") != 1
    ) {
      let welcomeModalInstance = M.Modal.init(welcomeModal, {
        onCloseStart: function () {
          setSawWelcomeModal(1);
        },
      });
      setTimeout(() => {
        welcomeModalInstance.open();
      }, 3000);
    }

    let from = searchParams.get("from");
    if (from) {
      setReferrer(from);
    }
  }, []);

  useEffect(() => {
    getUser();
  }, [isAuth]);

  useEffect(() => {
    // setInterval(async () => {
    // console.log((await
    // RequestService.checkConnection();
    // ).data);
    // }, 10000);
    // setInterval(() => {
    //   getUser();
    // }, 30000);
  }, []);

  useEffect(() => {
    // console.log(searchParams.get("redirect_uri"));
    // console.log(params);
    // console.log(searchParams.get("no_controls"));
    let noControls = searchParams.get("no_controls");
    if (noControls != 1) {
      setNoControls(0);
    }
  }, [searchParams]);

  const changeTheme = () => {
    let theme = getTheme();
    if (theme === "light") {
      setTheme("dark");
      setThemeIcon("light_mode");
    } else {
      setTheme("light");
      setThemeIcon("dark_mode");
    }
  };

  const logout = () => {
    RequestService.logout().then((response) => {
      setIsAuth(false);
      navigate(
        "/login?redirect_uri=" + encodeURIComponent(window.location.href)
      );
    });
  };

  const getUser = async () => {
    const response = (await RequestService.getUser(params.id)).data;
    // console.log(response);
    if (!response.response_code) {
      return;
    }
    setUserData(response.result);
  };

  const setReferrer = async (code) => {
    const response = (await RequestService.setReferrer(code)).data;
    // console.log(response);
    // console.log(document.cookie);
  };

  const onNotificationClick = (e) => {
    let toastElement = e.currentTarget;
    // console.log(toastElement);

    let classes = toastElement.getAttribute("class").split(" ");
    let targetPathname = null;
    classes.forEach((cl) => {
      if (cl.includes("messages") || cl.includes("packages")) {
        targetPathname = cl;
      }
    });

    if (targetPathname) {
      let toastClass = "toast-" + targetPathname;
      targetPathname = "/" + targetPathname.replaceAll("---", "/");
      // console.log(targetPathname);
      navigate(targetPathname);

      let targetToasts = document.querySelectorAll("." + toastClass);
      targetToasts.forEach((t) => {
        M.Toast.getInstance(t).dismiss();
      });
    }

    // let toastInstance = M.Toast.getInstance(toastElement);
    // toastInstance.dismiss();
  };

  const onNotificationClose = (e) => {
    let toastElement = e.currentTarget;
    // console.log(toastElement);
    let classes = toastElement.getAttribute("class").split(" ");
    let targetPathnameClass = null;
    classes.forEach((cl) => {
      if (cl.includes("messages") || cl.includes("packages")) {
        targetPathnameClass = cl;
      }
    });

    if (targetPathnameClass) {
      targetPathnameClass = targetPathnameClass.replace("close-", "toast-");
      // console.log(targetPathnameClass);
      let targetToasts = document.querySelectorAll("." + targetPathnameClass);
      targetToasts.forEach((t) => {
        M.Toast.getInstance(t).dismiss();
      });
    }
  };

  return (
    <div>
      {/* <div className="fullscreen-intro">
        <div className="row">
          <div className="col s12 center-align">
            <div
              className="iq-logo-m"
              style={{ margin: "50px auto 0px" }}
            ></div>
          </div>
        </div>
        <div className="row">
          <div className="col s12 center-align" style={{ fontSize: "30px" }}>
            new opportunity to take{" "}
            <ReactTyped
              strings={[
                "action",
                "a step",
                "part",
                "chance",
                "through",
                "an interest",
                "advantage",
                "time",
              ]}
              typeSpeed={30}
              loop
              shuffle
            />
          </div>
          <div className="col s12 center-align" style={{ fontSize: "30px" }}>
            new opportunity to take{" "}
            <ReactTyped
              strings={[
                "начать действовать",
                "сделать шаг",
                "участвовать",
                "рискнуть",
                "довести все до конца",
                "проявить интерес",
                "воспользоваться шансом",
                "не суетиться"
              ]}
              typeSpeed={100}
              loop
              shuffle
            />
          </div>
        </div>
      </div> */}
      <div
        className={
          noControls
            ? "navbar-fixed navigation-bar hide-on-large-only hide"
            : "navbar-fixed navigation-bar hide-on-large-only"
        }
        style={{ position: "absolute" }}
      >
        <nav className="z-depth-0">
          <div className="nav-wrapper container">
            <Link to="/events" className="brand-logo hide-on-large-only">
              <div className="iq-logo-m"></div>
            </Link>
            {/* <a
              href="<?= $site ?>"
              className="brand-logo hide-on-large-only"
            ></a> */}
            <a href="#" data-target="side-nav-menu" className="sidenav-trigger">
              <i className="material-icons accent-color">menu</i>
              {userData.new_messages || userData.new_follow_requests_count ? (
                <div
                  style={{
                    width: "10px",
                    height: "10px",
                    borderRadius: "100px",
                    position: "absolute",
                    backgroundColor: "var(--error-color)",
                    left: "18px",
                    top: "16px",
                  }}
                ></div>
              ) : null}
            </a>

            {/* <ul id="side-bar" className="right hide-on-med-and-down">
              <li>
                <Link to="/events">События</Link>
              </li>
              <li>
                <Link to="/projects">Проекты</Link>
              </li>
              <li>
                <Link to="/users">Люди</Link>
              </li>
              <li>
                <Link to="/profile">Профиль</Link>
              </li>
            </ul> */}
          </div>
        </nav>
      </div>

      <SideNav
        id="side-nav-menu"
        options={{
          draggable: true,
        }}
        className="hide-on-large-only"
      >
        <Link to="/events">
          <li
            style={{ marginTop: "15px", marginBottom: isAuth ? "0px" : "0px" }}
          >
            {!isAuth ? (
              <div className="iq-logo" style={{ marginLeft: "50px" }}></div>
            ) : (
              <div>
                <div
                  className="circular-image pastel-shadow"
                  style={{
                    width: "90px",
                    height: "90px",
                    marginLeft: "65px",
                    position: "relative",
                  }}
                >
                  <div
                    className={
                      userData.avatar_img_url
                        ? "circular-image"
                        : "circular-image image-theme-filter"
                    }
                    style={{
                      backgroundImage:
                        "url(" +
                        (userData.avatar_img_url
                          ? userData.avatar_img_url
                          : NoAvatar) +
                        ")",
                      width: "90px",
                      height: "90px",
                    }}
                  ></div>
                </div>
                <div
                  className="row nm tertiary-color center-align mt10"
                  style={{ marginBottom: "-15px" }}
                >
                  {userData.alias ? (
                    <div className="col s12">{"@" + userData.alias}</div>
                  ) : null}
                </div>
              </div>
            )}
          </li>
        </Link>

        {isAuth ? (
          <Verified
            ml={120}
            mt={-135}
            isOriginal={userData.is_original}
            isVerified={userData.is_verified}
          />
        ) : null}

        {/* <SideNavItem subheader className="hide"> */}
        {/* <span className="secondary-color xl700">Навигация</span> */}
        {/* </SideNavItem> */}
        {!isAuth ? (
          <div>
            <li>
              <Link to="/login" className="waves-effect">
                <i className="material-icons">login</i>Войти
              </Link>
            </li>
            <li>
              <Link to="/signup" className="waves-effect">
                <i className="material-icons">person_add_alt</i>Регистрация
              </Link>
            </li>
            <li>
              <Link to="/events" className="waves-effect">
                <i className="material-icons">event</i>События
              </Link>
            </li>
            <li>
              <Link to="/projects" className="waves-effect">
                <i className="material-icons">emoji_objects</i>Проекты
              </Link>
            </li>
          </div>
        ) : (
          <div>
            <li>
              <Link to="/feed" className="waves-effect">
                <i className="material-symbols-outlined">pages</i>Лента
              </Link>
            </li>
            <li>
              <Link to="/events" className="waves-effect">
                <i className="material-icons">event</i>События
              </Link>
            </li>
            <li>
              <Link to="/projects" className="waves-effect">
                <i className="material-icons">emoji_objects</i>Проекты
              </Link>
            </li>
            <li>
              <Link to="/users?active=1" className="waves-effect">
                <i className="material-icons">people</i>Нетворкинг
              </Link>
            </li>
            <li>
              <Link to="/messages" className="waves-effect">
                {userData.new_messages ? (
                  <i className="error-color">
                    <span
                      className="accent-counter"
                      style={{
                        fontStyle: "normal",
                        backgroundColor: "var(--error-color)",
                      }}
                    >
                      {userData.new_messages > 9 ? "9+" : userData.new_messages}
                    </span>
                  </i>
                ) : (
                  <i className="material-icons">forum</i>
                )}
                Сообщения
              </Link>
            </li>
            <li>
              <Link to="/profile" className="waves-effect">
                {userData.new_follow_requests_count ? (
                  <i className="error-color">
                    <span
                      className="accent-counter"
                      style={{
                        fontStyle: "normal",
                        backgroundColor: "var(--error-color)",
                      }}
                    >
                      {userData.new_follow_requests_count > 9
                        ? "9+"
                        : userData.new_follow_requests_count}
                    </span>
                  </i>
                ) : (
                  <i className="material-icons">account_circle</i>
                )}
                Профиль
              </Link>
            </li>
            <li>
              <Link to="/tickets" className="waves-effect">
                <i className="material-icons">local_activity</i>Мои участия
              </Link>
            </li>
            <li>
              <Link to="/bookmarks" className="waves-effect">
                <i className="material-icons">bookmarks</i>Закладки
              </Link>
            </li>
          </div>
        )}

        <SideNavItem divider />
        <div className="row nm mt15">
          <div
            className="col s12"
            style={{ display: "flex", justifyContent: "space-evenly" }}
          >
            <span
              className="change-theme"
              style={{
                marginRight: isAuth ? "15px" : "0px",
                cursor: "pointer",
              }}
              onClick={changeTheme}
              // data-theme="dark"
            >
              <i
                className="material-icons-outlined accent-color theme-icon"
                // style={{ opacity: "0%" }}
              >
                {themeIcon}
              </i>
            </span>
            {isAuth ? (
              <span style={{ cursor: "pointer" }} onClick={logout}>
                <i className="material-icons-round accent-color">logout</i>
              </span>
            ) : null}
          </div>
        </div>
        <div className="row nm mt15">
          <div className="col s12 center-align">
            {isAuth ? (
              <div>
                <Link to={"/messages/support"} className="iq-link">
                  Техподдержка
                </Link>
              </div>
            ) : null}
            {window.nott.info.version}
            <br />© 2023-{new Date().getFullYear()}
          </div>
        </div>
      </SideNav>

      <ul
        id="nav-mobile"
        className={
          noControls
            ? "sidenav sidenav-fixed blur-card hide-on-med-and-down hide"
            : "sidenav sidenav-fixed blur-card hide-on-med-and-down"
        }
        style={{
          transform: "translateX(0px)",
          boxShadow: "none",
        }}
      >
        <Link to="/events">
          <li
            style={{ marginTop: "35px", marginBottom: isAuth ? "0px" : "30px" }}
          >
            {!isAuth ? (
              <div className="iq-logo" style={{ marginLeft: "50px" }}></div>
            ) : (
              <div>
                <div
                  className="circular-image pastel-shadow"
                  style={{
                    width: "90px",
                    height: "90px",
                    marginLeft: "65px",
                    position: "relative",
                  }}
                >
                  <div
                    className={
                      userData.avatar_img_url
                        ? "circular-image"
                        : "circular-image image-theme-filter"
                    }
                    style={{
                      backgroundImage:
                        "url(" +
                        (userData.avatar_img_url
                          ? userData.avatar_img_url
                          : NoAvatar) +
                        ")",
                      width: "90px",
                      height: "90px",
                    }}
                  ></div>
                </div>

                <div className="row nm tertiary-color center-align mt10">
                  {userData.alias ? (
                    <div className="col s12">{"@" + userData.alias}</div>
                  ) : null}
                </div>
              </div>
            )}
          </li>
        </Link>

        {isAuth ? (
          <Verified
            ml={135}
            mt={-155}
            isOriginal={userData.is_original}
            isVerified={userData.is_verified}
          />
        ) : null}

        {!isAuth ? (
          <div>
            <li
              className="bold"
              style={{ paddingLeft: "12px", paddingRight: "12px" }}
            >
              {location.pathname === "/login" ? (
                <Link
                  to="/login"
                  className="waves-effect accent-menu-item accent-glow"
                >
                  <i className="material-icons-round primary-color left">
                    login
                  </i>
                  Войти
                </Link>
              ) : (
                <Link to="/login" className="waves-effect">
                  <i className="material-icons-round accent-color left">
                    login
                  </i>
                  Войти
                </Link>
              )}
            </li>
            <li
              className="bold"
              style={{ paddingLeft: "12px", paddingRight: "12px" }}
            >
              {location.pathname === "/signup" ? (
                <Link
                  to="/signup"
                  className="waves-effect accent-menu-item accent-glow"
                >
                  <i className="material-icons-round primary-color left">
                    person_add_alt
                  </i>
                  Регистрация
                </Link>
              ) : (
                <Link to="/signup" className="waves-effect">
                  <i className="material-icons-round accent-color left">
                    person_add_alt
                  </i>
                  Регистрация
                </Link>
              )}
            </li>
          </div>
        ) : null}

        {isAuth ? (
          <div>
            <li
              className="bold"
              style={{ paddingLeft: "12px", paddingRight: "12px" }}
            >
              {location.pathname === "/feed" ? (
                <Link
                  to="/feed"
                  className="waves-effect accent-menu-item accent-glow"
                >
                  <i className="material-symbols-outlined primary-color left">
                    pages
                  </i>
                  Лента
                </Link>
              ) : (
                <Link to="/feed" className="waves-effect secondary-color">
                  <i className="material-symbols-outlined accent-color left">
                    pages
                  </i>
                  Лента
                </Link>
              )}
            </li>
          </div>
        ) : null}

        <li
          className="bold"
          style={{ paddingLeft: "12px", paddingRight: "12px" }}
        >
          {location.pathname === "/events" ? (
            <Link
              to="/events"
              className="waves-effect accent-menu-item accent-glow"
            >
              <i className="material-icons-round primary-color left">event</i>
              События
            </Link>
          ) : (
            <Link to="/events" className="waves-effect">
              <i className="material-icons-round accent-color left">event</i>
              События
            </Link>
          )}
        </li>

        <li
          className="bold"
          style={{ paddingLeft: "12px", paddingRight: "12px" }}
        >
          {location.pathname === "/projects" ? (
            <Link
              to="/projects"
              className="waves-effect accent-menu-item accent-glow"
            >
              <i className="material-icons-round primary-color left">
                emoji_objects
              </i>
              Проекты
            </Link>
          ) : (
            <Link to="/projects" className="waves-effect">
              <i className="material-icons-round accent-color left">
                emoji_objects
              </i>
              Проекты
            </Link>
          )}
        </li>

        {isAuth ? (
          <div>
            <li
              className="bold"
              style={{ paddingLeft: "12px", paddingRight: "12px" }}
            >
              {location.pathname === "/users" ? (
                <Link
                  to="/users?active=1"
                  className="waves-effect accent-menu-item accent-glow"
                >
                  <i className="material-icons-round primary-color left">
                    people
                  </i>
                  Нетворкинг
                </Link>
              ) : (
                <Link
                  to="/users?active=1"
                  className="waves-effect secondary-color"
                >
                  <i className="material-icons-round accent-color left">
                    people
                  </i>
                  Нетворкинг
                </Link>
              )}
            </li>

            <li
              className="bold"
              style={{ paddingLeft: "12px", paddingRight: "12px" }}
            >
              {location.pathname === "/messages" ? (
                <Link
                  to="/messages"
                  className="waves-effect accent-menu-item accent-glow"
                >
                  {userData.new_messages ? (
                    <i className="error-color">
                      <span
                        className="accent-counter"
                        style={{
                          fontStyle: "normal",
                          backgroundColor: "var(--error-color)",
                        }}
                      >
                        {userData.new_messages > 9
                          ? "9+"
                          : userData.new_messages}
                      </span>
                    </i>
                  ) : (
                    <i className="material-icons-round primary-color left">
                      forum
                    </i>
                  )}
                  Сообщения
                </Link>
              ) : (
                <Link to="/messages" className="waves-effect">
                  {userData.new_messages ? (
                    <i className="error-color">
                      <span
                        className="accent-counter"
                        style={{
                          fontStyle: "normal",
                          backgroundColor: "var(--error-color)",
                        }}
                      >
                        {userData.new_messages > 9
                          ? "9+"
                          : userData.new_messages}
                      </span>
                    </i>
                  ) : (
                    <i className="material-icons-round accent-color left">
                      forum
                    </i>
                  )}
                  Сообщения
                </Link>
              )}
            </li>

            <li
              className="bold"
              style={{ paddingLeft: "12px", paddingRight: "12px" }}
            >
              {location.pathname === "/profile" ? (
                <Link
                  to="/profile"
                  className="waves-effect accent-menu-item accent-glow"
                >
                  {userData.new_follow_requests_count ? (
                    <i className="error-color">
                      <span
                        className="accent-counter"
                        style={{
                          fontStyle: "normal",
                          backgroundColor: "var(--error-color)",
                        }}
                      >
                        {userData.new_follow_requests_count > 9
                          ? "9+"
                          : userData.new_follow_requests_count}
                      </span>
                    </i>
                  ) : (
                    <i className="material-icons-round primary-color left">
                      account_circle
                    </i>
                  )}
                  Профиль
                </Link>
              ) : (
                <Link to="/profile" className="waves-effect">
                  {userData.new_follow_requests_count ? (
                    <i className="error-color">
                      <span
                        className="accent-counter"
                        style={{
                          fontStyle: "normal",
                          backgroundColor: "var(--error-color)",
                        }}
                      >
                        {userData.new_follow_requests_count > 9
                          ? "9+"
                          : userData.new_follow_requests_count}
                      </span>
                    </i>
                  ) : (
                    <i className="material-icons-round accent-color left">
                      account_circle
                    </i>
                  )}
                  Профиль
                </Link>
              )}
            </li>

            <li
              className="bold"
              style={{ paddingLeft: "12px", paddingRight: "12px" }}
            >
              {location.pathname === "/tickets" ? (
                <Link
                  to="/tickets"
                  className="waves-effect accent-menu-item accent-glow"
                >
                  <i className="material-icons-round primary-color left">
                    local_activity
                  </i>
                  Мои участия
                </Link>
              ) : (
                <Link to="/tickets" className="waves-effect">
                  <i className="material-icons-round accent-color left">
                    local_activity
                  </i>
                  Мои участия
                </Link>
              )}
            </li>

            <li
              className="bold"
              style={{ paddingLeft: "12px", paddingRight: "12px" }}
            >
              {location.pathname === "/bookmarks" ? (
                <Link
                  to="/bookmarks"
                  className="waves-effect accent-menu-item accent-glow"
                >
                  <i className="material-icons-round primary-color left">
                    bookmarks
                  </i>
                  Закладки
                </Link>
              ) : (
                <Link to="/bookmarks" className="waves-effect">
                  <i className="material-icons-round accent-color left">
                    bookmarks
                  </i>
                  Закладки
                </Link>
              )}
            </li>
          </div>
        ) : null}

        <li style={{}}></li>
      </ul>
      <div
        style={{
          position: "fixed",
          bottom: "0px",
          zIndex: 1000,
          width: "220px",
          textAlign: "center",
          paddingBottom: isAuth ? "70px" : "70px",
          // display: 'flex',
          // justifyContent: 'center'
        }}
        className={
          noControls ? "hide-on-med-and-down hide" : "hide-on-med-and-down"
        }
      >
        <span
          className="change-theme"
          style={{ marginRight: isAuth ? "15px" : "0px", cursor: "pointer" }}
          onClick={changeTheme}
          // data-theme="dark"
        >
          <i
            className="material-icons-outlined accent-color theme-icon"
            // style={{ opacity: "0%" }}
          >
            {themeIcon}
          </i>
        </span>
        {isAuth ? (
          <span style={{ cursor: "pointer" }} onClick={logout}>
            <i className="material-icons-round accent-color">logout</i>
          </span>
        ) : null}
      </div>
      <div
        style={{
          position: "fixed",
          bottom: "0px",
          zIndex: 1000,
          width: "220px",
          textAlign: "center",
          paddingBottom: "10px",
        }}
        className={
          noControls ? "hide-on-med-and-down hide" : "hide-on-med-and-down"
        }
      >
        {isAuth ? (
          <div>
            <Link to={"/messages/support"} className="iq-link">
              Техподдержка
            </Link>
          </div>
        ) : null}
        {window.nott.info.version} © 2023-{new Date().getFullYear()}
      </div>

      {noControls ? null : (
        <ChatWidget messagesCount={userData.new_messages_support} />
      )}

      {/* <a href="https://t.me/NottSupportBot" target="_blank" rel="noreferrer">
        <div className="chat-btn">
          <i className="material-icons chat-btn-icon">chat</i>
        </div>
      </a> */}

      <Modal
        actions={[
          <Button flat modal="close" node="button" className="iq-btn hide">
            Закрыть
          </Button>,
        ]}
        bottomSheet={false}
        // fixedFooter
        header={"Добро пожаловать!"}
        id="modal-welcome"
        open={false}
        options={{
          dismissible: true,
          endingTop: "10%",
          inDuration: 250,
          onCloseEnd: null,
          // onCloseStart: function () {
          //   console.log(setSawWelcomeModal(1));
          // },
          onOpenEnd: null,
          onOpenStart: null,
          opacity: 0.5,
          outDuration: 250,
          preventScrolling: true,
          startingTop: "4%",
        }}
      >
        <div className="row mt25">
          <div className="col s12 center-align secondary-color xl500">
            New opportunity to take{" "}
            <span className="accent-color">
              <ReactTyped
                strings={[
                  "action",
                  "a step",
                  "part",
                  "chance",
                  "through",
                  "an interest",
                  "advantage",
                  "time",
                ]}
                typeSpeed={100}
                backSpeed={70}
                smartBackspace
                loop
                shuffle
              />
            </span>
          </div>
        </div>
        <div className="row">
          <div className="col s12 l6 center-align">
            <svg
              className="animated"
              id="freepik_stories-international-cooperation"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 500 500"
              version="1.1"
              // xmlnsXlink="http://www.w3.org/1999/xlink"
              // xmlns:svgjs="http://svgjs.com/svgjs"
            >
              <style
                dangerouslySetInnerHTML={{
                  __html:
                    "svg#freepik_stories-international-cooperation:not(.animated) .animable {opacity: 0;}svg#freepik_stories-international-cooperation.animated #freepik--World--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-international-cooperation.animated #freepik--Plants--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-international-cooperation.animated #freepik--Shadows--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-international-cooperation.animated #freepik--character-3--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-international-cooperation.animated #freepik--character-2--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-international-cooperation.animated #freepik--character-1--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-international-cooperation.animated #freepik--Icons--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-international-cooperation.animated #freepik--speech-bubbles--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}            @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }                    @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }        ",
                }}
              />
              <g
                id="freepik--World--inject-2"
                style={{ transformOrigin: "249.993843px 173.195522px" }}
                className="animable"
              >
                <g
                  id="freepik--world--inject-2"
                  style={{ transformOrigin: "249.993843px 173.195522px" }}
                  className="animable"
                >
                  <g
                    id="freepik--world--inject-2"
                    style={{ transformOrigin: "249.993843px 173.195522px" }}
                    className="animable"
                  >
                    <path
                      d="M153.14,251.84a124.76,124.76,0,1,0-23-113.31A124.78,124.78,0,0,0,153.14,251.84Z"
                      style={{
                        fill: "#3D50FA",
                        transformOrigin: "249.993843px 173.195522px",
                      }}
                      id="elj3u5uyji1b"
                      className="animable"
                    />
                    <g id="elyq2nneqiaa">
                      <path
                        d="M153.14,251.84a124.76,124.76,0,1,0-23-113.31A124.78,124.78,0,0,0,153.14,251.84Z"
                        style={{
                          fill: "rgb(255, 255, 255)",
                          opacity: "0.6",
                          transformOrigin: "249.993843px 173.195522px",
                        }}
                        className="animable"
                        id="eler7f4o3nxp"
                      />
                    </g>
                    <g id="elyberwjrrjjc">
                      <path
                        d="M129.38,187.39c-.31-.32-2.79-3.79-2.75-3.83a.46.46,0,0,0,.15-.48c0-.14-.73-.54-1.22-1,.1,1.53.24,3.05.4,4.57.56.54,1.42,1,1.85,1.39s1.65,2.22,2.34,2.12C131.34,190,129.7,187.72,129.38,187.39Zm24.7-90.92a4,4,0,0,0,1.78.16,1.32,1.32,0,0,1,.76.14c.65.43-.49,2.26,0,2.8.31.32,1,.12,1.53.07a10.74,10.74,0,0,0,2.36-.36,6.91,6.91,0,0,0,1.43-.73A25.85,25.85,0,0,1,165.55,97a2,2,0,0,0,1.51-2.22c-.07-.89-.86-.8-1.79-.44-1.24.49-2.66,1.26-3,1.38s-.55.11-.43-.17c.21-.53,1.71-1.15,2-1.29l1.76-1c1-.53,2.08-1,2.55-1.25a6,6,0,0,0,.86-.52,5.66,5.66,0,0,0,1.19-1.09c.59-.92,0-1.31.6-2.13a6.88,6.88,0,0,1,1.74-1.5,19.77,19.77,0,0,0,1.84-1.45c1.1-1.1.93-2.26,1.68-3.54a7.86,7.86,0,0,1,1.58-1.88c.89-.78,2.11-1.71,2.77-2.33l1.18-1.11A8.35,8.35,0,0,0,182.84,75c.25-.37.46-.81.7-1.17a2.77,2.77,0,0,1,.8-.83,6.13,6.13,0,0,0,2.1-2.77c.48-1.45-.55-1-.81-1.26-.44-.46-1.1-.33-1.83-.13-1.58.42-3.44,1.42-5.31,2.13q-3.62,2.53-7.11,5.36c-2,1.62-3.91,3.31-5.78,5a3.57,3.57,0,0,0,1.37.35c1.13.2,2.86-1.19,4.28-1.81.63-.28,2.54-1.37,2.72-.77.28.92-1.84,2.28-2.29,2.55a2.67,2.67,0,0,0-1,.88c-.49.78-1.31,1.84-1.95,1.51a3,3,0,0,0-1.2-.55.8.8,0,0,0-.8.53c-.36.71-1.51,1.94-1.8,1.18-.16-.45-.19-1.11-.58-1.27s-.73-.07-1-.23a.93.93,0,0,1-.15-.13q-2.78,2.69-5.36,5.51a2.18,2.18,0,0,0,.54.51,3.57,3.57,0,0,0,2.31.49,6.71,6.71,0,0,0,1.32-.39c.52-.2,1.7-1.15,2.06-1s-.16,1.4-.61,2.12a11.26,11.26,0,0,1-2.79,2.93,5.32,5.32,0,0,1-3.9,1.27c-.4,0-2.05-.33-2.64.35S153.76,96.28,154.08,96.47Zm-7.59,13.38c1.38.61,2.87-1,3.66-2.49,1-1.86-1-1.74-.25-2.44.5-.48,1.1-1.07.82-1.33-.08-.09-.26-.07-.34-.15s-.94,0-2.27.87-1.58,2.27-2.54,2.81S145.57,109.44,146.49,109.85Zm4.74-9.63c.17-.3,1.07-2.08.63-2.79-.22-.34-.61-.25-1,0-.48.62-.94,1.26-1.4,1.89a5,5,0,0,0,.49,1.15C150.19,101.15,151.06,100.51,151.23,100.22Zm34.9-26c-.46,1.44-2.07,1.31-2.63,1.63a3.85,3.85,0,0,0-.8.61,4.06,4.06,0,0,0-.8,2.51c0,.29,0,.56-.76,1.37A23.79,23.79,0,0,1,178,83.13a5.8,5.8,0,0,0-2,2.73c-.42,1.14,0,1.07.32,1.38a1.72,1.72,0,0,1,.4.58c.17.4.33,1.51.85,1.62s2.07-.76,3.22-1.33c1.95-1,3.82-1.72,4.95-.13a4,4,0,0,1,.68,1.85,19.73,19.73,0,0,1-.62,5.11,3.72,3.72,0,0,0,0,2.24c.59,1.15,2,1,2.66,2.29a5.54,5.54,0,0,1-.28,4c-.59,1.57-1.44,2.21-2.17,3.57s-.29,2.72-.35,4a12.49,12.49,0,0,0,.78,4.67,35.33,35.33,0,0,0,2,4.7,5.62,5.62,0,0,0,1.09,1.6c.73.69,2.55.66,3.79.22a4.11,4.11,0,0,0,2.08-1.55c1.21-1.78.66-4.27,1-6.34a5.3,5.3,0,0,1,2.4-3.85c1.13-.74,2.67-1.33,3.55-2.68.73-1.11,1.06-2.75,1.84-3.78,1.05-1.38,2.89-1.53,4.14-2.24.87-.49,2.57-1.62,2.59-3,0-.74-.29-1.09,0-1.82a2.64,2.64,0,0,1,.9-1c.14-.11.41-.21.66-.36s.4-1.14.07-1.56-.47-.56-.59-.76c-.89-1.49-1.14-2.75,0-3.78.94-.86,2.58-2.57,2-4.49-.37-1.15-1.07-1.51-1.19-2.82a4.91,4.91,0,0,1,.1-1.46,13.39,13.39,0,0,1,1-2.3,1.57,1.57,0,0,0,0-1.34c-.4-.85-1.26-.84-1.74-1.34-2.51-2.56,4.29-8.76,3.44-10a1,1,0,0,0-.68-.35,6.55,6.55,0,0,0-1.63-.07,2.79,2.79,0,0,0-.89.25,2.82,2.82,0,0,0-1,1.06c-.47.73-1.09,1.56-1.32,1.35s-.16-.29-.37-.55c-.59-.75-.58-.12-1.17.28-.28.2-1.33.41-1.49-.52s.72-2,1-2.56a2.25,2.25,0,0,1,.77-1c.49-.34.3-1.61-.58-2.25a5.53,5.53,0,0,0-2.76-.93,8.33,8.33,0,0,0-5.4,1.26,12.08,12.08,0,0,0-2.57,2c-1.11,1.13-2.06,3.54-3.32,4.82a2,2,0,0,1-2.18.56c-1.3-.22-3-.5-5,2.12C185.63,72.81,186.57,72.84,186.13,74.25Zm179.5,112.94a6.61,6.61,0,0,0,.84,3.64,6.3,6.3,0,0,0,1.43,2.27,3.08,3.08,0,0,0,5-1c.22-.52.43-1.55.73-2.19.23-1.69.41-3.38.57-5.08a2,2,0,0,1-.1-2.15c.56-1.17.55-2.69-.67-2.75s-1.66,1.25-2.45,2.3a26.68,26.68,0,0,1-3.2,3.4C367.1,186.22,365.77,185.75,365.63,187.19ZM237.29,69.11c.35.3.68.72,1,1a5.7,5.7,0,0,0,1.34.93,15.4,15.4,0,0,1,1.61,1,1.37,1.37,0,0,1,.2.22c.2.32.07.25.08.5,0,.45.31.68.78.87s.76.41,1.16.63c.64.35,1.79.41,1.93-.24a5.65,5.65,0,0,0,0-1.3,9.63,9.63,0,0,1-.12-2.18,2.63,2.63,0,0,0,0-.31c0-.17.38-.42.94-.19.38.16.79.38,1,.47l.4.17c.22.11.24.45.25.56a.32.32,0,0,0,.11.22.94.94,0,0,0,.44.23,5.32,5.32,0,0,0,1.6.41,1.76,1.76,0,0,0,.62-.08.61.61,0,0,0,0-1.06,17.24,17.24,0,0,1-2.42-1,5.9,5.9,0,0,1-1.39-1.21c-.75-.93,0-1.19.57-1.25a7.39,7.39,0,0,0,1.43-.28A3.09,3.09,0,0,0,250.66,66a1.46,1.46,0,0,0-.17-1.12l-.09-.09a2,2,0,0,0-2-.4,23.87,23.87,0,0,1-2.42.31,5.44,5.44,0,0,1-1.08.08,2.73,2.73,0,0,0-.84-.07,3.43,3.43,0,0,0-1.29.7,2.6,2.6,0,0,1-1.56.62c-.34,0-.91-.13-.9.3,0,.61.83,1.09,1,1.66s-.38.32-.75,0-.4-.84-.73-1.13-.53-.13-.57,0c-.07.33.06.79-.57.45-.36-.19-.54-.48-.93-.56-.66-.13-2,.47-1.36,1.56A3.21,3.21,0,0,0,237.29,69.11Zm51.82,17a17,17,0,0,0,1.7.86,2.21,2.21,0,0,0,2.19-.25c.34-.36-.23-1.12-.59-1.67a7.24,7.24,0,0,0-.42-.61,6.26,6.26,0,0,1-.74-2.16,4.93,4.93,0,0,1,0-1.39,5.23,5.23,0,0,1,1.17-2.5,15.35,15.35,0,0,1,3.41-2.79c.6-.37,1.22-.71,1.85-1,.38-.2.77-.38,1.16-.56a6.75,6.75,0,0,0,1-.32,1,1,0,0,0-.21-1.69,1.75,1.75,0,0,0-.4-.16,1.21,1.21,0,0,0-1,.2,8.21,8.21,0,0,1-2.53.86c-3.67.69-6.54,2.32-7.45,5.77a17.93,17.93,0,0,0-.76,3.7c0,.47,0,.94-.45,1.05-.31.08-.43.2-.28.6A4.6,4.6,0,0,0,289.11,86.08ZM225.3,107.25c.67-1.81-1.68-4.25-2.55-4-.52.13-1,.68-1.4.91a9.08,9.08,0,0,1-1.72.37c-.95.2-1.75,1.66-2.54.82s-1.14,2.15,0,3.73C219.78,112.71,224.29,110,225.3,107.25Zm144.37,90.8a19.56,19.56,0,0,0-3.13.31,3.85,3.85,0,0,1-1.7-.12,1.71,1.71,0,0,1-.79-.53,3.87,3.87,0,0,1-.36-2.42,3.36,3.36,0,0,0-.95-2.45c-.25-.29-.5-.61-.75-.89-.4-.45-.94-.62-1.34-1.09a2.81,2.81,0,0,1-.77-1.72,1.68,1.68,0,0,1,.39-1.08,3.23,3.23,0,0,0,.18-2.39c-.18-.45-.41-.87-.55-1.2a15.68,15.68,0,0,0-1-1.7c-.17-.27-.41-.43-.58-.7a13.44,13.44,0,0,1-2-6.59c0-.69.2-1.4.79-1.42a1,1,0,0,1,.52.16,6,6,0,0,1,1.15,1.11c.3.38.61.73.7.72,1.18-.21,1.63,4.11,3,2.19.44-.6,1.09-1,1.55-1.57a7.5,7.5,0,0,0,.54-.77,6.47,6.47,0,0,0,.79-2.45,5.23,5.23,0,0,0-.13-1.62,8.67,8.67,0,0,0-1.48-3.05,8.93,8.93,0,0,0-1.19-1.45,1.75,1.75,0,0,1-.84-1.33c-.2-1.62,1-3.59,2.45-3.22a2.25,2.25,0,0,0,2.49-.73,10.87,10.87,0,0,1,2.56-2.55c1.35-.76,3.16-1.57,4.14-2.88l.27-.36a124.84,124.84,0,0,0-3-15.24l-.6-2.17a125.11,125.11,0,0,0-42-63.06c-.24,0-.49.09-.77.12a18.32,18.32,0,0,0-3.57.55,3.24,3.24,0,0,0-1.84,2.07A2.86,2.86,0,0,1,321,80a3.18,3.18,0,0,1-1.87.54c-.5,0-1.49.07-1.22.89s1.62,1.75,2.14,2.45c1.15,1.59-1.29.42-1.91.12a6.32,6.32,0,0,0-2.13-.72c-.42,0-1.36-.23-1.35.27s.56,1.1.83,1.49c.41.59.48.8,0,1s-1,.3-1.45.47a4.71,4.71,0,0,1-2.44.32,4.61,4.61,0,0,1-2.63-2.4A3.3,3.3,0,0,0,307.78,83a3,3,0,0,0-1.53-.57c-1.07,0-1.12,1-.82,2.06s-.63,1.42-.24,2.39a6.87,6.87,0,0,0,2.13,2.36c.68.56,1.84,1.34,1.63,2.09-.31,1.08-1.81.4-2.85-.14-1.41-.74-2.83-1.26-4.25-2a8.23,8.23,0,0,0-3.77-.92c-.67,0-1.06.38-.2,1.14.4.35,1.72.93,1.65,1.62s-1.59.64-2.06.73a16.58,16.58,0,0,1-4.11.52,10.29,10.29,0,0,0-3.21-.11,5.48,5.48,0,0,0-1.28.57,3.15,3.15,0,0,0-1.09,1.58.71.71,0,0,1-.34.38,2,2,0,0,1-.51.21,1.62,1.62,0,0,1-1.6-1.24c-.09-.62-.14-1.3-.73-1.61a2.62,2.62,0,0,0-2.13,0,.82.82,0,0,0-.34.68c0,.5.39,1.81.37,2.75a2.1,2.1,0,0,1-.48,1.42,4.79,4.79,0,0,1-1,.64,2.39,2.39,0,0,0-.95,1.37c-.4,1.08-.71,2.06-1.75,2.4s-1.86,0-3-1.05A26.58,26.58,0,0,1,273,98c-1.07-1.29,1-.8,1.52-.74.81.09,1.58,0,2.37,0a7.73,7.73,0,0,0,1.94-.13c.51-.1,1.4-.3,1.24-1.14-.33-1.84-4.19-3.5-5.31-4q-.81-.39-1.62-.72c-.9-.37-2.42-1-3.4-1.31A5,5,0,0,0,268,89.5c-.88,0-1.43,1.28-2.6-.36a2.66,2.66,0,0,0-2-1.44,8.63,8.63,0,0,0-5,.79,5,5,0,0,0-1.15.88c-.56.58-1.11,1.65-1.56,2a1.69,1.69,0,0,1-1,.28c-2.13,0-2.66,2-2.59,4.56,0,.69.13,1.47.09,2.15a4.07,4.07,0,0,1-.24,1.11c-.19.58-.69,1.9-1.06,3-.23.66-.47,1.33-.7,2-.65,2-1.43,4-2.24,6.06a7.52,7.52,0,0,0-.53,4.77,4.77,4.77,0,0,0,2.37,2.7,3.24,3.24,0,0,0,3.38-.16c1.52-.76,2.3,0,3.28,1.79a5.31,5.31,0,0,0,1.61,2.21,2.9,2.9,0,0,0,2.45.12c.82-.4,1-1.37.78-2.47a3.11,3.11,0,0,1,.31-2.63,2.55,2.55,0,0,0-.11-2.54c-.67-1.42-1.95-3.16-2.28-4.11a4,4,0,0,1-.25-1.69,7.43,7.43,0,0,1,.24-1.4c.21-.71,1.07-2.06,1.66-3.3a7.88,7.88,0,0,0,.73-2.52,4.25,4.25,0,0,1,.28-1.19,1.69,1.69,0,0,1,1.77-.66,1.57,1.57,0,0,1,1.06.76,3.62,3.62,0,0,1,.05,2.74c-.29.93-1.05,1.22-1.41,2.08a7.15,7.15,0,0,0,.06,3.4,7.37,7.37,0,0,0,1,3.38c.91,1.06,2.36.59,3.33.4.44-.09.93-.19,1.44-.25a5.22,5.22,0,0,1,2.15.17c.35.17.81,1.07.49,1.32a2.2,2.2,0,0,1-.68.24c-1,.25-2,.26-2.95.46-.61.14-1.61.2-1.59,1.18,0,.75.8,1.28,1.25,1.69a2,2,0,0,1,.91,1.54.57.57,0,0,1-.63.56,2.84,2.84,0,0,1-1.45-.74c-.29-.23-.68-.71-1-.5-.49.33.05,2.14.15,2.71a5.19,5.19,0,0,1-.07,3c-.85,1.77-3,2-4.65,2.12a17.3,17.3,0,0,1-3.11-.21,5.36,5.36,0,0,1-2-.4c-1.47-.82-1.06-3.44-1.55-4.91-.57-1.72-1.9-.3-2,.78-.22,1.71,1.35,3.48,1,5.1-.24,1.13-1.53,1.32-2.33,1.76a3.58,3.58,0,0,0-1.53,3.32,3.24,3.24,0,0,1-.84,1.81c-.49.75-1.07,1.38-1.59,2.07a2.29,2.29,0,0,1-1.52,1c-.41.06-1-.18-1.3.15s0,.94-.58,1.25-1.48.15-2.16.33c-.45.12-1.08.53-.57,1.06a6.6,6.6,0,0,0,2,.89,4.13,4.13,0,0,1,2,3.08c.41,1.84.15,3.37-1.57,3.75s-3.4.24-5,1.24c-1.41.88-1,3.75-.77,5.36a3.13,3.13,0,0,0,.74,1.79c.33.44.52,1,.95,1.37a2.43,2.43,0,0,0,1.89.29A2.22,2.22,0,0,1,243,157a2.58,2.58,0,0,0,.43.25c.25.09.5-.6,1-.77a3,3,0,0,1,.9-.1,2.86,2.86,0,0,0,.88-.07c.28-.1.37-.41.57-.51a2.9,2.9,0,0,0,1.21-2.27c.07-.45.1-.92.19-1.37a14.15,14.15,0,0,1,.55-1.46,7.69,7.69,0,0,1,.27-1.1c.33-.69.9-.65,1.46-.92a1.92,1.92,0,0,0,1.09-1.85c0-.69-.1-1.45.5-1.81s1.13,0,1.67,0c.93-.09,1.58-.84,2.3-1.37,1.43-1.07,2.75-.73,3.93.78a13.19,13.19,0,0,0,1.71,1.94c.5.42,1.08.63,1.57,1.06s1.35.93,1.94,1.45a3.25,3.25,0,0,1,.65,2.7c0,.36-.24.94.05,1.22s.64-.09.81-.34c.57-.82.33-1.69.19-2.71-.07-.47-.21-1,.16-1.21.15-.08.36,0,.56,0s.14-.95-.57-1.36a2.52,2.52,0,0,0-1.3-.41c-.32,0-1.31-1-1.6-1.27a18.37,18.37,0,0,1-2.14-1.92,4,4,0,0,1-1.18-2c-.15-1.14,1-1.2,1.68-.78s.7,1,1.07,1.54c.83,1.19,2.18,1.27,3.25,1.81.76.38.83,1,1.24,1.8a11.15,11.15,0,0,1,1,1.8c.15.48.13.55.48.88a7,7,0,0,0,1.06.78,4.87,4.87,0,0,1,1,.66c.31.34.19.31.19.71,0,.85.07,1.7.89,2.06s.78-1.18,1-1.83a1.6,1.6,0,0,0,0-1.37c-.21-.42-.7-.64-.94-1-.6-1,.43-1.06.88-1.49s1.13-1.4,2.07-.87c.55.31.49.69.53,1.26a5.19,5.19,0,0,0,.63,1.75,7,7,0,0,0,.68,1.71,4.36,4.36,0,0,0,3.7,1.61c.55-.07,1-.58,1.57-.52.25,0,.43.22.66.29a2.6,2.6,0,0,0,1.24,0c.54-.1,1-.35,1.59-.42.9-.12,1.2.1,1.11,1.16a37.08,37.08,0,0,0-.23,4.85c0,.6.38,2.08.07,2.55s-1.38-.24-1.85-.41a8.28,8.28,0,0,0-4.19-.14,15.66,15.66,0,0,1-2.16.34,3.94,3.94,0,0,1-2.07-.15c-1.15-.68-4.16-2.7-5.05-.77-.6,1.29.09,3.48-1.78,3.37a8.56,8.56,0,0,1-2.55-.91,19.64,19.64,0,0,0-3.86-1,4.56,4.56,0,0,1-2.54-1.13c-1-1,.34-1.51.36-2.62a3,3,0,0,0-1.26-2.54,3.62,3.62,0,0,0-2.3-.1c-.39.07-.75,0-1.15.05a5.88,5.88,0,0,0-1.23.5,12.81,12.81,0,0,1-2.72.64c-.49.07-1,.14-1.45.23-.29.06-1,.07-1.24.3-1.08,1.26-2.45,2.65-4.15,2.75-1.07.06-2-.15-3,.43a9.94,9.94,0,0,0-2.48,2.33c-.61.73-1.17,1.51-1.73,2.29s-.47,2-.3,3.15a3,3,0,0,1-.34,2,6.69,6.69,0,0,1-2.1,2.59,6.42,6.42,0,0,0-2.4,2.7,17.72,17.72,0,0,0-1,3.43,10.2,10.2,0,0,0,1.26,7.09c.37.55-.16,2.47-.21,3.12a6,6,0,0,0,.64,3.44,5.4,5.4,0,0,0,1.56,1.81,29.17,29.17,0,0,1,3.27,3.68A23.1,23.1,0,0,0,242.7,200a8.51,8.51,0,0,0,5.32,1.75,5.15,5.15,0,0,0,2.59-.74,3.72,3.72,0,0,1,1.35-.54,8.1,8.1,0,0,0,2.82-1.11c.45-.33.88-.71,1.29-1a3.22,3.22,0,0,1,3-.85,4.52,4.52,0,0,1,1.33.64,13,13,0,0,0,2.57,1.41,3.49,3.49,0,0,0,1.35.14,3.33,3.33,0,0,1,2.18.67c1.71,1.3,1.15,3.44.51,5.31s.3,3.32,1.21,4.57c.44.59.78,1.22,1.22,1.78a6.77,6.77,0,0,1,1.29,2c.23.73.51,1.39.76,2.07a16.35,16.35,0,0,1,.77,4.33c0,.72,0,1.45,0,2.18,0,.36-.05.72-.08,1.08a12.31,12.31,0,0,1-.33,2,7.07,7.07,0,0,0-.22.88,11.65,11.65,0,0,0-.07,2.21c.06,1.23.11,3.38.19,4.61a9.63,9.63,0,0,0,.33,2.17,54.64,54.64,0,0,0,3.71,8.8c.65,1.35,1.24,2.77,1.87,4.11.32.68.57,1.43.95,2.09a10.65,10.65,0,0,1,.74,2.32c.5,1.61,1.16,2.55,2.51,2.76a5.92,5.92,0,0,0,3.3-.86,14.05,14.05,0,0,0,5.67-5,17.8,17.8,0,0,0,2-4.82,10.43,10.43,0,0,0,.52-2.41c.07-.88.06-1.77.19-2.64.19-1.34.32-2.79.59-4.1.43-2.07.52-3.82,1.73-5.5a25.25,25.25,0,0,1,1.85-2.15c1-1.14,2.88-3,2.68-5.08-.92-9.69-4.63-16.86,3.14-25.06,2-2.85,4.48-7.5,4.84-11.57.18-1.93-1.22-3-2.35-2.34a21.14,21.14,0,0,1-2.08,1c-.65.27-1.34.44-2,.67a3.43,3.43,0,0,1-2-.23,2,2,0,0,1-1.43-1.24c-.35-.71-.34-1.46-.62-2.16a3.45,3.45,0,0,0-1.39-1.44,13.41,13.41,0,0,1-3-3.31A16.64,16.64,0,0,1,291.7,173a7.44,7.44,0,0,0-1.61-2.64,19.66,19.66,0,0,1-1.77-2.62c-.53-.91-2.45-4.06-1.21-4.93,1-.68,2.16,2.25,2.63,3,.92,1.49,1.89,2.84,2.87,4.16.5.69,1,1.36,1.52,2.05.85,1.13,1.85,2.52,2.26,3.09l.72,1.06a8.77,8.77,0,0,1,1.32,2.07c.83,3,2,4.53,3.63,4.2s3.58-2.2,4.89-3.16a46.71,46.71,0,0,0,6.51-5.71,10.8,10.8,0,0,0,1.17-2.24,8,8,0,0,0,.95-2.72,1.68,1.68,0,0,0-.93-1.84c-.47-.22-1,0-1.36-.25s-.67-1.14-1.07-1.58c-.77-.85-1.41-.09-2.08.42s-2.08,1.66-2.87,1.15c-.57-.36-.35-.9-.67-1.4s-.6-.2-1-.27c-1-.19-1.55-1.54-2.12-2.39-.44-.65-1.4-2.11-1.25-3,.25-1.47,2,.24,2.45.68a19.39,19.39,0,0,1,1.87,1.49,3.36,3.36,0,0,0,1.64.93,12,12,0,0,0,1.86.56c.47,0,.92-.2,1.42-.08a1.61,1.61,0,0,1,.78.42,4.72,4.72,0,0,0,3.33,1.13c1.33-.16,2.65-.65,3.88-.91a5.87,5.87,0,0,1,3-.1,5.52,5.52,0,0,1,2.88,2.3c.51.9,1,2.18,2,2.54s1.34-1.94,2-1.48c.33.25.41,1.13.49,1.53a12.66,12.66,0,0,0,.42,1.49c.37,1.13.73,2.27,1.1,3.41a57.36,57.36,0,0,0,2.6,6.94c.51,1.06,1.26,2.66,2.3,2.91.46.1,1.09-.59,1.33-1.06a5.26,5.26,0,0,0,.41-1.58,16.64,16.64,0,0,0,.23-2.1,22.65,22.65,0,0,1,.51-3.87,13.05,13.05,0,0,1,.59-1.66,13.91,13.91,0,0,1,1.55-2.79,10.87,10.87,0,0,0,1.44-1.88c.16-.3.3-.61.45-.92a16.89,16.89,0,0,1,.94-1.74,2,2,0,0,1,.63-.67,4.68,4.68,0,0,1,1-.24c.66-.2.8-.77,1.32-1.16s1.13,0,1.52.38c1.13,1,1.36,2.85,1.7,4.37.16.76.34,1.73,1.08,1.73s1.12-.52,1.76,0,.87,1.8,1.31,2.63,1.17,1.07,1.38,2c.14.6-.1.73-.29,1.23a1.49,1.49,0,0,0,.19,1.31,3,3,0,0,1,.24,1.67,4.82,4.82,0,0,0-.2,1.6.71.71,0,0,0,.58.6A2.15,2.15,0,0,1,357,182.4c.13.37.23.75.32,1a5.88,5.88,0,0,0,.45,1.21c.08.12.16.21.23.32a2.84,2.84,0,0,1,.36,1.32.94.94,0,0,1-.32.84c-.21.13-.51,0-.81-.15s-1.08-.63-1.47-.81a1.7,1.7,0,0,0-.73-.18c-1.29.05.45,2.93.82,3.38s.65.65.95,1a3.56,3.56,0,0,1,.59,1.36,16.48,16.48,0,0,0,1.51,2.86,11.72,11.72,0,0,0,1.75,2.38,5.93,5.93,0,0,0,1.05.85c.11.07,1.15.47,1.15.51.22,3.71,3.05,1.07,4.46,2,1.12.91,2.33.4,3.54.15a5,5,0,0,0,.95-.29c.07-.32.13-.64.2-1a1.5,1.5,0,0,1-1.14-.51A1.53,1.53,0,0,0,369.67,198.05Zm-80.16-53.87a13.21,13.21,0,0,1-3.38-.49c-1.59-.34-3.94.5-5.41,1a4.73,4.73,0,0,1-2.23.31c-1.58-.26-1.07-3.84-.63-5.56a7.27,7.27,0,0,1,1-2.58c1-1.25,3.58-.05,3.24.41s.27.84.41,1.27.63.8,1,.35-.36-2.36.93-3.25l.49-.3c1.36-.74,2.17,0,2.17,1.83a3.86,3.86,0,0,0,.19,1.3c.67,1.8,2.55,1.81,2.59,2s.77.38,1.41,1S291.08,144.09,289.51,144.18Zm13.71,5c-1.55-.55-2.05-3.13-2.22-4.78s-3-2.89-3.46-4.72c-.9-3.24,1.57-6.08,3.63-6.15,1.58-.05.79,2.38.21,4-.21.57.11,1,.71,1.66a18.24,18.24,0,0,0,3.46,2.42c.75.6,0,1.51-.78,1.87s2,2.58,1.81,4.38C306.45,149.27,304.87,149.76,303.22,149.18Zm-51.11.9c.48-.62.3-1.2-1.32-1-.25,0-.6.49-.8,1C249.71,150.84,251.29,151.15,252.11,150.08Zm58.14,70.69a5.57,5.57,0,0,0-.64-2.32,3.58,3.58,0,0,1-.43-.48c-.09-.13-.17-.3-.26-.46a2.18,2.18,0,0,0-.35-.51c-.22-.22-1,.2-1.13,1.06-.06.55,0,1.16-.05,1.57-.07,2.22-1.76,3.43-2.66,5.12-1.27,2.37-.61,4.69-.47,7.05.1,1.54-.46,3.69.21,5,2.19,4.27,4.16-3,4.68-5.24a41,41,0,0,0,1.15-9C310.31,222,310.3,221.37,310.25,220.77ZM264.86,153a1.31,1.31,0,0,0-1-1.61c-.45-.15-.46.35-.42.92C263.48,153,264.55,154.14,264.86,153Zm-5.78-3.95c.46-1.68-1.33-6.3-1.8-4.52a6.16,6.16,0,0,0-.16,1C256.94,147.41,258.61,150.72,259.08,149.05Zm-23.62-21.72c-.25.22-.13.58-.33.79s-.94.14-1.29.26c-1,.36-.09,1.39.14,2a2.29,2.29,0,0,1,.06,1.32c-.09.4-.34.88-.13,1.32.55,1.18,1.79.3,2.49,0a3.45,3.45,0,0,0,1.69-2.42,3.29,3.29,0,0,0-.53-2.2C237.14,127.81,236.09,126.8,235.46,127.33ZM167.3,189.52a7.39,7.39,0,0,1-3.42-.8c-1-.48-2.28-1.05-3.27-.49-.74.42.33,1.18.88,1.5a11.47,11.47,0,0,0,1.28.61c.72.31,1.7.93,2.25,1.16a1.58,1.58,0,0,0,1,.11c1.33-.26,2.61-1.25,4.1-.39.35.21,1,.86,1.37.76,0,0,0,0,.07,0,.42-.21.25-1,0-1.39C170.63,189,168.49,189.48,167.3,189.52Zm73.23-56.69c.07.59-.82.85-.49,1.44s1,.27,1.34.2c1.58-.31,3.69-1,4.63-2.55.36-.6,1.07-2.06.25-2.54-.31-.18-.67-.15-1-.4a4.54,4.54,0,0,1-.86-1.19,15.49,15.49,0,0,0-1.22-2c-.71-.92-2.21-1.29-2.15-2.81,0-.5.59-1,.36-1.53-.13-.3-.45-.33-.68-.44s-1.27-.89-1.23-1.32-2.42-.28-2.11.54c.47,1.21-1.51,1.82-.5,2.52l.12.1a14,14,0,0,0,.07,1.63c.15.87,1.43,1.1,1.58,1.84s1.3,0,1.76.68.6,2.07-.06,2.42-.22,1.76-.65,2.15c-.28.25-.57.49-.24.95C239.65,132.76,240.44,132.12,240.53,132.83Zm-85.12-11.66c-.54,1.68-.54,3.19.22,3.46s2.56-1,3.86-1.54c1.86-.72.22-1.45-1.18-2.61C157.39,119.72,155.94,119.48,155.41,121.17Zm62.77,115.7a16.54,16.54,0,0,1-1.24-4.8c-.09-3.06,2.4-5.25,2.4-8.46,0-2-2.26-3.68-3.76-4.19s-3.41-2.87-5-2.67l-.53.07c-1.62.2-4.26-1.67-6-2.11a9.78,9.78,0,0,0-1.16-.21c-1.69-.23-3.8-2-4.85-3.75s-2.12-3.16-3.52-3.75c-1.89-.79-4.12.93-5.85-.82a8.19,8.19,0,0,0-2.51-1.87,8.4,8.4,0,0,1-2.66-1.66c-1.13-1.15-1.86-.11-3.05-.5-.69-.22-1-.54-1.73-.46-1,.1-2,.33-3,.33-.81,0-1.14-.39-1.85-.81-1.6-1-3.86.12-4.65,1.49-.39.67-.45,1.65-.84,2.27-.79,1.24-2.94.53-4.24,0a7.5,7.5,0,0,1-2.67-1.84c-.88-1-1.5-1.22-1.6-2.61-.08-1,0-2.31-.84-3.11a3.12,3.12,0,0,0-2.44-.59c-.64,0-1.44.39-2.1.11a2.36,2.36,0,0,1-1.22-2.05c.09-.54.62-.92.84-1.38a1.79,1.79,0,0,0,.24-.81c0-.15-.22-.74-.2-.79.47-1.16.15-1.77-.49-2a2.72,2.72,0,0,0-3,2.29c-.12,1.42-2.26,2.59-3.76,2.11-2.95-.94-4.86-6.07-4.35-9.74.23-1.67,1.75-4.11,3.19-4.46,1.16-.28,2.47.07,3.84,0,.57,0,.51-.36.46-.75-.08-.64,1.18-.75,2.09-.89a4.84,4.84,0,0,1,4.12,1.33,11.49,11.49,0,0,1,1.23,2.13c.78,1.56,3.07,2.27,2.45.56-.38-1.07-1.08-2.4-1.54-3.62-.63-1.7.45-4.14,1.47-5.17a20.48,20.48,0,0,0,1.83-1.9,3.83,3.83,0,0,0,1-2.17c0-.95-.76-1.76-.79-2.81a5.09,5.09,0,0,1,.31-2.11,6.33,6.33,0,0,1,2.06-2.8c.85-.62,2.44-.62,2.82-1.93s.29-2.08,1.21-3.19a9.48,9.48,0,0,1,2-1.71c1.17-.79.74,1.48,2.22,1.14a12.49,12.49,0,0,0,4-2.53c1.3-1.12,1.74-2.83,1.24-3.32s-1.47,2.48-2.95,2.31a1.85,1.85,0,0,1-.45-.11c-1.39-.51-1.38-2.8-1.63-2.73s-.26-.31.06-.51.56-2.67-.84-1.94a7.63,7.63,0,0,0-.75.44c-1.35.88-1.63-.25-.28-1.15,2.14-1.43,4.79-2,7.26-2.84,1.49-.54,2.1.21,1.37,2s-1.09,2.92,0,3c1.51.15,3.24-.71,3.32-.13.05.38.11.73.58.31.7-.64,1.63.56,2.19-.47a1.64,1.64,0,0,0-.28-1.62c-.48-.75-1.12-2.14-2-2.09s-1.3-2.19-1-4.1l.09-.59c.25-1.91-2.14-3.18-3.35-4.06-3.54-2.61-2.32-2.89-4.2-6.82-.7-1.46-2-1.08-3.12.35-.6.76-1.22,1.33-1.73,1.31-1.32-.05-.76-4.07-1.66-4.4-.49-.17-1.13-.19-1.44-1a2.49,2.49,0,0,0-3.26-1.34c-1.25.36-2.45,2.82-2.29,4.21s-1,3.66-.45,4.61,1.32,3.4.38,5c-.57.94-1.41,1.71-1.88,2.66-.83,1.67.49,4-.05,5a1,1,0,0,1-1.35.57,4,4,0,0,1-1.9-2.36c-.41-2.19.38-3.57-1.54-3.89a19.25,19.25,0,0,1-7.11-2.59c-1-.65-.93-1.63-1.24-2.87s-1.43-1.5-.08-3.37c.85-1.18,2.17-2.08,2.66-3.77s-1-1.63-.1-3,3.09-1.06,4.09-1.6a2.24,2.24,0,0,0,1.22-1.24c.41-1.17-.47-1.14-.69-1.69-.07-.17.26-.31.59-.41a3.35,3.35,0,0,0,1.3-.49,2.42,2.42,0,0,0,.58-.74,5.25,5.25,0,0,1,.33-.88,1.71,1.71,0,0,1,.75-.54,4.18,4.18,0,0,0,1.71-.82,6.19,6.19,0,0,0,2.11-2.46,5,5,0,0,0,.39-2.17c-.13-.38-.62-.29-.6-.91,0-2,2.21-2.25,2.92-2.46,1.07-.32,2.33-.74,2.07,1.3-.11.91-.24,3.07.86,1.79.62-.73.85-1.07,1.29-.5a1.89,1.89,0,0,1,.57,1.75,2.42,2.42,0,0,1-1.05,1.65c-.74.61-1.47,3.56-2.71,3.89l-.61.16c-1.23.38-1.08,3.31.14,2.64s2.67,0,3.56,1c1.26,1.35,3.13,2.77,4,2.68,1.32-.12.35-2.92,1-3.22a3.41,3.41,0,0,1,1.15-.39c.21,0,.26-1.72.24-1.9a2.58,2.58,0,0,0-.56-1.34c-.59-.66-1.43-.66-1.77-1.77s.84-2.47,1.54-2.08c.33.18.53.68.75,1.16.34.78,1,1.17,1.34,1a1.69,1.69,0,0,0,.52-.48c.39-.53.35-1.15.65-1.7.49-.89,1.25-.71,1.73-1.55a1.08,1.08,0,0,0-.39-1.64c-1-.68-2.17-1-3.16-1.64-.2-.13-.41-.21-.57-.34a2.82,2.82,0,0,1-.32-2,6.62,6.62,0,0,0,.1-1.29,2,2,0,0,0-.78-1.29,6.06,6.06,0,0,0-1.24-1c-.72-.44-2.4-.4-3-1.34s-1-2.17-1.92-2c-.1,0-.43.36-.57.43a.93.93,0,0,1-.59.09c-.37-.07-.61-.39-.94-.53a2.18,2.18,0,0,0-2.3.36,8.13,8.13,0,0,1-1,.64,9.87,9.87,0,0,1-1.86.5,8.68,8.68,0,0,0-2.53,1.92,6.86,6.86,0,0,0-1.31,1.74c-.51,1-.87,2.66-.22,2.78a16.86,16.86,0,0,0,2.57-.29c.7,0,2.42-.2,1.83,1.57-.44,1.34-1.89,1.06-2,2.63A3.54,3.54,0,0,1,158,113a6.12,6.12,0,0,1-1,1.45,8.62,8.62,0,0,1-1,1c-.51.39-1.22.28-1.16-.48s.61-1.12.73-1.76a.71.71,0,0,0-.51-.91,2,2,0,0,0-.55-.12,1.57,1.57,0,0,1-1-.63,3.64,3.64,0,0,1-.32-.66c-.15-.41-.4-.79-.56-1.23a3.48,3.48,0,0,1,.49-2.61c.2-.23.44-.44.71-.76a14.45,14.45,0,0,0,1.43-2.11c.9-1.59,1.08-3.08,0-2.9s-2.8,1.64-3.5,3.54a19.66,19.66,0,0,1-1.18,3.28c-.55,1-1.33,1.69-1.84,2.65a19.11,19.11,0,0,0-.75,2.63c-.32.88-.51.71-1,1-1.1.78-.9,2.75-2,3.72a2.67,2.67,0,0,1-1.16.51,3.94,3.94,0,0,1-2,.16c-.18,0-.44-.09-.32-.51.18-.61.73-.79,1.06-1.06a5.81,5.81,0,0,0,1.81-4c-.09-.67-.71-.6-1.07-.88a2.69,2.69,0,0,1-.67-2.63q-2.53,4.31-4.7,8.77a.57.57,0,0,1,.55.35c.14.32,0,.72-.22,1.25a7.32,7.32,0,0,0-.37,1c-.17.56-.91,2.64-1.56,2.25a3.19,3.19,0,0,1-.46-.38,122.8,122.8,0,0,0-5.6,15.44,125.93,125.93,0,0,0-4.68,42.16,1.05,1.05,0,0,1,1,.22c1.18.92,2,3.46,3.14,4.37,2,1.53,4.25,3.45,5.44,5.74.79,1.5,1.91,3.72,3.31,4.5,2.75,1.51,6,2.63,8.66,2.26s5.84,4.17,8.34,2.64c.3-.18,1.81,1.94,2,2.23a9.49,9.49,0,0,0,3,2.39,19.35,19.35,0,0,0,3.69,1.43c2.31.72,5.11,1.91,4.78,5.37a48.46,48.46,0,0,1-1.46,6.14c-.48,2.15-.75,4.29.45,6.3s3,3.32,4.18,5.23.95,4.49,2.2,6.59c1.57,2.63,3.67,3,6.38,4a9.13,9.13,0,0,1,5.05,3.86,79.75,79.75,0,0,1,7.22,13.52c2.51,5.85,4.61,12.1,8.35,17.26a26.26,26.26,0,0,0,6.47,6.62c1.68,1.13,3.29,1.12,3.14-1.29-.08-1.48-1.3-2.66-1.91-4s-.1-2.47-.18-3.86c-.06-1.16-1.15-2.86-.39-3.83s2-.38,2.39-1.64c.5-1.58-1.21-2.23-1.53-3.44s1.75-1.31,2.35-2.43c.38-.71.14-1.6.39-2.34.21-.59.52-.7.86-1.14a6.42,6.42,0,0,0,1-2.94c.25-1.67-1.44-3.52-.87-5.12a7.49,7.49,0,0,1,3.17-3.05c.93-.51,1.58-.61,2.12-1.89a8.3,8.3,0,0,0,.15-4.71C218.07,238.66,218.41,237.59,218.18,236.87ZM147.1,155c1.2-1.23,3.32-4,4.54-3.36a4.6,4.6,0,0,1,1.47,1.68c.82,1.3,2.83,1.67,4,2.18s-.38,1.69-.51,2.82-.91,1.59-.9,1c0-.38,0-.67-.56-.43-.74.35-.58-.23-.4-.86.25-.87-1.78-1.51-2.23.27-.11.45-.18,1-.25,1.46-.24,1.81-2,1.85-1.7.05q0-.34.12-.69c.35-1.79-.3-3.87-1.72-3.64C147.34,155.7,145.81,156.32,147.1,155Z"
                        style={{
                          fill: "rgb(255, 255, 255)",
                          opacity: "0.5",
                          transformOrigin: "249.920357px 171.173923px",
                        }}
                        className="animable"
                        id="el4tjde2tn39v"
                      />
                    </g>
                    <g id="elbuxiahjlgtc">
                      <path
                        d="M282.65,62.65c-79.44-23-94.34,31.12-52.27,65.31s114.25,45.52,124,23S341.7,79.78,282.65,62.65Z"
                        style={{
                          fill: "rgb(255, 255, 255)",
                          opacity: "0.1",
                          transformOrigin: "282.013908px 109.882706px",
                        }}
                        className="animable"
                        id="eljuljlo423h"
                      />
                    </g>
                    <g id="elum6oi5cif4l">
                      <path
                        d="M194.29,250.4C142.47,207.77,139.56,133,165.82,81.14A124.76,124.76,0,0,0,328.65,270.06c3.25-2.64,6.33-5.42,9.24-8.3C297.2,279.82,239.92,287.94,194.29,250.4Z"
                        style={{
                          fill: "#3D50FA",
                          opacity: "0.2",
                          transformOrigin: "231.597107px 189.531609px",
                        }}
                        className="animable"
                        id="el1zsple57tkri"
                      />
                    </g>
                  </g>
                  <path
                    d="M358.46,234.78a5,5,0,0,1-.73-.33,7.52,7.52,0,0,0-5.36-.7c-4.72,1-9.86,6.42-11.71,12.29-1.06,3.39-.89,6.19.47,7.69a3.47,3.47,0,0,0,2.68,1.12l.57,0c.67-.78,1.33-1.55,2-2.34l-.69.2a2.8,2.8,0,0,1-2.84-.43c-1-1.06-1.12-3.36-.23-6.16,1.59-5,5.85-9.58,9.69-10.43a5.68,5.68,0,0,1,4.07.53,6.4,6.4,0,0,0,1.09.48l1.09-1.86Z"
                    style={{
                      fill: "rgb(255, 255, 255)",
                      transformOrigin: "349.265826px 244.195323px",
                    }}
                    id="el2uxxeyu1ep"
                    className="animable"
                  />
                  <path
                    d="M370.12,206.46l-4.68.66-3.11.43c-11.69,1.63-19,2.45-21.33.11-1.74-1.72-.36-4.94,1.78-7.36a10.19,10.19,0,0,0,2.87-5.82,6,6,0,0,0-1.78-4.73c-2.11-2.22-5.78-3.48-9.77-3.35-6.59.21-12.18,4.34-12.47,9.21a8.76,8.76,0,0,0,2,5.86c1.56,2.06,2.54,5.28.18,7.58-3.12,3-11.07,3.57-22,4l-2.5.1-6.86.26c0-3.82-.21-7.39-.36-10.39L292,200.6c-.51-9.51-.91-17,1.81-19.56,2.31-2.16,5.89-.92,8.25.8a10.34,10.34,0,0,0,6.32,2.2c5.29-.08,9.6-5.29,9.58-11.61s-4.32-11.53-9.62-11.63A10.29,10.29,0,0,0,302,163c-2.36,1.71-5.93,2.95-8.25.78-2.52-2.35-2-9.07-1.37-17.59l.13-1.83c.28-3.72.56-8.14.62-12.8,5.55.31,10.44,1,15.36,1.73l.64.1c3.29.49,6.13.92,8.52,1.09,4,.3,6.35-.17,7.71-1.57,2.56-2.65.65-6.91-2-10a10.57,10.57,0,0,1-2.63-5.11,4.42,4.42,0,0,1,1.24-3.94c1.5-1.51,4.06-2.11,7-1.66,5.25.8,10.32,4.64,11.09,8.39a5.41,5.41,0,0,1-1,4.29,7.07,7.07,0,0,0,.76,9.49c2.95,2.77,8,3,15.75,3.3l1.42.06c3.58.15,7.9.37,12.75.91h.15c-.16-.56-.31-1.13-.48-1.69-4.83-.54-9.1-.78-12.66-.94l-1.4-.06c-7-.31-12-.53-14.34-2.74s-1.72-5.29-.37-7.19a6.81,6.81,0,0,0,1.18-5.43c-1-4.63-6.78-9.19-13-10.16-3.41-.53-6.42.21-8.26,2a6,6,0,0,0-1.67,5.3,12.53,12.53,0,0,0,3.09,6.14c2,2.38,3.72,5.83,1.9,7.71s-7.31,1.11-14.85,0l-.49-.07c-5-.76-9.87-1.46-15.52-1.78,0-.62-.07-1.22-.1-1.83-.05-.88-.1-1.76-.14-2.61-.06-1.27-.11-2.63-.15-4-.3-9.08-.67-20.38-6-26.6-2.56-3-6.86-2.21-9.62,0a6.64,6.64,0,0,1-4.54,1.68c-3.79-.2-7.08-4.93-7.35-10.55-.16-3.51.84-6.77,2.62-8.51A4.13,4.13,0,0,1,271,76a8,8,0,0,1,4.6,2.32c1.78,1.59,4.77,3.15,7.1,2.88A3,3,0,0,0,285,79.9c4.38-6.36,1.46-18.07-.74-26.7l-1.69-.47.05.2c2.08,8.31,4.92,19.7,1,25.68a1.7,1.7,0,0,1-1.26.73c-1.51.2-4-.84-5.73-2.42A9.67,9.67,0,0,0,271,74.13a5.59,5.59,0,0,0-4.34,1.7c-2.18,2.11-3.36,5.83-3.18,10,.29,6.6,4.37,12.17,9.1,12.41a8.23,8.23,0,0,0,5.66-2c1.74-1.42,5.25-2.75,7.29-.32,4.79,5.71,5.1,16.44,5.34,25.07,0,1.52.08,3,.15,4.32,0,.89.09,1.81.14,2.74l.09,1.63-6.23-.34-3.07-.17c-13-.73-21.76-.93-25.09,2.67-2.92,3.15-1.36,7.72.85,10.67a8.91,8.91,0,0,1,2,5.25,6.3,6.3,0,0,1-2,4.51,11.67,11.67,0,0,1-8.18,3.07h0a11.64,11.64,0,0,1-8.17-3.07,6.3,6.3,0,0,1-2-4.5,8.87,8.87,0,0,1,2-5.25c2.21-3,3.77-7.53.86-10.67-3.37-3.63-10.77-3.44-22.56-2.81l-2.58.13q-3.16.18-6.71.35v-.14c.11-1.52.21-3,.33-4.39.15-1.62.35-3.33.56-5.14,1-8.1,2-17.28-1.54-22.62a2.92,2.92,0,0,0-2.11-1.25c-2.35-.34-5.68,1.21-7.75,2.93a10.14,10.14,0,0,1-5.07,2.5,4.13,4.13,0,0,1-3.65-1.29c-1.45-1.56-2-4.3-1.36-7.33,1-5.32,5-10.33,8.6-10.94a5,5,0,0,1,4,1.17c2.18,1.78,6.48,2.82,9.17-.45,5.58-6.77,6.68-18.56,7.64-29l.13-1.33-1.62.41-.11,1.11c-1,10-2,21.24-7.17,27.59a3.8,3.8,0,0,1-2.65,1.44,6.07,6.07,0,0,1-4.2-1.33A6.23,6.23,0,0,0,198.59,80c-4.48.77-9.16,6.49-10.41,12.76-.72,3.56-.1,6.72,1.69,8.66a5.66,5.66,0,0,0,5,1.74,11.94,11.94,0,0,0,6.1-2.94c2.49-2,5.77-3.57,7.53-1.71,2.53,2.67,1.86,10.69.83,22.83l-.29,3.58c-.13,1.49-.25,3-.37,4.64-3.68.19-7.1.45-10.25.7l-2.29.18c-10.62.86-18.3,1.47-20.53-.86-1.79-1.86-.07-5.31,2-7.69a12.67,12.67,0,0,0,3.11-6.15,5.92,5.92,0,0,0-1.62-5.29c-1.82-1.8-4.8-2.52-8.18-2-6.16,1-12,5.6-13,10.22a6.7,6.7,0,0,0,1.12,5.4c1.32,1.88,2,4.9-.45,7.18-3,2.8-9.94,3.6-19.54,4.69l-2.52.29c-1.81.21-3.78.45-5.83.72-.16.52-.34,1.05-.49,1.58l0,.11.16,0c2.14-.27,4.19-.51,6.07-.72l2.59-.29,4.92-.55c8.09-1,13-2,15.86-4.67a7.08,7.08,0,0,0,.84-9.47,5.35,5.35,0,0,1-.92-4.27c.8-3.74,5.88-7.6,11.1-8.44,2.92-.47,5.44.11,6.93,1.59a4.38,4.38,0,0,1,1.2,3.93,10.76,10.76,0,0,1-2.66,5.12c-2.65,3.11-4.57,7.38-2,10,2.77,2.88,10.91,2.24,22.16,1.35l2.06-.16c2.91-.22,6.37-.48,10.07-.67-.14,1.12-.22,1.81-.37,3-.14,1-.31,2-.49,3.15-1.38,8.75-3.28,20.74,1.86,26.53,2.65,3,7.84,1.31,10.69-.83a8.92,8.92,0,0,1,5.26-2h0a6.25,6.25,0,0,1,4.44,2,12.46,12.46,0,0,1,0,16.39,6.3,6.3,0,0,1-4.47,2h0a8.86,8.86,0,0,1-5.25-2c-2.81-2.11-8.16-3.82-10.7-.8-5.8,6.9-3.83,20.85-2.4,31,.18,1.29.36,2.53.51,3.71-4.37-.18-8.46-.23-12.09-.26l-2.06,0c-9.38-.11-16.23-.39-18.92-3-2.37-2.3-1.41-5.5.14-7.54a8.65,8.65,0,0,0,1.92-5.83c-.32-4.85-5.93-9-12.51-9.22-4-.14-7.66,1.1-9.75,3.31a5.88,5.88,0,0,0-1.73,4.68,10.21,10.21,0,0,0,2.9,5.8c2.15,2.42,3.56,5.62,1.84,7.32-2.17,2.14-9.32,1-17.61-.4l-.72-.11c-2.69-.45-5.74-.95-8.94-1.43l-.16,0c.16.57.32,1.13.49,1.7,3.08.48,6,1,8.64,1.41l.69.12c3.3.55,6.24,1,8.81,1.34,5.64.66,8.6.28,10.2-1.31,2.46-2.44.84-6.6-1.87-9.65a8.45,8.45,0,0,1-2.42-4.76,4.41,4.41,0,0,1,1.32-3.51c1.74-1.84,4.86-2.86,8.34-2.73,5.6.21,10.37,3.55,10.63,7.45a7,7,0,0,1-1.6,4.71c-2,2.57-3.09,6.7.16,9.85s9.86,3.5,20.29,3.64l2,0c3.9.05,8.32.1,13.05.32.21,1.78.51,3.82.83,6,1.43,9.56,3.2,21.46-.84,27.15a1.85,1.85,0,0,1-1.33.73c-1.77.23-4.44-1.08-6.16-2.49a11.92,11.92,0,0,0-6.09-2.95,5.62,5.62,0,0,0-5,1.73c-1.79,1.94-2.41,5.1-1.69,8.66,1.27,6.27,5.94,12,10.42,12.77a6.2,6.2,0,0,0,5.12-1.44,6.12,6.12,0,0,1,4.33-1.3,3.51,3.51,0,0,1,2.49,1.41c3.9,5.22,4.87,13.38,5.81,21.27.24,2,.46,3.85.73,5.68l.15,1,1.64.43-.2-1.38c-.25-1.77-.46-3.7-.67-5.74-.83-8-1.78-17.07-6.33-22.44-2.89-3.41-7.15-2.09-9.15-.45a4.87,4.87,0,0,1-4,1.16c-3.61-.62-7.55-5.63-8.61-10.95-.6-3-.1-5.77,1.36-7.33a4.08,4.08,0,0,1,3.63-1.27,10,10,0,0,1,5.06,2.5c2,1.69,5.19,3.26,7.57,3a3.13,3.13,0,0,0,2.27-1.27c4.5-6.15,2.7-18.56,1.25-28.53-.3-2.09-.58-4.06-.78-5.8l6.41.34,2,.11c2.57.14,5.3.28,7.82.35,7.85.21,13.62-.24,16.25-3.07,2.92-3.15,1.37-7.72-.85-10.67a8.91,8.91,0,0,1-2-5.25,6.3,6.3,0,0,1,2-4.51,12.45,12.45,0,0,1,16.37,0,6.3,6.3,0,0,1,2,4.5,8.92,8.92,0,0,1-2,5.26c-2.22,3-3.78,7.52-.86,10.67,3.23,3.47,10.74,3.32,22.72,2.64l2.29-.13c2.51-.14,5.22-.3,8.06-.44-.38,3-.79,5.8-1.13,8.16l-.27,1.78c-1.71,11.47-2.95,19.76,0,22.83,2.53,2.67,6.75.88,9.85-1.68a10.09,10.09,0,0,1,5.07-2.48,4.22,4.22,0,0,1,3.69,1.32c1.47,1.57,2,4.33,1.43,7.37-1,5.33-4.93,10.32-8.56,10.91a5,5,0,0,1-4.07-1.2c-2.47-2-6.28-2.67-9.2.38s-3.35,9.21-4.13,17.94c-.09.94-.17,1.91-.27,2.91-.23,2.45-.59,6.17-1.13,10.19l0,.15c.55-.14,1.1-.3,1.64-.45.42-3,.79-6.22,1.16-10q.14-1.48.27-2.88c.74-8,1.33-14.24,3.58-16.59s5.14-1.53,6.91-.09a6.34,6.34,0,0,0,5.17,1.49c4.5-.74,9.16-6.46,10.37-12.75.69-3.56.05-6.73-1.77-8.69a5.73,5.73,0,0,0-5-1.78,11.94,11.94,0,0,0-6.11,2.92c-2.48,2-5.77,3.56-7.55,1.68-2.36-2.47-1.17-10.3.47-21.13l.3-2c.34-2.26.78-5.25,1.18-8.37,2.4-.11,4.71-.2,6.87-.28l2.52-.1c2.47-.09,5.1-.21,7.54-.37,7.33-.49,12.82-1.4,15.74-4.24,3.24-3.15,2.08-7.3.1-9.9a7.15,7.15,0,0,1-1.63-4.74c.24-3.91,5-7.24,10.6-7.43,3.45-.12,6.59.92,8.36,2.77a4.55,4.55,0,0,1,1.36,3.54,8.48,8.48,0,0,1-2.4,4.79c-2.69,3-4.29,7.22-1.81,9.68,3,2.92,10.54,2,22.69.27l2.68-.38,4.83-.7c.17-.56.32-1.13.48-1.7Zm-80-5.66.13,2.36c.17,3.15.33,6.57.38,10.3-2.87.14-5.61.29-8.14.44l-2.35.13c-11.5.63-18.67.81-21.36-2.08-2.13-2.3-.8-5.89,1-8.27a10.74,10.74,0,0,0,2.4-6.37,8,8,0,0,0-2.5-5.8,14.23,14.23,0,0,0-19,0,8,8,0,0,0-2.5,5.8,10.74,10.74,0,0,0,2.4,6.37c1.78,2.38,3.11,6,1,8.27-2.76,3-11.53,2.75-22.72,2.16l-2.54-.13c-2.22-.12-4.5-.25-6.88-.36-.19-1.7-.43-3.54-.7-5.49-1.31-9.77-2.94-21.93,2.08-28.06,1.69-2.06,5.94-.72,8.24,1a10.71,10.71,0,0,0,6.37,2.39h0a8.12,8.12,0,0,0,5.75-2.51,14.31,14.31,0,0,0,0-19.05,8.19,8.19,0,0,0-5.79-2.5A10.74,10.74,0,0,0,219,161.8a9.83,9.83,0,0,1-6.41,2,2.64,2.64,0,0,1-1.81-1c-4.24-5.71-2.61-16.73-1.3-25.58.14-.93.27-1.83.39-2.71.16-1.31.25-2,.4-3.23h.07v0L217,131l2.75-.15c11.35-.58,18.44-.72,21.2,2.25,2.13,2.3.8,5.89-1,8.27a10.83,10.83,0,0,0-2.4,6.37,8,8,0,0,0,2.5,5.81,13.31,13.31,0,0,0,9.49,3.63h0a13.35,13.35,0,0,0,9.5-3.63,8.09,8.09,0,0,0,2.5-5.82,10.78,10.78,0,0,0-2.4-6.37c-1.78-2.37-3.11-6-1-8.26,2.79-3,12-2.76,23.74-2.12l2.71.15c2.15.12,4.36.25,6.63.36-.06,4.62-.35,9-.62,12.69l-.14,1.81c-.71,9.41-1.23,16.2,2,19.16s7.71,1.5,10.64-.64a8.36,8.36,0,0,1,5.2-1.84c4.18.07,7.73,4.56,7.74,9.81s-3.52,9.73-7.71,9.79a8.37,8.37,0,0,1-5.2-1.85c-2.95-2.14-7.5-3.6-10.65-.67C289.13,182.83,289.54,190.37,290.1,200.8Z"
                    style={{
                      fill: "rgb(255, 255, 255)",
                      transformOrigin: "250.260033px 173.165016px",
                    }}
                    id="el9uqzcvsm8v"
                    className="animable"
                  />
                  <path
                    d="M131.43,181.86a13,13,0,0,0,6.48,2.19h.29a8.39,8.39,0,0,0,5.89-2.42,11.58,11.58,0,0,0,0-15.95,8.45,8.45,0,0,0-6.2-2.43,12.78,12.78,0,0,0-6.46,2.17,10.29,10.29,0,0,1-6,1.77h0c0,.63-.05,1.26-.07,1.89a12.57,12.57,0,0,0,7.24-2.11,10.46,10.46,0,0,1,5.28-1.79,6.39,6.39,0,0,1,4.7,1.88,9.71,9.71,0,0,1,0,13.19,6.31,6.31,0,0,1-4.69,1.87,10.54,10.54,0,0,1-5.28-1.81,12.82,12.82,0,0,0-7.27-2.14c0,.63.07,1.26.1,1.89h0A10.41,10.41,0,0,1,131.43,181.86Z"
                    style={{
                      fill: "rgb(255, 255, 255)",
                      transformOrigin: "136.306888px 173.647909px",
                    }}
                    id="el1mffrg4i4ro"
                    className="animable"
                  />
                </g>
              </g>
              <g
                id="freepik--Plants--inject-2"
                style={{ transformOrigin: "250.30407px 378.65004px" }}
                className="animable"
              >
                <g
                  id="freepik--plants--inject-2"
                  style={{ transformOrigin: "313.157425px 378.65004px" }}
                  className="animable"
                >
                  <path
                    d="M302.8,407.18,295.56,403s-4.3-17.9-2.59-34c2.42-22.64,17.32-31.16,23-29.21s7.31,8.54-2.07,22C308.36,369.77,301.56,386.35,302.8,407.18Z"
                    style={{
                      fill: "#3D50FA",
                      transformOrigin: "306.575889px 373.350254px",
                    }}
                    id="elsa4493zkcbf"
                    className="animable"
                  />
                  <g id="elkz59dh8mdjd">
                    <g
                      style={{
                        opacity: "0.65",
                        transformOrigin: "306.575889px 373.350254px",
                      }}
                      className="animable"
                      id="elpeg9pwvddvd"
                    >
                      <path
                        d="M302.8,407.18,295.56,403s-4.3-17.9-2.59-34c2.42-22.64,17.32-31.16,23-29.21s7.31,8.54-2.07,22C308.36,369.77,301.56,386.35,302.8,407.18Z"
                        style={{
                          fill: "rgb(255, 255, 255)",
                          transformOrigin: "306.575889px 373.350254px",
                        }}
                        id="elivo8b4bsh3"
                        className="animable"
                      />
                    </g>
                  </g>
                  <path
                    d="M299.8,398.39h.07a.5.5,0,0,0,.4-.58c-4-20.89,3.33-44.36,12.36-54.12a.5.5,0,0,0,0-.71.49.49,0,0,0-.71,0c-9.2,9.94-16.64,33.79-12.61,55A.5.5,0,0,0,299.8,398.39Z"
                    style={{
                      fill: "rgb(255, 255, 255)",
                      transformOrigin: "305.483154px 370.608917px",
                    }}
                    id="elqhxvi8dp69"
                    className="animable"
                  />
                  <path
                    d="M321,417.7c1.08.55,4-1.91,4.75-2.51a10,10,0,0,0,3.15-4,9.44,9.44,0,0,0,.55-5.68,24,24,0,0,0-.87-3c-.33-1-.66-1.91-1-2.87a7.2,7.2,0,0,1-.58-2.91c.16-2,1.85-3.49,3.4-4.78,1.71-1.42,3.47-3.27,3.34-5.67a8.41,8.41,0,0,0-2.36-4.91c-1.22-1.4-2.65-2.61-3.76-4.09a6,6,0,0,1-1.4-3.67,6.24,6.24,0,0,1,.7-2.37,33.6,33.6,0,0,0,2.31-4.8c.5-1.7.31-3.79-1.06-4.92a5.5,5.5,0,0,0-4.18-.82,9.62,9.62,0,0,0-3.77,1.54c-3.7,2.31-5.65,6.93-9.6,8.77a41.94,41.94,0,0,1-4.83,1.44,6,6,0,0,0-3.9,3c-1.33,3,1.6,6.55.72,9.75-.78,2.83-3.43,4-4.82,6.62a5.94,5.94,0,0,0-.53,3.67,17.43,17.43,0,0,0,1.85,6.08,53.18,53.18,0,0,0,3.65,5.62Z"
                    style={{
                      fill: "#3D50FA",
                      transformOrigin: "315.458527px 389.182787px",
                    }}
                    id="el9zhjhg5ik8a"
                    className="animable"
                  />
                  <g id="el0ymvw6c1i2nh">
                    <g
                      style={{
                        opacity: "0.3",
                        transformOrigin: "315.458527px 389.182787px",
                      }}
                      className="animable"
                      id="elhupsepxc73g"
                    >
                      <path
                        d="M321,417.7c1.08.55,4-1.91,4.75-2.51a10,10,0,0,0,3.15-4,9.44,9.44,0,0,0,.55-5.68,24,24,0,0,0-.87-3c-.33-1-.66-1.91-1-2.87a7.2,7.2,0,0,1-.58-2.91c.16-2,1.85-3.49,3.4-4.78,1.71-1.42,3.47-3.27,3.34-5.67a8.41,8.41,0,0,0-2.36-4.91c-1.22-1.4-2.65-2.61-3.76-4.09a6,6,0,0,1-1.4-3.67,6.24,6.24,0,0,1,.7-2.37,33.6,33.6,0,0,0,2.31-4.8c.5-1.7.31-3.79-1.06-4.92a5.5,5.5,0,0,0-4.18-.82,9.62,9.62,0,0,0-3.77,1.54c-3.7,2.31-5.65,6.93-9.6,8.77a41.94,41.94,0,0,1-4.83,1.44,6,6,0,0,0-3.9,3c-1.33,3,1.6,6.55.72,9.75-.78,2.83-3.43,4-4.82,6.62a5.94,5.94,0,0,0-.53,3.67,17.43,17.43,0,0,0,1.85,6.08,53.18,53.18,0,0,0,3.65,5.62Z"
                        style={{
                          fill: "rgb(255, 255, 255)",
                          transformOrigin: "315.458527px 389.182787px",
                        }}
                        id="el713lb1osd6q"
                        className="animable"
                      />
                    </g>
                  </g>
                  <path
                    d="M310.54,412.24h0a.49.49,0,0,0,.44-.52c-1.73-18.78,6.09-40,12.23-46.37a.47.47,0,0,0,0-.67.47.47,0,0,0-.67,0c-6.27,6.49-14.25,28.07-12.5,47.12A.49.49,0,0,0,310.54,412.24Z"
                    style={{
                      fill: "rgb(255, 255, 255)",
                      transformOrigin: "316.572649px 388.389898px",
                    }}
                    id="elghvm0ebsyvo"
                    className="animable"
                  />
                  <path
                    d="M312.41,389.08l.14,0a64.26,64.26,0,0,1,13.54-2.89.47.47,0,0,0,.43-.52.46.46,0,0,0-.51-.43,65,65,0,0,0-13.79,3,.48.48,0,0,0,.19.92Z"
                    style={{
                      fill: "rgb(255, 255, 255)",
                      transformOrigin: "319.227312px 387.19858px",
                    }}
                    id="elm4ssr17vpn"
                    className="animable"
                  />
                </g>
                <g
                  id="freepik--plants--inject-2"
                  style={{ transformOrigin: "187.391609px 374.988663px" }}
                  className="animable"
                >
                  <path
                    d="M180.22,359.92c2.15,4.45,7.15,10.74,10.51,17.19a48.79,48.79,0,0,1,4,10.32h0a71.09,71.09,0,0,1,2,19.69l2.47-1.79,4-2.9,1.15-.83,2-1.49a100.67,100.67,0,0,0,1.19-26.48c-1.69-16-10.44-31.73-19.69-33.31C179.24,338.86,174.85,348.83,180.22,359.92Z"
                    style={{
                      fill: "#3D50FA",
                      transformOrigin: "192.897221px 373.648674px",
                    }}
                    id="elw5hu6n0t9yq"
                    className="animable"
                  />
                  <g id="elfe3pduyfh1b">
                    <path
                      d="M180.22,359.92c2.15,4.45,7.15,10.74,10.51,17.19a48.79,48.79,0,0,1,4,10.32h0a71.09,71.09,0,0,1,2,19.69l2.47-1.79,4-2.9,1.15-.83,2-1.49a100.67,100.67,0,0,0,1.19-26.48c-1.69-16-10.44-31.73-19.69-33.31C179.24,338.86,174.85,348.83,180.22,359.92Z"
                      style={{
                        fill: "rgb(255, 255, 255)",
                        opacity: "0.65",
                        transformOrigin: "192.897221px 373.648674px",
                      }}
                      className="animable"
                      id="ellux6unryl2n"
                    />
                  </g>
                  <path
                    d="M185.54,346.74c10,9.15,19,31.16,17.62,55.7l1.15-.83c1.14-24.55-8-46.52-18-55.71a.56.56,0,0,0-.75.84Z"
                    style={{
                      fill: "rgb(255, 255, 255)",
                      transformOrigin: "194.889201px 374.098499px",
                    }}
                    id="elv1jfzydi19e"
                    className="animable"
                  />
                  <path
                    d="M167.16,378.66c1.3,5.61,11.59,11.86,19.69,21.14a29.11,29.11,0,0,1,6.17,10l1.45-1.08,1.05-.76,1.15-.83,2.47-1.79a50.51,50.51,0,0,0-4.46-17.9h0c-5-10.74-9.21-15.11-15.05-17.32C170.21,366.54,165.6,371.92,167.16,378.66Z"
                    style={{
                      fill: "#3D50FA",
                      transformOrigin: "183.000685px 389.388624px",
                    }}
                    id="elubj0scp64j"
                    className="animable"
                  />
                  <g id="eli30mqzd66ze">
                    <path
                      d="M167.16,378.66c1.3,5.61,11.59,11.86,19.69,21.14a29.11,29.11,0,0,1,6.17,10l1.45-1.08,1.05-.76,1.15-.83,2.47-1.79a50.51,50.51,0,0,0-4.46-17.9h0c-5-10.74-9.21-15.11-15.05-17.32C170.21,366.54,165.6,371.92,167.16,378.66Z"
                      style={{
                        fill: "rgb(255, 255, 255)",
                        opacity: "0.3",
                        transformOrigin: "183.000685px 389.388624px",
                      }}
                      className="animable"
                      id="elu2vc9yz2cp"
                    />
                  </g>
                  <path
                    d="M177.26,378.25a.56.56,0,1,1,.52-1c6.35,3.35,16.23,12.89,19.53,29.41l-.64.46-.4.29C193.07,390.89,183.07,381.31,177.26,378.25Z"
                    style={{
                      fill: "rgb(255, 255, 255)",
                      transformOrigin: "187.132092px 392.297643px",
                    }}
                    id="elbbr6foi4ari"
                    className="animable"
                  />
                </g>
              </g>
              <g
                id="freepik--Shadows--inject-2"
                style={{ transformOrigin: "249.43998px 427.524994px" }}
                className="animable"
              >
                <ellipse
                  id="freepik--Shadow--inject-2"
                  cx="252.34"
                  cy="422.72"
                  rx="69.1"
                  ry="39.9"
                  style={{
                    fill: "rgb(224, 224, 224)",
                    transformOrigin: "252.34px 422.72px",
                  }}
                  className="animable"
                />
                <ellipse
                  id="freepik--shadow--inject-2"
                  cx="406.43"
                  cy="432.33"
                  rx="69.1"
                  ry="39.9"
                  style={{
                    fill: "rgb(224, 224, 224)",
                    transformOrigin: "406.43px 432.33px",
                  }}
                  className="animable"
                />
                <ellipse
                  id="freepik--shadow--inject-2"
                  cx="92.45"
                  cy="432.33"
                  rx="69.1"
                  ry="39.9"
                  style={{
                    fill: "rgb(224, 224, 224)",
                    transformOrigin: "92.45px 432.33px",
                  }}
                  className="animable"
                />
              </g>
              <g
                id="freepik--character-3--inject-2"
                style={{ transformOrigin: "408.328888px 277.24987px" }}
                className="animable"
              >
                <g
                  id="freepik--Chartacter--inject-2"
                  style={{ transformOrigin: "408.328888px 277.24987px" }}
                  className="animable"
                >
                  <g
                    id="freepik--Bottom--inject-2"
                    style={{ transformOrigin: "405.011932px 346.187225px" }}
                    className="animable"
                  >
                    <path
                      d="M431.09,440.63c.39,5.36,1.27,8.9,3.22,12s5.5,3.86,9.17,3.08a13.83,13.83,0,0,0,10.08-8.4c1.29-3.55.72-7.81-.18-12.77Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "442.702223px 445.267221px",
                      }}
                      id="eli9wns0vxj5k"
                      className="animable"
                    />
                    <path
                      d="M445.86,401.33c1.5.1,2,7.29,3,14.49,1,7.72,3.46,12,4.3,17.2,1.17,7.21.72,10.47-1.76,14.88s-12.25,9.09-16.76,2.89c-3.68-5.06-3.91-10.73-3.68-18a183.18,183.18,0,0,0,.07-18.4c-.37-5.42-.82-10.67.48-11.29.11.79.22,1.8.34,2.58.09.6.28,3.53,1.12,3.55a11.59,11.59,0,0,0,0-2,2.45,2.45,0,0,1,.38-1.76,2.88,2.88,0,0,1,1.65-.76,41.74,41.74,0,0,1,4.45-.75,20.88,20.88,0,0,1,2.24-.13,12.14,12.14,0,0,1,2.76,0,1.33,1.33,0,0,1,.82.72,2.31,2.31,0,0,1,.09.83,6.15,6.15,0,0,0,.21,1.48c.06.21.21.47.42.42s.24-.27.24-.44c0-.88-.13-1.51-.18-2.53,0-.47-.11-1.11-.13-1.58S445.9,401.8,445.86,401.33Z"
                      style={{
                        fill: "rgb(55, 71, 79)",
                        transformOrigin: "442.209661px 427.554955px",
                      }}
                      id="el6cxrdltrhq6"
                      className="animable"
                    />
                    <g id="elj6dewtywc0q">
                      <path
                        d="M447.71,434.89a.53.53,0,0,1-.46.58.52.52,0,0,1-.58-.46.51.51,0,0,1,.46-.58A.53.53,0,0,1,447.71,434.89Z"
                        style={{
                          opacity: "0.15",
                          transformOrigin: "447.188846px 434.950498px",
                        }}
                        className="animable"
                        id="el82cj4npr6l"
                      />
                    </g>
                    <g id="elyg2q3qtglv">
                      <path
                        d="M447.14,429.9a.53.53,0,1,1-.59-.46A.54.54,0,0,1,447.14,429.9Z"
                        style={{
                          opacity: "0.15",
                          transformOrigin: "446.614172px 429.966604px",
                        }}
                        className="animable"
                        id="elc2k9u5gn7pk"
                      />
                    </g>
                    <g id="el895wenwarh3">
                      <path
                        d="M446.59,425.19a.51.51,0,0,1-.46.58.52.52,0,0,1-.58-.46.54.54,0,0,1,.46-.58A.53.53,0,0,1,446.59,425.19Z"
                        style={{
                          opacity: "0.15",
                          transformOrigin: "446.071591px 425.250518px",
                        }}
                        className="animable"
                        id="eljzcy7lncuoi"
                      />
                    </g>
                    <g id="eliqp0ov7utp">
                      <path
                        d="M446.06,420.55a.52.52,0,0,1-.46.58.51.51,0,0,1-.58-.46.52.52,0,1,1,1-.12Z"
                        style={{
                          opacity: "0.15",
                          transformOrigin: "445.524187px 420.548176px",
                        }}
                        className="animable"
                        id="elcc8xx5symfs"
                      />
                    </g>
                    <g id="el5agkpct01ms">
                      <path
                        d="M435.39,421.58a.53.53,0,0,1-.46.58.52.52,0,0,1-.58-.46.51.51,0,0,1,.46-.58A.53.53,0,0,1,435.39,421.58Z"
                        style={{
                          opacity: "0.15",
                          transformOrigin: "434.868875px 421.640443px",
                        }}
                        className="animable"
                        id="elj0o3z96r54"
                      />
                    </g>
                    <g id="el1asnufdx1x3">
                      <path
                        d="M435.92,426.25a.51.51,0,0,1-.46.58.52.52,0,0,1-.58-.46.54.54,0,0,1,.46-.58A.53.53,0,0,1,435.92,426.25Z"
                        style={{
                          opacity: "0.15",
                          transformOrigin: "435.401612px 426.310488px",
                        }}
                        className="animable"
                        id="el0bm4jvhh509"
                      />
                    </g>
                    <g id="elggyh1zvdik5">
                      <path
                        d="M436.47,431a.53.53,0,0,1-1.05.12.53.53,0,0,1,1.05-.12Z"
                        style={{
                          opacity: "0.15",
                          transformOrigin: "435.944994px 431.059987px",
                        }}
                        className="animable"
                        id="elcyjhr8ei9yn"
                      />
                    </g>
                    <g id="elfpub1d2rznq">
                      <path
                        d="M437,436a.52.52,0,0,1-.46.58.51.51,0,0,1-.58-.46.52.52,0,0,1,1-.12Z"
                        style={{
                          opacity: "0.15",
                          transformOrigin: "436.481927px 436.126907px",
                        }}
                        className="animable"
                        id="el83gwl4pvo0d"
                      />
                    </g>
                    <g id="elb66wf00inru">
                      <polygon
                        points="441.48 438.25 436.96 403.44 438.89 403.38 441.48 438.25"
                        style={{
                          opacity: "0.15",
                          transformOrigin: "439.220001px 420.815002px",
                        }}
                        className="animable"
                        id="elvcieesnjm2"
                      />
                    </g>
                    <path
                      d="M447.21,435.22h-.08c-3.47-.72-8.2-.16-10.5,1a.26.26,0,0,1-.35-.12.27.27,0,0,1,.11-.36c2.44-1.23,7.22-1.8,10.85-1.05a.27.27,0,0,1,.21.31A.29.29,0,0,1,447.21,435.22Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "441.852036px 435.300292px",
                      }}
                      id="elm9v0xqmbclm"
                      className="animable"
                    />
                    <path
                      d="M446.64,430.23l-.14,0c-2.65-1.21-7.81-.3-10.44,1a.27.27,0,0,1-.36-.12.28.28,0,0,1,.12-.36c2.74-1.38,8.1-2.31,10.9-1a.26.26,0,0,1,.14.35A.28.28,0,0,1,446.64,430.23Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "441.279484px 430.189083px",
                      }}
                      id="elhmeuk0nmbn"
                      className="animable"
                    />
                    <path
                      d="M446.1,425.52a.34.34,0,0,1-.14,0c-2.66-1.22-7.81-.31-10.44,1a.27.27,0,0,1-.36-.12.26.26,0,0,1,.12-.35c2.73-1.39,8.1-2.32,10.9-1a.25.25,0,0,1,.13.35A.26.26,0,0,1,446.1,425.52Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "440.735939px 425.480669px",
                      }}
                      id="el19b4oadbxsei"
                      className="animable"
                    />
                    <path
                      d="M445.57,420.88a.32.32,0,0,1-.14,0c-2.66-1.21-7.82-.3-10.44,1a.27.27,0,0,1-.24-.48c2.73-1.38,8.1-2.31,10.9-1a.26.26,0,0,1,.13.35A.26.26,0,0,1,445.57,420.88Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "440.216081px 420.833455px",
                      }}
                      id="el3w5lxtfmisc"
                      className="animable"
                    />
                    <polygon
                      points="397.99 419.18 391.61 417 393.54 412.67 397.53 416.16 397.99 419.18"
                      id="eldibtx2st77b"
                      style={{ transformOrigin: "394.799988px 415.925003px" }}
                      className="animable"
                    />
                    <path
                      d="M404.16,407.59s.38,4.1.47,5.4-5.29,5.48-6.64,6.19l-.46-3c-1.14,1.22-1.8,2.74-3,5-1,1.87-2.25,5.41-5.09,7.88-4.23,3.66-10.93,5.66-17.81,6.12s-10.88-1.1-12.88-2.54-2.68-3.16-2.25-4.92S404.16,407.59,404.16,407.59Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "380.503839px 421.426018px",
                      }}
                      id="elq46s3mmnirp"
                      className="animable"
                    />
                    <path
                      d="M385.3,394.15l-.16-2.38c-1.27,0-1.32,3.45-3.08,6.54a61.48,61.48,0,0,1-9.31,12.7c-6.79,6.58-12.9,10.77-15.93,13.73-4.05,4,3.46,9.83,14.69,8.86,5.57-.49,15.4-3.6,18.08-7s4.24-8.58,6.4-11.05,6.87-5,8.17-8c.71-1.62.19-5.33-.36-8.49-.51-2.89-.73-7.35-2.36-6.94l-.07,1.5c-.63,1.29-2.12,3.44-6.6,4.34C392.54,398.45,385.84,398.86,385.3,394.15Z"
                      style={{
                        fill: "rgb(55, 71, 79)",
                        transformOrigin: "380.107172px 412.738569px",
                      }}
                      id="el2ve2d6f4j2y"
                      className="animable"
                    />
                    <g id="eld4buvb3vmck">
                      <path
                        d="M391.16,398.23c-2.15-.12-4.48-.76-5.44-2.67l0-.06a5.5,5.5,0,0,1-1.31,4.63c-1.94,2.41-14.13,19.39-14.13,19.39s11.4-14,13.59-16.69c3.23-3.92,4.28-4.39,7.35-4.6Z"
                        style={{
                          opacity: "0.15",
                          transformOrigin: "380.75px 407.51001px",
                        }}
                        className="animable"
                        id="elyj6uvg1r2pl"
                      />
                    </g>
                    <g id="ely7n8m4sdklp">
                      <path
                        d="M388.49,402.71a.69.69,0,0,0,1.37-.19.69.69,0,0,0-1.37.19Z"
                        style={{
                          opacity: "0.15",
                          transformOrigin: "389.175043px 402.614996px",
                        }}
                        className="animable"
                        id="el1beean8mg08"
                      />
                    </g>
                    <g id="el4f2vip3d8en">
                      <path
                        d="M385.29,406.48a.69.69,0,1,0,1.36-.19.69.69,0,0,0-1.36.19Z"
                        style={{
                          opacity: "0.15",
                          transformOrigin: "385.979501px 406.452936px",
                        }}
                        className="animable"
                        id="elx9g0h9c5n9"
                      />
                    </g>
                    <g id="elug05of1lzn">
                      <path
                        d="M382.08,410.25a.7.7,0,0,0,.78.59.69.69,0,0,0-.19-1.36A.69.69,0,0,0,382.08,410.25Z"
                        style={{
                          opacity: "0.15",
                          transformOrigin: "382.730881px 410.162515px",
                        }}
                        className="animable"
                        id="elzlnuqqwfzzg"
                      />
                    </g>
                    <g id="elwm2wkn3cgq">
                      <path
                        d="M378.88,414a.69.69,0,1,0,.58-.78A.68.68,0,0,0,378.88,414Z"
                        style={{
                          opacity: "0.15",
                          transformOrigin: "379.562349px 413.902242px",
                        }}
                        className="animable"
                        id="eld7ndwo9qi1m"
                      />
                    </g>
                    <g id="elfmugffos5ci">
                      <path
                        d="M375.67,417.8a.69.69,0,0,0,.78.58.69.69,0,0,0-.19-1.36A.69.69,0,0,0,375.67,417.8Z"
                        style={{
                          opacity: "0.15",
                          transformOrigin: "376.320221px 417.703251px",
                        }}
                        className="animable"
                        id="elvjr4ip526hn"
                      />
                    </g>
                    <path
                      d="M389.2,402.89a.31.31,0,0,0,.18-.09.28.28,0,0,0,0-.39c-.14-.13-3.55-3.22-7.87-2.83h0a.28.28,0,0,0-.25.3.29.29,0,0,0,.3.25c4.08-.36,7.41,2.66,7.45,2.69A.25.25,0,0,0,389.2,402.89Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "385.359096px 401.218253px",
                      }}
                      id="el038kzpqc02bl"
                      className="animable"
                    />
                    <path
                      d="M386,406.65a.32.32,0,0,0,.17-.09.27.27,0,0,0,0-.39c-.14-.13-3.54-3.22-7.87-2.84h0a.29.29,0,0,0-.25.31.29.29,0,0,0,.3.25c4.08-.37,7.42,2.66,7.45,2.69A.29.29,0,0,0,386,406.65Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "382.151176px 404.97392px",
                      }}
                      id="elgmq9d6mgst"
                      className="animable"
                    />
                    <path
                      d="M382.79,410.43a.25.25,0,0,0,.18-.08.29.29,0,0,0,0-.4c-.14-.13-3.55-3.22-7.87-2.83h0a.28.28,0,0,0,.05.55c4.07-.36,7.41,2.66,7.45,2.69A.25.25,0,0,0,382.79,410.43Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "378.970615px 408.758246px",
                      }}
                      id="el5emkpvcy0nd"
                      className="animable"
                    />
                    <path
                      d="M379.59,414.2a.25.25,0,0,0,.17-.08.27.27,0,0,0,0-.39c-.15-.14-3.55-3.23-7.87-2.84h0a.26.26,0,0,0-.24.3.27.27,0,0,0,.3.25c4.07-.36,7.41,2.66,7.44,2.69A.26.26,0,0,0,379.59,414.2Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "375.745073px 412.528442px",
                      }}
                      id="elna7k0rzo7lo"
                      className="animable"
                    />
                    <path
                      d="M376.38,418a.25.25,0,0,0,.18-.08.28.28,0,0,0,0-.39c-.14-.14-3.55-3.23-7.87-2.84h0a.29.29,0,0,0-.24.3.28.28,0,0,0,.3.25c4.07-.36,7.41,2.66,7.44,2.69A.28.28,0,0,0,376.38,418Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "372.544354px 416.328016px",
                      }}
                      id="elqo3ff2h3dzd"
                      className="animable"
                    />
                    <path
                      d="M441.08,238.71c4.47,39.51,5.89,92.38,5.89,92.38.38,3,3.3,11.22,3.43,25.84.15,15.74-.84,54.23-.84,54.23s-10,7.09-20.79,1.74c0,0-8-42.58-11.6-65.41-2.88-18.25-6.79-41.7-6.79-41.7l-3.29,21.83s2,13.56,1.19,25.48c-.62,9.19-3.94,44.1-3.94,44.1s-13,10.63-23.14.44c0,0-3.92-58.41-4.57-69.45-1.28-21.67.28-63.79.05-91.81Z"
                      style={{
                        fill: "rgb(69, 90, 100)",
                        transformOrigin: "413.267601px 325.638809px",
                      }}
                      id="eljtzwyfogr5"
                      className="animable"
                    />
                    <path
                      d="M410.38,305.79l-5.6-37.5s-10.54-1.18-16.09-5.93c0,0,3.7,6.42,13.68,8.62l5.27,34-.55,22.64Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "399.535004px 294.990005px",
                      }}
                      id="el6q491o3ki37"
                      className="animable"
                    />
                  </g>
                  <g
                    id="freepik--Top--inject-2"
                    style={{ transformOrigin: "408.328888px 178.072655px" }}
                    className="animable"
                  >
                    <path
                      d="M384.1,159.1c-7.2,2.27-12.23,5.67-15.52,15.34-3.39,9.94-9.91,27.67-12.18,35,1.4,4,11.63,7.61,15.73,5.72s14.26-30.79,14.26-30.79Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "371.395035px 187.388374px",
                      }}
                      id="elxp19xjl8mv"
                      className="animable"
                    />
                    <path
                      id="freepik--Chest--inject-2"
                      d="M418.69,154.4c4,.68,8.8,1.56,8.8,1.56,10.15,4.12,11.79,4.73,13.93,5.57a157.84,157.84,0,0,1-.83,35,219.42,219.42,0,0,0-.7,24.11c.28,11.49.67,24.81.67,24.81s-9.87,8.58-37.89,7.42c-22-.91-25-7.49-25-7.49s-1.07-34.11-1.05-50.31c0-21.28,4.52-32.61,9.13-36.48l14-3.31Z"
                      style={{
                        fill: "rgb(235, 235, 235)",
                        transformOrigin: "409.321224px 203.688919px",
                      }}
                      className="animable"
                    />
                    <g
                      id="freepik--Head--inject-2"
                      style={{ transformOrigin: "407.934937px 135.46265px" }}
                      className="animable"
                    >
                      <g
                        id="freepik--head--inject-2"
                        style={{
                          transformOrigin: "407.934937px 135.46265px",
                        }}
                        className="animable"
                      >
                        <path
                          d="M426.86,112.42c-1.76-4.4-5.38-4.75-5.38-4.75-1.11-4.7-8-10.19-17.51-9s-14.13,4.1-17.11,9.86-.46,9.77-.46,9.77l27.77-1.78a26.48,26.48,0,0,0,.34,3.95c.67,4.22,4.76,9.16,4.76,9.16l0,5.91.29,8.48a5.43,5.43,0,0,0,3-2.72c.92-2,1.84-5.15,3.18-12.38S428.15,115.66,426.86,112.42Z"
                          style={{
                            fill: "rgb(224, 224, 224)",
                            transformOrigin: "406.42334px 121.262646px",
                          }}
                          id="elarm67kbvn98"
                          className="animable"
                        />
                        <path
                          d="M426.72,137.38c-3,2.2-6-.85-6-.85l.31,16.54s-.06,4.33-5.24,7.6c-7.36,4.65-10.55,7.08-13.55,11.75-2.9-7.37-7.26-12.38-2.73-18.37l-.08-3.89a38.19,38.19,0,0,1-4.09-.21c-3.92-.37-6.54-3.31-7.95-7.44-2.26-6.65-2.59-18.47.21-30.67,4.9-4.2,17.61-4.41,27.08.84,0,7.76,2.35,11.06,2.51,13.87a7.31,7.31,0,0,0,1.8,2.08c1.49,1.15,2.46-2.11,3.58-3.43s4.93-3.24,7.1.75S429.33,135.49,426.72,137.38Z"
                          style={{
                            fill: "rgb(177, 102, 104)",
                            transformOrigin: "408.045856px 140.566166px",
                          }}
                          id="elom9775e9ibi"
                          className="animable"
                        />
                        <path
                          d="M404.65,119.72l4.11,2.23a2.44,2.44,0,0,0-1-3.25A2.27,2.27,0,0,0,404.65,119.72Z"
                          style={{
                            fill: "rgb(38, 50, 56)",
                            transformOrigin: "406.838836px 120.192402px",
                          }}
                          id="el15evmmb44kp"
                          className="animable"
                        />
                        <path
                          d="M388.69,120.76l4.44-1.58a2.27,2.27,0,0,0-2.94-1.48A2.48,2.48,0,0,0,388.69,120.76Z"
                          style={{
                            fill: "rgb(38, 50, 56)",
                            transformOrigin: "390.853722px 119.163237px",
                          }}
                          id="el4x7shzspu4h"
                          className="animable"
                        />
                        <path
                          d="M406.94,124.39a1.91,1.91,0,1,1-1.95-1.86A1.91,1.91,0,0,1,406.94,124.39Z"
                          style={{
                            fill: "rgb(38, 50, 56)",
                            transformOrigin: "405.030611px 124.439573px",
                          }}
                          id="elljdixt8ck4c"
                          className="animable"
                        />
                        <path
                          d="M393.48,124.23a1.91,1.91,0,1,1-3.81.09,1.91,1.91,0,0,1,1.86-1.95A1.74,1.74,0,0,1,393.48,124.23Z"
                          style={{
                            fill: "rgb(38, 50, 56)",
                            transformOrigin: "391.578124px 124.336068px",
                          }}
                          id="el1d6ylbfrxlg"
                          className="animable"
                        />
                        <polygon
                          points="399.48 121.25 398.64 133.46 392.1 131.48 399.48 121.25"
                          style={{
                            fill: "rgb(154, 74, 77)",
                            transformOrigin: "395.790009px 127.355003px",
                          }}
                          id="elombffde5y99"
                          className="animable"
                        />
                        <path
                          d="M411.72,124a1.57,1.57,0,0,0-.49-.31l-.32-.08a4.22,4.22,0,0,0-.7-.1,3.51,3.51,0,0,0-1.44.15c-.11,0-.07.3.05.32a10.27,10.27,0,0,0,1.47.09,4.14,4.14,0,0,1,.6.09,1.68,1.68,0,0,1,.32.09l.14,0,.21.06h.11C411.85,124.42,411.8,124.12,411.72,124Z"
                          style={{
                            fill: "rgb(154, 74, 77)",
                            transformOrigin: "410.249002px 123.912438px",
                          }}
                          id="elugb5n8n202q"
                          className="animable"
                        />
                        <path
                          d="M410.38,125.77a1,1,0,0,0-.21-.19,2.59,2.59,0,0,0-.71-.29,3.29,3.29,0,0,0-.43-.09,2.36,2.36,0,0,0-.46,0c-.16,0-.1.35,0,.38a5.47,5.47,0,0,1,.8.19,2,2,0,0,1,.34.12l.34.16c.1,0,.29.14.35,0A.24.24,0,0,0,410.38,125.77Z"
                          style={{
                            fill: "rgb(154, 74, 77)",
                            transformOrigin: "409.453561px 125.65049px",
                          }}
                          id="ellrdxczchean"
                          className="animable"
                        />
                        <path
                          d="M386.56,124.1h0l-.09,0Z"
                          style={{
                            fill: "rgb(154, 74, 77)",
                            transformOrigin: "386.514999px 124.099998px",
                          }}
                          id="elx606km19yeh"
                          className="animable"
                        />
                        <path
                          d="M388.69,123.81a1.42,1.42,0,0,0-.54-.17c-.21,0-.43-.06-.65-.08l-.47,0h-.29a.39.39,0,0,0-.29.13c-.13.14,0,.37.13.44l.1,0a1.22,1.22,0,0,0,.54.06h1a.8.8,0,0,0,.46-.07C388.83,124.08,388.79,123.87,388.69,123.81Z"
                          style={{
                            fill: "rgb(154, 74, 77)",
                            transformOrigin: "387.587593px 123.879139px",
                          }}
                          id="elr29xlq5s2r"
                          className="animable"
                        />
                        <polygon
                          points="386.59 124.11 386.58 124.11 386.58 124.11 386.59 124.11"
                          style={{
                            fill: "rgb(154, 74, 77)",
                            transformOrigin: "386.584991px 124.110001px",
                          }}
                          id="el4roufjzgqbo"
                          className="animable"
                        />
                        <path
                          d="M388.71,125.13a1.1,1.1,0,0,0-.51,0c-.14,0-.29,0-.43,0s-.52,0-.78,0a.23.23,0,0,0-.19.32.43.43,0,0,0,.38.3h.46l.41,0,.41-.1a.58.58,0,0,0,.33-.19C388.85,125.37,388.84,125.17,388.71,125.13Z"
                          style={{
                            fill: "rgb(154, 74, 77)",
                            transformOrigin: "387.803273px 125.425015px",
                          }}
                          id="el02ex0bbj6fyv"
                          className="animable"
                        />
                        <path
                          d="M387.16,125.81Z"
                          style={{
                            fill: "rgb(154, 74, 77)",
                            transformOrigin: "387.160004px 125.809998px",
                          }}
                          id="elpj8ck71kb9"
                          className="animable"
                        />
                        <path
                          d="M405.69,115.34c-1.05-.45-2.47-.1-3.56,0a19.16,19.16,0,0,1-3.63.34c-2.22-.1-4.52-1.49-6.75-.79-.05,0-.07.13,0,.13a8.64,8.64,0,0,1,3.52.51,14.66,14.66,0,0,0,3.33.78,14.18,14.18,0,0,0,3.67-.38c.57-.12,1.13-.23,1.7-.31a10,10,0,0,0,1.72-.25S405.73,115.35,405.69,115.34Z"
                          style={{
                            fill: "rgb(154, 74, 77)",
                            transformOrigin: "398.706227px 115.504512px",
                          }}
                          id="elb8rfe93we5p"
                          className="animable"
                        />
                        <path
                          d="M417.24,125.54c-.32,8.32-3.18,8.92-6.13,9.43-3.91.67-5.86-1.43-12.85-1.37-4.25,0-5.56,1.31-8,2.32-1.78.75-3.63.66-3.92-1a58.58,58.58,0,0,1-.6-10.76,78.27,78.27,0,0,0,0,15.09c.61,3.91,1.68,7.56,3.86,9.37,3,2.51,9.32,2.84,17.13,1s10.68-4.41,11.6-7.18c3-9,1.74-13.22,2.75-14.93S417.24,125.54,417.24,125.54Z"
                          style={{
                            fill: "rgb(224, 224, 224)",
                            transformOrigin: "403.296875px 137.474687px",
                          }}
                          id="el2n7250zwbmf"
                          className="animable"
                        />
                        <path
                          d="M399.24,136.09c4-.12,5.3.6,5.52,3.33.3,3.91.12,5.23-1.37,5.45-1.76.25-3.06.37-3.13-.74a4.3,4.3,0,0,1,.24-2.51c.61-.75.39-.86-1.36-.81s-1.73.37-1.21.9.37,1.74.37,2.51-.18,1.17-2.71.95c-2.2-.19-1.84-2-1.82-5.32C393.77,137.58,394.72,136.22,399.24,136.09Z"
                          style={{
                            fill: "rgb(177, 102, 104)",
                            transformOrigin: "399.309253px 140.65378px",
                          }}
                          id="el1jbynwezx8f"
                          className="animable"
                        />
                        <path
                          d="M401.84,137.07l-5.3.77a2.62,2.62,0,0,0,3,2.35A2.8,2.8,0,0,0,401.84,137.07Z"
                          style={{
                            fill: "rgb(154, 74, 77)",
                            transformOrigin: "399.201819px 138.644697px",
                          }}
                          id="el1dqj1yu4c18"
                          className="animable"
                        />
                        <path
                          d="M401.16,137.88a2.72,2.72,0,0,1,.64.05,2.75,2.75,0,0,1-2.28,2.26,2.24,2.24,0,0,1-.86,0A2.45,2.45,0,0,1,401.16,137.88Z"
                          style={{
                            fill: "rgb(242, 143, 143)",
                            transformOrigin: "400.230011px 139.054724px",
                          }}
                          id="el5uhblrn22f4"
                          className="animable"
                        />
                      </g>
                    </g>
                    <g
                      id="freepik--Tie--inject-2"
                      style={{ transformOrigin: "409.465866px 192.382591px" }}
                      className="animable"
                    >
                      <path
                        d="M397.86,170.94s-3.26-5.41-3.38-7.63l3.4-3.91,1.56,9Z"
                        style={{
                          fill: "#3D50FA",
                          transformOrigin: "396.959976px 165.169998px",
                        }}
                        id="elcs9ht6q1gff"
                        className="animable"
                      />
                      <g id="eld15hh9u9r7n">
                        <g
                          style={{
                            opacity: "0.15",
                            transformOrigin: "396.959976px 165.169998px",
                          }}
                          className="animable"
                          id="elo8wt9u85s6"
                        >
                          <path
                            d="M397.86,170.94s-3.26-5.41-3.38-7.63l3.4-3.91,1.56,9Z"
                            id="elexmahvjr7"
                            style={{
                              transformOrigin: "396.959976px 165.169998px",
                            }}
                            className="animable"
                          />
                        </g>
                      </g>
                      <polygon
                        points="402.41 168.39 408.32 163.88 413.63 167.05 404.46 172.38 402.41 168.39"
                        style={{
                          fill: "#3D50FA",
                          transformOrigin: "408.020004px 168.130005px",
                        }}
                        id="elzelco3qmnol"
                        className="animable"
                      />
                      <g id="elom74mawnjq">
                        <g
                          style={{
                            opacity: "0.15",
                            transformOrigin: "408.020004px 168.130005px",
                          }}
                          className="animable"
                          id="elissmt5dpaeo"
                        >
                          <polygon
                            points="402.41 168.39 408.32 163.88 413.63 167.05 404.46 172.38 402.41 168.39"
                            id="eleicx2jd5ahw"
                            style={{
                              transformOrigin: "408.020004px 168.130005px",
                            }}
                            className="animable"
                          />
                        </g>
                      </g>
                      <path
                        d="M405.12,227.22c.89-12.72-2.84-47.2-2.75-51.7l-3.15-.14c-1.88,5.5-6.08,41.3-5.91,50,.08,4.2,4.46,11.47,5.83,11.68S404.93,229.92,405.12,227.22Z"
                        style={{
                          fill: "#3D50FA",
                          transformOrigin: "399.281172px 206.222206px",
                        }}
                        id="elj1hriikqbj"
                        className="animable"
                      />
                      <g id="elrdltialp1ie">
                        <path
                          d="M399,176.18c.07-.26.16-.58.23-.79h0l3.15.14h0c0,.38,0,.85,0,1.4A5.43,5.43,0,0,1,399,176.18Z"
                          style={{
                            opacity: "0.15",
                            transformOrigin: "400.690002px 176.17527px",
                          }}
                          className="animable"
                          id="els0w96mja4ok"
                        />
                      </g>
                      <path
                        d="M402.41,168.39a13.79,13.79,0,0,0-3,0,7.09,7.09,0,0,0-1.58,2.51,10.64,10.64,0,0,0,1.36,4.44,3.76,3.76,0,0,0,3.15.14,6.58,6.58,0,0,0,2.09-3.14A6,6,0,0,0,402.41,168.39Z"
                        style={{
                          fill: "#3D50FA",
                          transformOrigin: "401.130005px 172.034003px",
                        }}
                        id="els7cyqbdd54"
                        className="animable"
                      />
                      <path
                        d="M401.89,168.35l.52,0a19.11,19.11,0,0,1,3.61-3.24c.86-.44,4.4,5.67,5.06,7.26s.55,1.58,2.73.17a42.57,42.57,0,0,0,9.94-9.33c3.46-4.44,3.74-7.26,3.74-7.26a47,47,0,0,1-3.51-4.67c-1.37-2.53-1.62-3.75-3.05-3.56v1.82c-.28,2.19-2.52,3.71-5.62,6.32s-8.1,5-9.28,6.17A44,44,0,0,0,401.89,168.35Z"
                        style={{
                          fill: "rgb(250, 250, 250)",
                          transformOrigin: "414.690002px 160.640788px",
                        }}
                        id="el50bffpufssw"
                        className="animable"
                      />
                      <path
                        d="M391.65,168.42c.33.89,3.27-6.07,4.67-5.9.67.06,2.39,3.84,3.62,5.86h.22a26.18,26.18,0,0,1-1-6.47,48.65,48.65,0,0,1,.35-6.34l-.09-4.86c-.46,0-.83.3-2.25,2s-4.77,5.25-5.26,7.92A23.5,23.5,0,0,0,391.65,168.42Z"
                        style={{
                          fill: "rgb(250, 250, 250)",
                          transformOrigin: "395.800879px 159.60433px",
                        }}
                        id="elz1pyym9fts"
                        className="animable"
                      />
                    </g>
                    <path
                      d="M425,152.86s-15.84,27-27.37,49.37c-6.21-17.09-3.48-41.86-1.71-48a123.81,123.81,0,0,1-11.83,4.91c-5.64,5-7.76,10.3-8.45,46.27-.1,5.55.77,41.13.77,41.13,3.51,4.52,12.63,8,22.74,8.83,15.89,1.37,39.06-3.44,43.12-10l.32-31.95,2.25-49.23-4.14-2.95C434.44,158.3,427.13,155.2,425,152.86Z"
                      style={{
                        fill: "rgb(55, 71, 79)",
                        transformOrigin: "410.236012px 204.232109px",
                      }}
                      id="ellq5rpon29id"
                      className="animable"
                    />
                    <path
                      d="M424.16,168.9c-.56,1.86-1.12,3.71-1.71,5.55s-1.16,3.62-1.86,5.31l-8,3.93-.25.13v.28c0,2.9-.05,5.81-.21,8.68a17,17,0,0,1-.24,2.1,1.85,1.85,0,0,1-.44.76c-.21.27-.45.54-.69.8-1,1.06-2,2.06-3.06,3.05-2.12,2-4.3,3.91-6.46,5.84-2,1.74-3.94,3.45-5.93,5.16l1.07-3.71,1.27-4.55-1.55,4.47-1.52,4.47-.28.85.69-.57c4.5-3.69,9-7.38,13.28-11.34,1.07-1,2.13-2,3.14-3.07.26-.27.5-.55.74-.84a2.73,2.73,0,0,0,.62-1.12,17.65,17.65,0,0,0,.28-2.23c.21-2.83.21-5.65.2-8.47l7.85-4,.14-.07,0-.13c.74-1.86,1.25-3.71,1.8-5.57s1.06-3.73,1.57-5.6,1-3.75,1.47-5.63.95-3.76,1.4-5.64ZM389.8,198.46a14.88,14.88,0,0,1-1.1-2.6c-.05-.25,0-.22,0-.56l.15-.73.25-1.43.42-2.89.77-5.76,0-.25-.2-.17c-.92-.73-1.81-1.52-2.67-2.31-.43-.4-.85-.81-1.23-1.24a6.17,6.17,0,0,1-.52-.65,1.75,1.75,0,0,1-.29-.56,27.82,27.82,0,0,1,.53-3.43c.22-1.17.49-2.32.75-3.48.53-2.31,1.13-4.61,1.87-6.86a35.27,35.27,0,0,1,2.73-6.58,31.21,31.21,0,0,0-3.2,6.41c-.83,2.24-1.54,4.53-2.16,6.84-.3,1.16-.57,2.33-.82,3.5a28.18,28.18,0,0,0-.6,3.62,1.57,1.57,0,0,0,.18.6,3.14,3.14,0,0,0,.26.45,7.44,7.44,0,0,0,.58.75c.41.47.84.89,1.28,1.31a33.25,33.25,0,0,0,2.54,2.19l-.67,5.51-.37,2.88-.19,1.43-.11.7,0,.17v.08l0,.16a1.47,1.47,0,0,0,.06.46,15.58,15.58,0,0,0,1.26,2.7c.47.86.95,1.7,1.46,2.52,1,1.65,2.07,3.29,3.17,4.88-.94-1.69-1.9-3.37-2.8-5.09C390.68,200.18,390.22,199.33,389.8,198.46Z"
                      id="elz0pvqjp8bn8"
                      style={{ transformOrigin: "405.980026px 184.87999px" }}
                      className="animable"
                    />
                    <g
                      id="freepik--Arms--inject-2"
                      style={{ transformOrigin: "408.328888px 209.445007px" }}
                      className="animable"
                    >
                      <path
                        d="M408.81,224c.39-.51,1.58.56,4.13,1.13,3.25.72,4.51.61,8,1.51a17,17,0,0,0,4.8.88l-12.56,2.58a13.63,13.63,0,0,1-3.52-2.15A3,3,0,0,1,408.81,224Z"
                        style={{
                          fill: "rgb(177, 102, 104)",
                          transformOrigin: "417.07149px 226.983px",
                        }}
                        id="el7jupxxoiq1x"
                        className="animable"
                      />
                      <path
                        d="M353.7,189.88c-.89-.37-1.51,0-1.4.81l5.87,41.94,58.91,25-6-42a3.17,3.17,0,0,0-1.81-2.16l-33.64-14.28-2.4-4.26a1.49,1.49,0,0,0-.72-.63l-13.95-5.93a1.46,1.46,0,0,0-1.93.59l-.69,1.88Z"
                        style={{
                          fill: "#3D50FA",
                          transformOrigin: "384.683704px 222.921906px",
                        }}
                        id="elrvklckdprqm"
                        className="animable"
                      />
                      <g id="elbimuobfyufg">
                        <path
                          d="M353.7,189.88c-.89-.37-1.51,0-1.4.81l5.87,41.94,58.91,25-6-42a3.17,3.17,0,0,0-1.81-2.16l-33.64-14.28-2.4-4.26a1.49,1.49,0,0,0-.72-.63l-13.95-5.93a1.46,1.46,0,0,0-1.93.59l-.69,1.88Z"
                          style={{
                            opacity: "0.15",
                            transformOrigin: "384.683704px 222.921906px",
                          }}
                          className="animable"
                          id="el7e8rpp8vlf2"
                        />
                      </g>
                      <polygon
                        points="358.18 230.63 415.09 254.79 409.14 215.13 350.38 190.19 358.18 230.63"
                        style={{
                          fill: "rgb(240, 240, 240)",
                          transformOrigin: "382.735001px 222.489998px",
                        }}
                        id="eljuawza0ht1s"
                        className="animable"
                      />
                      <path
                        d="M417.08,257.64l-9.85-39.73a3.69,3.69,0,0,0-2-2.15l-55.55-23.57c-.88-.38-1.44,0-1.24.79l9.7,39.65Z"
                        style={{
                          fill: "#3D50FA",
                          transformOrigin: "382.739738px 224.840778px",
                        }}
                        id="el9lf76r1q55a"
                        className="animable"
                      />
                      <path
                        d="M351.87,206.88c-2.53,3.07-2.55,5.49-1.62,9.54s3.56,8.86,5,10.16,4.25,3.16,7.36,2.53,3.2-4.6,4.59-6.27c2.23-2.65-.77-4.62-3.66-5-6.83-.93-10.1-4.37-10.1-4.37Z"
                        style={{
                          fill: "rgb(177, 102, 104)",
                          transformOrigin: "358.831302px 218.058292px",
                        }}
                        id="elejpbl5jqmkq"
                        className="animable"
                      />
                      <path
                        d="M404.26,230.22a47.71,47.71,0,0,0,8.88-.08l12.56-2.58c5.59.65,21.57-10.55,21.57-10.55s-3.72-10.69-8.94-25.82c-4.25-11-3-21.66,2.94-28.9,8.94,3.53,12.15,4.63,15.53,15.06,2.65,8.23,7.79,30.78,10,39.37,1.26,4.91,1.75,9.26-3.61,12.32-4.78,2.73-17.08,8-27.66,11-5.65,1.61-8.79,3.18-14.76,4.06a51,51,0,0,1-9.71.72,13.71,13.71,0,0,1-3.45-.36c-1.67-.56-3.4-2.07-4.82-3.08a3.33,3.33,0,0,1-1.16-1.17c-.34-.69-.19-1.58-.63-2.21s-1.06-.77-1.48-1.26c-.75-.87-.66-2.22-1.25-3.2-.5-.83-1.52-1.8-1-2.86C398.12,229,400.24,229.89,404.26,230.22Z"
                        style={{
                          fill: "rgb(177, 102, 104)",
                          transformOrigin: "432.375633px 203.560959px",
                        }}
                        id="ell4ya9e7e3m"
                        className="animable"
                      />
                      <path
                        d="M435.82,222.93l-4.66,2.88s2.47,1.21,3.38,8a31.66,31.66,0,0,1,.37,7.22l3.93-1.65S442,227,435.82,222.93Z"
                        style={{
                          fill: "rgb(245, 245, 245)",
                          transformOrigin: "435.403899px 231.979996px",
                        }}
                        id="elw04ad791l2"
                        className="animable"
                      />
                      <path
                        d="M440.71,161.25c4.8,1.64,11.2,4.78,12.88,7.24s4.6,11.57,7.51,22.5,5.5,23.27,6.51,27.53,1.46,8.15-3.47,11.26-26.37,10.5-26.37,10.5,1.77-10.76-4.5-16.37l12.26-7.14s-5.63-15.92-7.87-21.44S430.77,171.2,440.71,161.25Z"
                        style={{
                          fill: "rgb(38, 50, 56)",
                          transformOrigin: "450.764166px 200.764999px",
                        }}
                        id="elxu9f0er2yqg"
                        className="animable"
                      />
                    </g>
                  </g>
                  <rect
                    x="417.57"
                    y="183.08"
                    width="12.94"
                    height="6.49"
                    style={{
                      fill: "#3D50FA",
                      transformOrigin: "424.04px 186.325px",
                    }}
                    id="elrpkt867ghjr"
                    className="animable"
                  />
                </g>
              </g>
              <g
                id="freepik--character-2--inject-2"
                style={{ transformOrigin: "270.031616px 268.319176px" }}
                className="animable"
              >
                <g
                  id="freepik--Character--inject-2"
                  style={{ transformOrigin: "270.031616px 268.319176px" }}
                  className="animable"
                >
                  <g
                    id="freepik--bottom--inject-2"
                    style={{ transformOrigin: "254.162849px 328.002258px" }}
                    className="animable"
                  >
                    <path
                      d="M217.12,386c-.51,2.57-1.44,5.55-2.27,10.83s.33,5.51-3.3,18.7c-2.18,7.93-1.85,11.09,2.93,17.85,5.1,7.24,10.56,5.85,14.2-2.06,3.12-6.77,3-9.93,3.08-17s.2-9.1.6-14.68c.34-4.93,0-8.3.33-12.07Z"
                      style={{
                        fill: "rgb(55, 71, 79)",
                        transformOrigin: "221.474275px 412.052261px",
                      }}
                      id="el3xcezctqqxv"
                      className="animable"
                    />
                    <path
                      d="M290.2,413.85a34.61,34.61,0,0,1-5.77-10.12c-1.35-3.94-1.6-7.45-2.25-13s.37-24.73.9-46.25c.4-10,.82-18.9,1.21-23.94,0,0-.1-13.78.22-21.81,1.11-27.51-1.75-80.79-1.75-80.79H230.45c-2.11,5.53-8.12,13.41-9.53,42.5-1.48,30.49-.74,61.35-.74,61.35-4.17,14.22-3.36,23.73-3,42.85h0c.14,8.7.4,16.78-.08,22.14-.42,4.61-.74,11.67-1.8,18.49-.79,5.11-2.42,10.09-2.53,13.75a1.9,1.9,0,0,0,2.51,1.84,17.22,17.22,0,0,1,11.85.91,1.9,1.9,0,0,0,2.68-1.43c1.57-9.87,2.89-32.31,2.89-32.31.47-2.74,1.08-5.79,1.76-9,1.06-4.49,2.94-12.31,5-21.14,2.24-9.12,4.22-17.39,6.28-29.52s7.83-46.28,7.83-46.28l3.34,39.78c-.34,11.93-.1,16.45,1.51,26.19.7,4.21,2,10.78,3.3,17.41,1,6.22,2.87,14,2.56,16.05a4.08,4.08,0,0,1-.63,1.79s1.43,13.08,3.21,22.05,2.3,13.87,8,15.73,18.64.75,20,.1S290.2,413.85,290.2,413.85Z"
                      style={{
                        fill: "rgb(255, 189, 167)",
                        transformOrigin: "253.914772px 320.028236px",
                      }}
                      id="elgh8ahgrwcsf"
                      className="animable"
                    />
                    <path
                      d="M258.89,396.31c.2,2.1,1.78,4.61,2.3,7.91a58.27,58.27,0,0,1,.71,11.4c-.15,4.65-.17,5.32-.17,5.32l1.45,0s.2-6.73.3-9.69,1.11-5.56,2.53-5.83C266,405.46,265.88,396.52,258.89,396.31Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "262.449997px 408.625px",
                      }}
                      id="elhqgop04v8rc"
                      className="animable"
                    />
                    <path
                      d="M263.83,382.1c-.86,3.12-1.3,3.59-3.91,8.49a10.44,10.44,0,0,0-1.35,4,4.36,4.36,0,0,0,1.37,3.19c1.19,1.22,2.15,2,4,3.89,2.08,2.09,3.6,8.83,4.44,12.75s1.3,7.36,4.61,9.36c2.58,1.56,9.86,3.28,15.25,3.92,10.49,1.24,11.19-4,8.48-6.88s-5.72-6.36-6.55-7a13.52,13.52,0,0,0-6.9.82c-4.18,1.7-6.87,1.54-9,.59-4-1.79-4.36-8.3-5-19C268.62,384.16,263.83,382.1,263.83,382.1Z"
                      style={{
                        fill: "rgb(55, 71, 79)",
                        transformOrigin: "278.318541px 404.993298px",
                      }}
                      id="eltf78qmvpazt"
                      className="animable"
                    />
                    <path
                      d="M283.45,217.9c1.27,8.36,5.05,62.85,5.36,81.29s1.12,32.33,1.12,32.33-6.83,12.37-41.64,10.56c-30.47-1.57-35.35-10.67-35.35-10.67s3.14-23.57,3.7-40.4,1.11-55.3,12.73-73.11Z"
                      style={{
                        fill: "rgb(69, 90, 100)",
                        transformOrigin: "251.434998px 280.080448px",
                      }}
                      id="elmcn8gnmxak"
                      className="animable"
                    />
                    <path
                      d="M265.56,269.39s2.36,53.44,2.87,71.9c-1.44.21-3,.4-4.58.54Z"
                      style={{
                        fill: "rgb(55, 71, 79)",
                        transformOrigin: "266.139999px 305.610016px",
                      }}
                      id="elfcb9ha484gg"
                      className="animable"
                    />
                    <path
                      d="M253.14,247l-.1,95.27c-1.53,0-3.1-.06-4.75-.14l-.86-.05Z"
                      style={{
                        fill: "rgb(55, 71, 79)",
                        transformOrigin: "250.284996px 294.634995px",
                      }}
                      id="elt1x8b51harl"
                      className="animable"
                    />
                    <path
                      d="M275.59,339.8l.16-97.4,4.59,95.81A43.89,43.89,0,0,1,275.59,339.8Z"
                      style={{
                        fill: "rgb(55, 71, 79)",
                        transformOrigin: "277.964996px 291.099991px",
                      }}
                      id="el4eatryk081i"
                      className="animable"
                    />
                    <path
                      d="M241.09,265.24,236.68,341c-1.69-.26-3.28-.54-4.76-.85Z"
                      style={{
                        fill: "rgb(55, 71, 79)",
                        transformOrigin: "236.504997px 303.119995px",
                      }}
                      id="els02fgb2nn0a"
                      className="animable"
                    />
                    <path
                      d="M222,307.1c2.35-22.23,5.72-41.79,7.14-59.31-.25,12.49-1.86,35.93-3.2,61.4-.65,12.23-1.14,23.95-1.38,28.94a41,41,0,0,1-5.47-2.33C220,329.79,221,316.53,222,307.1Z"
                      style={{
                        fill: "rgb(55, 71, 79)",
                        transformOrigin: "224.114998px 292.960007px",
                      }}
                      id="elhvkroijcm6e"
                      className="animable"
                    />
                  </g>
                  <g
                    id="freepik--top--inject-2"
                    style={{ transformOrigin: "270.031616px 172.237801px" }}
                    className="animable"
                  >
                    <path
                      d="M268.55,154.34c10.73,1.46,14.76,7.15,19.79,16.12,4.32,7.69,9.29,16.42,9.29,16.42,1.53-1.24,14-11.53,17-15.49,3.15-4.2,2-6.18,2-9.07s1-5.14.45-9.66c-.28-2.16,2.05-1.7,3-.44,1.89,2.55,1.67,7.16,2.9,6.95a11,11,0,0,0,3.3-3.6c2.3-3.53,2.77-6.76,4.65-10.49.72-1.43,1.69-3,3.51-3a3.47,3.47,0,0,1,.55.08.68.68,0,0,1,.5.56,6.57,6.57,0,0,1,0,1.47c0,.35-.22,1.37-.22,1.37s1.64.26,1.9,1a5.3,5.3,0,0,1-.08,3.33c.69.48,1.75,1.7.66,4.29.63.27,1.94,2,.86,5.54a45.19,45.19,0,0,1-4.17,9.24c-2.69,4.29-5.25,5.87-8.87,10.36s-10.33,14.34-16.36,21.21c-7,8-9.83,10.06-16.61,6.32-3.52-1.93-22.38-27.73-22.38-27.73Z"
                      style={{
                        fill: "rgb(255, 189, 167)",
                        transformOrigin: "303.786301px 175.366985px",
                      }}
                      id="eldyhmktsgkub"
                      className="animable"
                    />
                    <path
                      d="M324.89,160.86c1.78,2.35,1.67,7.06-1.87,10.6C327.16,169.65,328.69,163.4,324.89,160.86Z"
                      style={{
                        fill: "rgb(240, 153, 122)",
                        transformOrigin: "325.042926px 166.160004px",
                      }}
                      id="eln6v8k3iae3a"
                      className="animable"
                    />
                    <path
                      d="M269.15,154c8.7,1.78,11.92,4.57,14.85,8.64s14,24,14,24l12.89-11.22s-.31,3.64,3.31,7.84,5.94,3.38,5.94,3.38-8.38,12.83-13.95,18.3-9.16,5.13-13.91,2-22.61-27.47-22.61-27.47Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "294.645004px 181.597696px",
                      }}
                      id="el58w1wjcwbwc"
                      className="animable"
                    />
                    <path
                      d="M284,217.69c-.62-5-1.09-8.76-1.25-10.86,0-5.17.11-13.21.11-13.21,9.18-8.42,4.88-17,1.46-22.24-5.71-8.67-11-13-15.74-17a111.5,111.5,0,0,0-16.5-2,46.23,46.23,0,0,0-12.39,1.19c-3.5.66-12.18,2.81-12.18,2.81-2.58,1.42-4.82,4.27-4.73,12.19.07,6.89.83,10,3.13,16.2,3.23,8.72,3.7,12.82,4.8,17.22,1.43,5.72.49,9.93-2.07,15.28-1.23,2.59-.11,5.25,7.23,8.81,4.93,2.38,23.27,5.72,38.49,1.06C280.31,225.22,284.31,220.45,284,217.69Z"
                      style={{
                        fill: "rgb(250, 250, 250)",
                        transformOrigin: "255.575001px 190.912682px",
                      }}
                      id="el9y8u4gyuasq"
                      className="animable"
                    />
                    <path
                      d="M271.05,128.64c-3.46,7.4-7.38,10.1-10.61,16.82-8.18-.35-18.28-13.34-27.72-18.86-5.51-3.22-9.1-7.26-7.53-13.89,2.57-10.86,11.56-16.6,27-13.2,6.24,1.37,13.16,6.42,14.37,13.48C274.17,115.7,273.36,123.68,271.05,128.64Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "248.739262px 121.996908px",
                      }}
                      id="elg8h91qenpzn"
                      className="animable"
                    />
                    <path
                      d="M233.44,111.28c-1.64.74-4.29,4.59-4.94,19.57-.54,12.13,3.66,16.49,6,17.56a20.27,20.27,0,0,0,8.06,1.2l0,5.1c5,9.42,12.16,12.81,22.06,18.07a32,32,0,0,0-4.06-17.18V141.53s2.94,2.39,6.86-.56c3.24-2.44,3.87-7.43,1.67-10a5.5,5.5,0,0,0-8.75,1s-4.77,3.18-4.34-4.47c.48-8.61-2.87-17.31-8.78-15.56C236.61,115.09,236.8,109.68,233.44,111.28Z"
                      style={{
                        fill: "rgb(255, 189, 167)",
                        transformOrigin: "249.419222px 141.878475px",
                      }}
                      id="elihth64bcvs"
                      className="animable"
                    />
                    <path
                      d="M242.57,149.61c3.93-.23,11.83-2.31,13.82-6.58,0,0-.46,3.73-3,5.58-3.91,2.83-10.81,3.53-10.81,3.53Z"
                      style={{
                        fill: "rgb(240, 153, 122)",
                        transformOrigin: "249.480011px 147.584999px",
                      }}
                      id="elk1bkg15y7kb"
                      className="animable"
                    />
                    <polygon
                      points="241.28 124.47 239.86 135.54 234.99 133.27 241.28 124.47"
                      style={{
                        fill: "rgb(240, 153, 122)",
                        transformOrigin: "238.135002px 130.004997px",
                      }}
                      id="elocy0fbvb36"
                      className="animable"
                    />
                    <path
                      d="M246,137.3l-5.95,2a3.08,3.08,0,0,0,3.91,2.09A3.29,3.29,0,0,0,246,137.3Z"
                      style={{
                        fill: "rgb(177, 102, 104)",
                        transformOrigin: "243.10142px 139.419602px",
                      }}
                      id="eloxd165knmp"
                      className="animable"
                    />
                    <path
                      d="M243.91,141.38a2.45,2.45,0,0,1-.37.08,2.85,2.85,0,0,1,2.54-3.06A3.24,3.24,0,0,1,243.91,141.38Z"
                      style={{
                        fill: "rgb(242, 143, 143)",
                        transformOrigin: "244.805448px 139.930008px",
                      }}
                      id="el2b49vksyfym"
                      className="animable"
                    />
                    <path
                      d="M232.29,126.44c-.37.87.23,1.2,1.07,1.55s1.58.59,1.95-.27a1.67,1.67,0,0,0-.84-2.21A1.69,1.69,0,0,0,232.29,126.44Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "233.817902px 126.850837px",
                      }}
                      id="elqijfomwj4om"
                      className="animable"
                    />
                    <path
                      d="M235.26,125.89a4.44,4.44,0,0,0-1.2-.53,3.63,3.63,0,0,0-1.27-.15,4.24,4.24,0,0,0-1.31.29s-.07.11,0,.1c.35,0,.66,0,1.17,0a5.59,5.59,0,0,1,1.4.27,5.81,5.81,0,0,1,1.57.71c.16.09.48.29.51.32s.09-.09.07-.13A2.88,2.88,0,0,0,235.26,125.89Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "233.826438px 126.054166px",
                      }}
                      id="elr6nuo78mf0e"
                      className="animable"
                    />
                    <path
                      d="M235.27,121.11l-3.79,1.3a2.11,2.11,0,0,1,1.29-2.61A2,2,0,0,1,235.27,121.11Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "233.326929px 121.059889px",
                      }}
                      id="elp31tgemjcu"
                      className="animable"
                    />
                    <path
                      d="M248.71,127.27c.25.9-.39,1.15-1.27,1.39s-1.65.37-1.9-.54a1.67,1.67,0,0,1,1.13-2.07A1.69,1.69,0,0,1,248.71,127.27Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "247.118582px 127.418249px",
                      }}
                      id="elgxewqotrb1m"
                      className="animable"
                    />
                    <path
                      d="M245.84,126.32a4.65,4.65,0,0,1,1.26-.36,3.61,3.61,0,0,1,1.27,0,4.12,4.12,0,0,1,1.27.46s.05.12,0,.11a9.8,9.8,0,0,0-1.15-.19,6.45,6.45,0,0,0-3.08.57l-.54.25c-.05,0-.08-.1-.06-.14A3,3,0,0,1,245.84,126.32Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "247.23298px 126.531852px",
                      }}
                      id="elqb7tf9ecm6k"
                      className="animable"
                    />
                    <path
                      d="M246.23,121.26l3.58,1.8a2.11,2.11,0,0,0-.93-2.76A1.94,1.94,0,0,0,246.23,121.26Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "248.119203px 121.576768px",
                      }}
                      id="eloqul1bslj2f"
                      className="animable"
                    />
                    <path
                      d="M242.56,152.14s9.57,18.66,13,27.75,2.49,16.6,2.59,33.47c.08,13,0,32.58,0,32.58s-28.28.38-36.56-10c1.56-6.56,7.08-19.67,8.42-23.88s1.14-10-2.13-19.31-5.47-16.38-5.82-23.4,2.55-11.64,4.26-13Z"
                      style={{
                        fill: "rgb(55, 71, 79)",
                        transformOrigin: "239.893171px 199.040886px",
                      }}
                      id="el7mitkxokw3"
                      className="animable"
                    />
                    <path
                      d="M260.54,151.94V154s17.58,16.34,18.71,32.95,2.13,54.1,2.13,54.1a25.09,25.09,0,0,0,6.27-5.25c-.73-7.54-3.28-37.34-2.57-40.75s8.85-11.17,1.42-22.27A90.11,90.11,0,0,0,269.15,154Z"
                      style={{
                        fill: "rgb(55, 71, 79)",
                        transformOrigin: "275.073139px 196.494995px",
                      }}
                      id="eltdtuy2jsko"
                      className="animable"
                    />
                    <path
                      d="M250.46,196.54l-1.31-2.25-.1-.16,0-.12a3.53,3.53,0,0,1,0-1.31c0-.48.13-1,.21-1.44a51.45,51.45,0,0,1,1.51-5.7l.15-.48-.5-.1a30.63,30.63,0,0,1-4.29-1.18,10.5,10.5,0,0,1-3.73-2.07,2.33,2.33,0,0,1-.52-.77,2.07,2.07,0,0,1-.08-.42l-.05-.56-.18-2.26-.35-4.52c-.52-6-1.06-12-1.73-18,.21,6,.55,12.07.9,18.08l.3,4.52.15,2.25,0,.57a2.63,2.63,0,0,0,.13.69,3.26,3.26,0,0,0,.71,1.11,10.34,10.34,0,0,0,4.1,2.32,30,30,0,0,0,4,1.06,49.35,49.35,0,0,0-1.33,5.36,10.89,10.89,0,0,0-.19,1.52,4.09,4.09,0,0,0,.13,1.64l.09.23.3.47.4.63.8,1.26c1.07,1.68,2.11,3.37,3.2,5l3.27,5-2.94-5.19C252.48,200,251.46,198.25,250.46,196.54Zm35-9.17a3.57,3.57,0,0,0-.17-.75,17.82,17.82,0,0,0-2.8-4.62,27.28,27.28,0,0,0,1.37-3.83,13,13,0,0,0,.41-2.17,6.16,6.16,0,0,0-.13-2.29,5.59,5.59,0,0,0-1.17-2c-.45-.57-.92-1.12-1.39-1.65-.94-1.08-1.91-2.13-2.88-3.17-2-2.08-4-4.08-6-6.07-1-1-2.07-2-3.12-2.92s-2.13-1.91-3.27-2.77c2.1,1.93,4,4,6,6.07s3.9,4.15,5.81,6.25c.95,1.05,1.91,2.11,2.82,3.18.46.54.92,1.09,1.34,1.64a4.77,4.77,0,0,1,1,1.66,5.5,5.5,0,0,1,.07,2,14.19,14.19,0,0,1-.37,2,25.29,25.29,0,0,1-1.37,3.95l-.11.26.17.22a17.83,17.83,0,0,1,2.88,4.52,2.69,2.69,0,0,1,.15,1.2c0,.44-.09.9-.14,1.35-.13.9-.27,1.81-.43,2.72-.66,3.62-1.4,7.24-2.11,10.87,1-3.56,2-7.13,2.73-10.75.19-.91.37-1.81.54-2.73.07-.46.15-.92.19-1.4A3.9,3.9,0,0,0,285.5,187.37Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "262.500196px 181.020012px",
                      }}
                      id="el2usbswwwtwo"
                      className="animable"
                    />
                    <path
                      d="M227.1,156.13c-8.45,1.48-11.81,6.64-15.52,17.61-5.07,15-9.53,29.75-10.49,37.26L221,205.55l10.66-21.46S235.68,166.86,227.1,156.13Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "216.845375px 183.565002px",
                      }}
                      id="el3nkf57hy6b3"
                      className="animable"
                    />
                    <polygon
                      points="267.5 240.49 224.38 233.86 217.82 178.59 260.94 185.22 267.5 240.49"
                      style={{
                        fill: "#3D50FA",
                        transformOrigin: "242.660004px 209.540001px",
                      }}
                      id="ela77m33k82ga"
                      className="animable"
                    />
                    <g id="eltaqi6jxevsb">
                      <polygon
                        points="267.5 240.49 224.38 233.86 217.82 178.59 260.94 185.22 267.5 240.49"
                        style={{
                          opacity: "0.2",
                          transformOrigin: "242.660004px 209.540001px",
                        }}
                        className="animable"
                        id="eluozx76mwse"
                      />
                    </g>
                    <polygon
                      points="265.9 238.07 224.59 231.71 218.48 180.16 259.79 186.52 265.9 238.07"
                      style={{
                        fill: "rgb(250, 250, 250)",
                        transformOrigin: "242.189995px 209.115005px",
                      }}
                      id="el51121vlq67k"
                      className="animable"
                    />
                    <path
                      d="M260.6,222.46l-4.13-34.81-38.65-9.07,6.56,55.3,40.86,9.59a1,1,0,0,0,1.31-1.2l-2.09-17.63A2,2,0,0,0,263,223Z"
                      style={{
                        fill: "#3D50FA",
                        transformOrigin: "242.202381px 211.055683px",
                      }}
                      id="el8l09tul9pu9"
                      className="animable"
                    />
                    <path
                      d="M201.37,211c0,5.66.84,6.61,7.06,9.79s21.9,8.09,34.33,9.29c8.1.78,12.26.4,15.41-.84A13,13,0,0,0,266.28,215c1.35-3.92-.7-4.45-2.39-4.87l.31,2.56s-3.63,2.47-7,2.52-.24-3.88.36-6.24.48-3.73-1.46-4.85c-1.09,0-1.45,1.49-4.82,4.85-2.57,2.56-4.57,7.21-8.54,6.67-3.12-.42-21.61-9-21.61-9l-.84-7.08Z"
                      style={{
                        fill: "rgb(255, 189, 167)",
                        transformOrigin: "234.043873px 215.02278px",
                      }}
                      id="elerhhosymmyj"
                      className="animable"
                    />
                    <path
                      d="M201.09,211c-.24,3.53.39,5.38,2,6.9s8.35,4.69,12.47,6.13,15,4.37,17,4.75c-2.15-3.36-1.62-10,.2-13s4.23-2.25,4.23-2.25l-15.91-7.16L220,196.72Z"
                      style={{
                        fill: "rgb(38, 50, 56)",
                        transformOrigin: "219.015303px 212.75px",
                      }}
                      id="ele078l3wbhd"
                      className="animable"
                    />
                  </g>
                </g>
              </g>
              <g
                id="freepik--character-1--inject-2"
                style={{ transformOrigin: "109.858887px 282.175461px" }}
                className="animable"
              >
                <g
                  id="freepik--character--inject-2"
                  style={{ transformOrigin: "109.858887px 282.175461px" }}
                  className="animable"
                >
                  <g
                    id="freepik--bottom--inject-2"
                    style={{ transformOrigin: "95.066654px 340.43866px" }}
                    className="animable"
                  >
                    <g
                      id="freepik--bottom--inject-2"
                      style={{ transformOrigin: "95.066654px 340.43866px" }}
                      className="animable"
                    >
                      <polygon
                        points="105.77 422.82 109.53 420.9 105.78 419.9 105.77 422.82"
                        style={{
                          fill: "rgb(38, 50, 56)",
                          transformOrigin: "107.649998px 421.360001px",
                        }}
                        id="elo47ud7kpsxk"
                        className="animable"
                      />
                      <path
                        d="M143.46,429.31s-45-19.67-45.52-16.63a4.29,4.29,0,0,0,0,1.83l-.13-.17.91,5.65a13.24,13.24,0,0,0,7,2.83c0-.27,0-2,0-2.92a23.28,23.28,0,0,1,4,2.05c2.9,1.87,4.79,5.18,7.88,9,2.26,2.8,6.23,4.06,12.1,4.81,6.32.82,11.85-.48,13.39-2.2C144.35,432.19,143.69,429.7,143.46,429.31Z"
                        style={{
                          fill: "rgb(38, 50, 56)",
                          transformOrigin: "120.824404px 424.186258px",
                        }}
                        id="eldec4ihzdt9k"
                        className="animable"
                      />
                      <path
                        d="M142.21,428.28c-.44-.45-2.06-2.19-4.24-4.09-1.92-1.65-4.15-3.75-6.54-5.44a25.18,25.18,0,0,1-3.24-2.61c-.79-.83-1.55-1.69-2.26-2.6a48.5,48.5,0,0,1-5.53-9.13,22,22,0,0,1-2-4.81,31.21,31.21,0,0,1-.61-5.36c-.17-8.12,0-9.41-.07-15.59l-18.88.89c.67,3.42,1.68,8.08,2.06,12,.58,5.91.76,7.22-1.45,13.16-.65,1.75-1.64,3.43-1.7,5.3-.1,3,2.3,5.61,5,7,2.21,1.2,4.74,1.69,6.88,3a22.05,22.05,0,0,1,5.65,5.42c1.53,1.91,2.77,4.18,4.9,5.52a19.73,19.73,0,0,0,7.32,2.43,39,39,0,0,0,9.79.35C142,433.28,145.39,431.54,142.21,428.28Z"
                        style={{
                          fill: "rgb(255, 168, 167)",
                          transformOrigin: "120.599648px 406.264271px",
                        }}
                        id="el8d408z6l88t"
                        className="animable"
                      />
                      <path
                        d="M139.6,425c-1.95-1.6-4.72-3.9-8-6.48a8.41,8.41,0,0,0-6.93.74c-6.6,3.6-7.66,8.6-7.66,8.6a9.59,9.59,0,0,0,5.49,4.69c7.73,3.27,21.45,2,21.53-1.56C144,428.74,142,427,139.6,425ZM99.9,403.38s-.43,1.17-1.57,3.48a6.44,6.44,0,0,0,.17,6.85,10.22,10.22,0,0,0,6.79,4.51C107.33,411.44,102.59,404.8,99.9,403.38Z"
                        style={{
                          fill: "rgb(55, 71, 79)",
                          transformOrigin: "120.728189px 418.909394px",
                        }}
                        id="el0k6enyr0iv6g"
                        className="animable"
                      />
                      <path
                        d="M65.21,413.07c1.31,2-.17,9.71.23,15.16.37,5,1.87,13.58.45,18.51-1.68,5.85-5.21,12.67-12.15,7.37-4.31-3.29-6.82-7.59-7.55-14.73-.51-4.95,1.33-11.86,2.9-18,1.84-7.16,2.52-11,2.52-11Z"
                        style={{
                          fill: "rgb(38, 50, 56)",
                          transformOrigin: "56.296358px 433.198673px",
                        }}
                        id="el7jg4949v94m"
                        className="animable"
                      />
                      <path
                        d="M50.43,376.76c-.25,11.58,1.27,19.68,1.5,27.09a52,52,0,0,1-.84,10c-.88,4.75-2.39,11.36-3,14.44-.88,4.3-1.55,7,0,11.79a5.47,5.47,0,0,0,.5,1.07c2.15,3.92,7.47,6.8,9.14,6.28a2.91,2.91,0,0,0,3,1,5.12,5.12,0,0,0,.56-.15c.19-.07.37-.15.56-.24a5.77,5.77,0,0,0,2.72-3.7,10.1,10.1,0,0,0,.25-1.05c1.1-6,.13-9.82,0-12.15-.19-2.69-.1-6.12,0-10.47s.89-18,2.26-24.55c1-4.57,2.3-10.31,3.65-16.42Z"
                        style={{
                          fill: "rgb(255, 168, 167)",
                          transformOrigin: "58.946023px 412.641247px",
                        }}
                        id="elawcd79cu9tw"
                        className="animable"
                      />
                      <path
                        d="M47.17,433.92c4.1-1.92,16.11-2.43,18.15,3.38.16,5.51.28,9.24-3.1,14.11-4.49,6.46-10.66-.16-13.06-4.4S46.66,436.9,47.17,433.92Z"
                        style={{
                          fill: "rgb(55, 71, 79)",
                          transformOrigin: "56.152418px 443.358445px",
                        }}
                        id="eli480dz2fbxb"
                        className="animable"
                      />
                      <path
                        d="M62.92,225.27c-5.63,10.62-10.17,19.56-11.11,47.31-1.06,31.32-.56,43.23-.63,47s-2.36,10.75-4,29.38,1.44,63.66,1.44,63.66,1.53,3,8.65,3.55c6.58.5,10.38-1.89,10.38-1.89s9.18-59.39,11.52-70.64,9.06-48.19,9.06-48.19l4.7,29.83s-1.86,10.3.37,26.59S99.86,401,99.86,401a37.4,37.4,0,0,0,10,2.36,24.1,24.1,0,0,0,11-1.5s4.12-66.6,3.87-85.09-2.65-64.61-8.84-91.91Z"
                        style={{
                          fill: "rgb(69, 90, 100)",
                          transformOrigin: "85.719978px 320.549393px",
                        }}
                        id="elj0bnn2xi32"
                        className="animable"
                      />
                      <path
                        d="M93.57,259.82,88.2,295.46l4.7,29.83L90.66,295l4.84-29.26c4.45-1.13,14.52-6.61,17.21-14.29C105.93,258.76,93.57,259.82,93.57,259.82ZM72.45,239.31c.74-3,1.53-6,2.43-9a43.32,43.32,0,0,0-3.9,8.54,81.47,81.47,0,0,0-2.55,9,93.31,93.31,0,0,0-1.57,9.24,61,61,0,0,0-.49,9.37c.7-3.06,1.36-6.09,2-9.12s1.28-6,2-9.07S71.72,242.31,72.45,239.31Zm-4.51-2.18c1-1.84,2-3.68,2.86-5.62a32.79,32.79,0,0,0-4.16,4.81,44.64,44.64,0,0,0-3.37,5.39,39.76,39.76,0,0,0-2.53,5.84,25.13,25.13,0,0,0-1.35,6.23l2.77-5.64c.94-1.84,1.87-3.69,2.85-5.51S67,239,67.94,237.13ZM65.85,355.94q-2.4,14.47-4.43,29,3.17-14.36,5.94-28.76c1.89-9.6,3.65-19.19,5.4-28.86s2.68-19.44,3.49-29.2,1.41-19.53,1.86-29.31c-1.21,9.72-2.29,19.45-3.38,29.16s-2.26,19.42-3.91,29S67.42,346.29,65.85,355.94Zm49.91-49.35c.25,4.24.56,8.51.55,12.7s-.23,8.49-.39,12.74l-.47,12.77q-.48,12.76-.66,25.56,1.33-12.72,2.2-25.48c.58-8.52,1.12-17,1.29-25.58-.15-8.63-1-17.09-1.87-25.58s-2-16.94-3.47-25.35l1.94,25.49C115.18,298.1,115.51,302.35,115.76,306.59Z"
                        style={{
                          fill: "rgb(55, 71, 79)",
                          transformOrigin: "88.834997px 307.625px",
                        }}
                        id="el1dk90dw1w7w"
                        className="animable"
                      />
                    </g>
                  </g>
                  <g
                    id="freepik--top--inject-2"
                    style={{ transformOrigin: "109.858887px 191.586327px" }}
                    className="animable"
                  >
                    <path
                      id="freepik--chest--inject-2"
                      d="M56.65,239.93c-5.67-2.67.53-6.42,1.77-23.77.32-4.48-1.19-15.57-1.19-15.57s9.68-11.78,7.06-33.38L83.81,165l12.6.1,8,2.38c2.72,2.43,7.7,6.29,11.65,12.12,5.7,8.43,6.56,17.58.41,24.28-.09,1.32.77,21.63,2.42,26.59,1.54,4.61,1.87,5.13-.61,7.18C110.48,243.39,66.69,243.79,56.65,239.93Z"
                      style={{
                        fill: "rgb(250, 250, 250)",
                        transformOrigin: "87.509262px 203.730255px",
                      }}
                      className="animable"
                    />
                    <g
                      id="freepik--Arm--inject-2"
                      style={{ transformOrigin: "141.917988px 195.745171px" }}
                      className="animable"
                    >
                      <path
                        d="M101.71,166.1c10.52,1.81,12.08,3.32,17.71,9.64,7,7.87,8.63,9.72,18.89,20.13l31.94-10.18v17.16s-22.46,10.65-30,13.19c-5.62,1.9-8.81-.71-13.23-4.79-6.77-6.24-20.45-19.12-20.45-19.12Z"
                        style={{
                          fill: "#3D50FA",
                          transformOrigin: "135.98px 191.38615px",
                        }}
                        id="elyzsy513gird"
                        className="animable"
                      />
                      <g id="elmi6lubz5lq">
                        <g
                          style={{
                            opacity: "0.15",
                            transformOrigin: "135.98px 191.38615px",
                          }}
                          className="animable"
                          id="elg6z12qio57a"
                        >
                          <path
                            d="M101.71,166.1c10.52,1.81,12.08,3.32,17.71,9.64,7,7.87,8.63,9.72,18.89,20.13l31.94-10.18v17.16s-22.46,10.65-30,13.19c-5.62,1.9-8.81-.71-13.23-4.79-6.77-6.24-20.45-19.12-20.45-19.12Z"
                            id="ele2rt5k2z9r"
                            style={{
                              transformOrigin: "135.98px 191.38615px",
                            }}
                            className="animable"
                          />
                        </g>
                      </g>
                      <g
                        id="freepik--Tablet--inject-2"
                        style={{
                          transformOrigin: "155.860443px 195.745171px",
                        }}
                        className="animable"
                      >
                        <path
                          d="M178.67,163.32h0l-1.81-.88v0a1.69,1.69,0,0,0-1.55.23L135.09,186a6,6,0,0,0-2.7,4.3l-2.74,36.16a1.57,1.57,0,0,0,.66,1.64h0l1.86.91v0a1.7,1.7,0,0,0,1.58-.23L174,205.45a6,6,0,0,0,2.7-4.3c.54-7.11,2.2-29.05,2.74-36.16C179.49,164.1,179.18,163.52,178.67,163.32Z"
                          style={{
                            fill: "rgb(69, 90, 100)",
                            transformOrigin: "154.529449px 195.727982px",
                          }}
                          id="eldqa9kixsvxh"
                          className="animable"
                        />
                        <path
                          d="M135.41,188.28a5.92,5.92,0,0,0-1.21,2.93l-2.74,36.15a1.63,1.63,0,0,0,.6,1.62l-1.76-.85h0a1.57,1.57,0,0,1-.67-1.64l2.74-36.17a5.77,5.77,0,0,1,1.09-2.75Z"
                          style={{
                            fill: "rgb(38, 50, 56)",
                            transformOrigin: "132.50246px 208.274986px",
                          }}
                          id="elkdpluess2ks"
                          className="animable"
                        />
                        <path
                          d="M131.47,227.37l2.73-36.17a6.07,6.07,0,0,1,2.7-4.29l40.25-23.35c1.37-.79,2.39-.15,2.27,1.43-.54,7.11-2.2,29-2.74,36.16a6,6,0,0,1-2.7,4.3l-40.24,23.34C132.36,229.59,131.35,229,131.47,227.37Z"
                          style={{
                            fill: "rgb(55, 71, 79)",
                            transformOrigin: "155.444958px 196.18285px",
                          }}
                          id="elhxs0k88obzq"
                          className="animable"
                        />
                        <path
                          d="M136.05,198.15l.52-6.77a1.12,1.12,0,0,1,.5-.81l2.77-1.6c.26-.15.45,0,.43.27l-.51,6.77a1.16,1.16,0,0,1-.51.8l-2.77,1.6C136.22,198.56,136,198.44,136.05,198.15Z"
                          style={{
                            fill: "rgb(69, 90, 100)",
                            transformOrigin: "138.157155px 193.692691px",
                          }}
                          id="el9o4la7flyoq"
                          className="animable"
                        />
                        <path
                          d="M137.1,192.82a2.89,2.89,0,0,1,1.31-2c.66-.38,1.15-.11,1.1.61a2.88,2.88,0,0,1-1.3,2C137.54,193.82,137.05,193.54,137.1,192.82Z"
                          style={{
                            fill: "rgb(38, 50, 56)",
                            transformOrigin: "138.305007px 192.127218px",
                          }}
                          id="elfqeqx8sgi0l"
                          className="animable"
                        />
                        <path
                          d="M136.89,196.23a2.82,2.82,0,0,1,1.3-2c.66-.38,1.15-.11,1.1.61a2.9,2.9,0,0,1-1.3,2C137.32,197.22,136.83,197,136.89,196.23Z"
                          style={{
                            fill: "rgb(38, 50, 56)",
                            transformOrigin: "138.089269px 195.540065px",
                          }}
                          id="el7o3zgunreki"
                          className="animable"
                        />
                        <path
                          d="M180.8,185.91c1.08-2.35.89-2.6-.11-3.5a6.65,6.65,0,0,0-5.81-1.7c-1.81.41-3.65.72-4.49,1.38s.33,2.48,2.8,2.56c3.88.12,4.06,1.14,4.06,1.14a47.19,47.19,0,0,0-5,.08,35.66,35.66,0,0,0-5.31,1.87c-1.53.55-1.45,2.64,1.35,2.83l-2.79,1c-2,.71-2.44,1.92-.62,2.86a3,3,0,0,0,2,.34s-2.15.41-2.05,1.13c.26,2.07,1.69,2.36,6.27,2.79,4.37.4,5.65,2.47,5.13,4.17,0,0,1.48-1.3,2.77-2.61.94-.95,1.7-2,.88-3.58,0,0,2.38-.41,2.24-1.9a7.55,7.55,0,0,0-1.17-3,2.64,2.64,0,0,0,.84-2.68,4.3,4.3,0,0,0-1.35-2.41Z"
                          style={{
                            fill: "rgb(255, 168, 167)",
                            transformOrigin: "172.928071px 191.726441px",
                          }}
                          id="elpmi4tcyo2m"
                          className="animable"
                        />
                        <path
                          d="M168.31,190.57a13.13,13.13,0,0,1,2.56-.78,8.72,8.72,0,0,1,2.69.31,31.85,31.85,0,0,1,5,1.57,30.26,30.26,0,0,1-5.2-.81,14.56,14.56,0,0,0-2.48-.47C170.1,190.41,169.19,190.57,168.31,190.57Z"
                          style={{
                            fill: "rgb(242, 143, 143)",
                            transformOrigin: "173.434998px 190.726326px",
                          }}
                          id="eltxasqb1hdzq"
                          className="animable"
                        />
                        <path
                          d="M166.86,194.78a6,6,0,0,1,2.82-.63,16.07,16.07,0,0,1,2.86.33,27.36,27.36,0,0,1,5.43,1.7c-1.9-.18-3.75-.57-5.59-.93A14.69,14.69,0,0,0,166.86,194.78Z"
                          style={{
                            fill: "rgb(242, 143, 143)",
                            transformOrigin: "172.415009px 195.164173px",
                          }}
                          id="elxs89z54ya4i"
                          className="animable"
                        />
                      </g>
                    </g>
                    <path
                      d="M96.41,165.14l8,1.37c7.61,6,16.57,16.73,16.91,24.84a42.47,42.47,0,0,1-1.41,13.58s-.87,16.8.83,25.54,5.7,29.9,5.7,29.9a25.66,25.66,0,0,1-10.84,6.15c-1.75-11.21-5.77-53.5-5.29-63.33S111.31,177.85,96.41,165.14Z"
                      style={{
                        fill: "#3D50FA",
                        transformOrigin: "111.425003px 215.830009px",
                      }}
                      id="elro8zt5mc2v8"
                      className="animable"
                    />
                    <g id="ele29ni5bn3j">
                      <path
                        d="M96.41,165.14l8,1.37c7.61,6,16.57,16.73,16.91,24.84a42.47,42.47,0,0,1-1.41,13.58s-.87,16.8.83,25.54,5.7,29.9,5.7,29.9a25.66,25.66,0,0,1-10.84,6.15c-1.75-11.21-5.77-53.5-5.29-63.33S111.31,177.85,96.41,165.14Z"
                        style={{
                          opacity: "0.3",
                          transformOrigin: "111.425003px 215.830009px",
                        }}
                        className="animable"
                        id="elkh7n7tl3y5h"
                      />
                    </g>
                    <g id="el4as3gj2febn">
                      <path
                        d="M111.43,207.8c.69-2.6,1.45-5.18,2.21-7.75s1.51-5.15,2.2-7.73a29.94,29.94,0,0,0,.82-3.89c.22-1.22-.63-2.27-1.48-3.25a35.43,35.43,0,0,0-6.06-5.11l-.21-.14,0-.25a12.94,12.94,0,0,0,.08-4.26,11.11,11.11,0,0,0-1.4-4,12.82,12.82,0,0,0-3-3.16,20.49,20.49,0,0,0-3.75-2.3,17.94,17.94,0,0,1,3.92,2.07,11.83,11.83,0,0,1,3.19,3.12,11.65,11.65,0,0,1,1.63,4.21,12.77,12.77,0,0,1,0,4.53l-.15-.38a34.77,34.77,0,0,1,6.26,5.18,9.31,9.31,0,0,1,1.23,1.71,2.52,2.52,0,0,1,.22.5,1.86,1.86,0,0,1,.16.55,3.78,3.78,0,0,1,0,1.11,32,32,0,0,1-.89,4c-.71,2.6-1.59,5.14-2.44,7.69S112.32,205.26,111.43,207.8Z"
                        style={{
                          opacity: "0.2",
                          transformOrigin: "109.090485px 186.879997px",
                        }}
                        className="animable"
                        id="elrcpl7f8c5h"
                      />
                    </g>
                    <path
                      d="M75.07,166s3.29,4.42,7.55,14.75S91,200.48,90.72,210s-4.4,63.94-4.4,63.94a95.38,95.38,0,0,1-26.13,0L61.42,256l-5.78,17.44s-.37,1.4-7-1.41c3.84-15.63,7.52-40.3,8-49.66s1.42-54,1.42-54Z"
                      style={{
                        fill: "#3D50FA",
                        transformOrigin: "69.686752px 220.419537px",
                      }}
                      id="eldczfybjqx5"
                      className="animable"
                    />
                    <g id="elbcel8qs2aw5">
                      <path
                        d="M75.07,166s3.29,4.42,7.55,14.75S91,200.48,90.72,210s-4.4,63.94-4.4,63.94a95.38,95.38,0,0,1-26.13,0L61.42,256l-5.78,17.44s-.37,1.4-7-1.41c3.84-15.63,7.52-40.3,8-49.66s1.42-54,1.42-54Z"
                        style={{
                          opacity: "0.3",
                          transformOrigin: "69.686752px 220.419537px",
                        }}
                        className="animable"
                        id="eld5ayyu4o6u8"
                      />
                    </g>
                    <g id="elor4bw8f5dna">
                      <path
                        d="M88.87,212.74a21.91,21.91,0,0,0-3.6-6.63c-1.48-2.05-3.11-4-4.78-5.88-.82-1-1.67-1.91-2.52-2.85L76.69,196c-.21-.24-.42-.46-.64-.74a1.14,1.14,0,0,1-.17-.23c0-.12-.11-.24-.15-.36a2.4,2.4,0,0,1,0-.64,11.35,11.35,0,0,1,1.4-3.75c.63-1.14,1.3-2.22,2-3.3l.05.64-3.8-4-1.89-2L73,181l-.23-.25a2.23,2.23,0,0,1-.32-.41,2,2,0,0,1-.08-.87q0-.36.09-.72a42.47,42.47,0,0,1,1.44-5.4c.58-1.76,1.18-3.51,1.85-5.24-.48,1.79-1,3.57-1.42,5.36s-.91,3.59-1.15,5.39a3.41,3.41,0,0,0,0,1.16c-.07-.1,0,.05.13.12l.24.24.5.49,1.95,2,3.9,4,.28.29-.23.34c-.68,1.05-1.33,2.13-1.92,3.23a11.59,11.59,0,0,0-1.33,3.32c0,.1,0,.24,0,.31a.1.1,0,0,1,0,.08s.07.1.11.15c.17.22.39.47.59.71l1.25,1.43c.84,1,1.68,1.92,2.49,2.9a76.5,76.5,0,0,1,4.57,6.15,29.44,29.44,0,0,1,1.89,3.33A13.35,13.35,0,0,1,88.87,212.74Z"
                        style={{
                          opacity: "0.2",
                          transformOrigin: "80.611755px 190.425003px",
                        }}
                        className="animable"
                        id="elqbu4y58gzml"
                      />
                    </g>
                    <g
                      id="freepik--arm--inject-2"
                      style={{ transformOrigin: "76.790752px 202.776047px" }}
                      className="animable"
                    >
                      <path
                        d="M97.62,195.19c3.63-2.7,5.45-3.75,7.14-4.23s7.62-2.94,9.9-3.51c1.44-.36,2,1.94.19,3.51-1.42,1.22-5.09,2.81-6.71,3.69s-4.78,4.73-4.78,4.73Z"
                        style={{
                          fill: "rgb(242, 143, 143)",
                          transformOrigin: "106.804854px 193.396168px",
                        }}
                        id="el6dayz76ag6e"
                        className="animable"
                      />
                      <path
                        d="M46.67,177.56c3.59-7.66,6.66-8.4,15.36-9.41,8.18,8,1.54,25.83,1.54,25.83l-4,18.76s21.24-3.08,23.7-4.65,9-8.64,11.24-10.76c3-2.88,4.49-2.5,6-2.27,5,.75,6.09,1.17,7.15,1.85a2.24,2.24,0,0,1,1,1.94c1.33.17,3.32.13,3.58,2.31a6.11,6.11,0,0,1,.07,1.74,1.46,1.46,0,0,1,.87.5c1.1,1.28-.79,5.71-2,6.79-.84.76-2,.85-3.63.64-1.34-.18-.72-1.55-.72-1.55l-1.88.11c-4.07,2.89-4.27,8.61-9.65,9.87a37.28,37.28,0,0,0-6.56,1.28c-11.58,3.88-30.55,15.67-40.86,16.55-10.07.87-9.78-4.49-9.94-10.66C37.84,220.93,43.08,185.2,46.67,177.56Z"
                        style={{
                          fill: "rgb(255, 168, 167)",
                          transformOrigin: "75.725014px 202.666523px",
                        }}
                        id="el1i6z8fduwmh"
                        className="animable"
                      />
                      <path
                        d="M73,210.51l7.64-1.6s-1.56,1.61-1.1,6.79S82.94,223,82.94,223l-11.09,5.4Z"
                        style={{
                          fill: "rgb(250, 250, 250)",
                          transformOrigin: "77.395004px 218.654991px",
                        }}
                        id="el3xbrf3cacc4"
                        className="animable"
                      />
                      <path
                        d="M60.05,210.63l-.43,2.11c-4.59,1.18-10,7.23-11.07,9.74C49.41,218.5,52,212.78,60.05,210.63Z"
                        style={{
                          fill: "rgb(242, 143, 143)",
                          transformOrigin: "54.299999px 216.555008px",
                        }}
                        id="el4gwe8jjbqjl"
                        className="animable"
                      />
                      <path
                        d="M62.36,167.75s-1.46.15-4.3.59-6.93.95-10,5.8-3.3,6.92-5.1,15.21-4.88,27.57-5.27,34.74.39,10.52,2.19,12,6,2.63,12.2.68,24.58-9.29,24.58-9.29-2.36.14-3.12-6.86.83-10.48.83-10.48l-14.3,2.23,4.46-19.31S70.59,174,62.36,167.75Z"
                        style={{
                          fill: "#3D50FA",
                          transformOrigin: "57.1259px 202.776051px",
                        }}
                        id="elydxvjeda9d9"
                        className="animable"
                      />
                      <g id="el33w5loam85m">
                        <path
                          d="M62.36,167.75s-1.46.15-4.3.59-6.93.95-10,5.8-3.3,6.92-5.1,15.21-4.88,27.57-5.27,34.74.39,10.52,2.19,12,6,2.63,12.2.68,24.58-9.29,24.58-9.29-2.36.14-3.12-6.86.83-10.48.83-10.48l-14.3,2.23,4.46-19.31S70.59,174,62.36,167.75Z"
                          style={{
                            opacity: "0.15",
                            transformOrigin: "57.1259px 202.776051px",
                          }}
                          className="animable"
                          id="ellll15x5waur"
                        />
                      </g>
                      <g id="elcr2726ae7v">
                        <path
                          d="M60.05,212.36a15.73,15.73,0,0,0-11.27,9.22c1.57-8,7.75-11.3,11.85-11.76Z"
                          style={{
                            opacity: "0.15",
                            transformOrigin: "54.705px 215.700012px",
                          }}
                          className="animable"
                          id="el16m633u3z3t"
                        />
                      </g>
                      <path
                        d="M108.7,198.85l-5.93-1.2,5.81.38A2.15,2.15,0,0,1,108.7,198.85Z"
                        style={{
                          fill: "rgb(242, 143, 143)",
                          transformOrigin: "105.736268px 198.250008px",
                        }}
                        id="el20lmg1m3rt8"
                        className="animable"
                      />
                      <path
                        d="M112.35,202.9l-6.83-.88,6.84.09A3.49,3.49,0,0,1,112.35,202.9Z"
                        style={{
                          fill: "rgb(242, 143, 143)",
                          transformOrigin: "108.948845px 202.459991px",
                        }}
                        id="elzkg38yorbh"
                        className="animable"
                      />
                      <path
                        d="M111.45,205.91a2,2,0,0,1-.92.8,4,4,0,0,1-1.16.4l.09-.06c-.19.35-.38.71-.58,1l-.14-.18a1.39,1.39,0,0,1,1.09.27,1.82,1.82,0,0,1,.59.89,2.05,2.05,0,0,0-.69-.74,1.3,1.3,0,0,0-.93-.17l-.26.05.12-.24c.18-.35.37-.71.57-1l0-.06h.06a7.7,7.7,0,0,0,1.14-.31A2.56,2.56,0,0,0,111.45,205.91Z"
                        style={{
                          fill: "rgb(242, 143, 143)",
                          transformOrigin: "109.994987px 207.470001px",
                        }}
                        id="elb9i60swloz"
                        className="animable"
                      />
                      <path
                        d="M109.64,206.79a19.66,19.66,0,0,1-2.48.18,2.64,2.64,0,0,1-.85,1.31,13.9,13.9,0,0,1-1.32,1.11l1.88-.11a3,3,0,0,1,2.15-1.17Z"
                        style={{
                          fill: "rgb(242, 143, 143)",
                          transformOrigin: "107.314999px 208.089989px",
                        }}
                        id="el8dkuca5bibd"
                        className="animable"
                      />
                    </g>
                    <g
                      id="freepik--head--inject-2"
                      style={{ transformOrigin: "85.06963px 145.361641px" }}
                      className="animable"
                    >
                      <g
                        id="freepik--head--inject-2"
                        style={{
                          transformOrigin: "87.651318px 146.269855px",
                        }}
                        className="animable"
                      >
                        <g
                          id="freepik--head--inject-2"
                          style={{
                            transformOrigin: "87.259434px 147.577866px",
                          }}
                          className="animable"
                        >
                          <path
                            d="M74.48,151.05a6.46,6.46,0,0,1-5.92-2c-3.2-3.26-3.61-6.69-2.27-9,1.11-1.93,4-3.24,6-2s2.33,2.39,3.21,3.9,2.15-.05,1.22-6.21c1.65-7.33,4.52-9.94,7.26-12.66,4.08-4.07,7.88-3.71,10.46-3.81,2.19-.91,4.35-1.51,7.3-.07s5.32,5.67,6.73,16.62c1.44,11.16-.6,19.19-3.09,21.17a12.86,12.86,0,0,1-8.55,2.85l.69,5.93s9.65,12.74-4.79,10.86a19.92,19.92,0,0,1-13.93-9l-2-18.31S76.63,150.57,74.48,151.05Z"
                            style={{
                              fill: "rgb(255, 168, 167)",
                              transformOrigin: "87.259434px 147.577868px",
                            }}
                            id="elkklfxa3rzvk"
                            className="animable"
                          />
                          <path
                            d="M91.41,137.37a1.88,1.88,0,0,1-2.28,1.38,1.93,1.93,0,1,1,2.28-1.38Z"
                            style={{
                              fill: "rgb(38, 50, 56)",
                              transformOrigin: "89.5471px 136.870553px",
                            }}
                            id="elo1bggn86e8m"
                            className="animable"
                          />
                          <path
                            d="M105.63,131.57l-4-1.86a2.12,2.12,0,0,1,2.86-1.13A2.32,2.32,0,0,1,105.63,131.57Z"
                            style={{
                              fill: "rgb(38, 50, 56)",
                              transformOrigin: "103.720347px 129.976218px",
                            }}
                            id="el604jfu6uzy"
                            className="animable"
                          />
                          <path
                            d="M101.21,136.41a1.85,1.85,0,1,0,3.42-1.41,1.85,1.85,0,1,0-3.42,1.41Z"
                            style={{
                              fill: "rgb(38, 50, 56)",
                              transformOrigin: "102.920002px 135.704999px",
                            }}
                            id="elpdgmnauax5"
                            className="animable"
                          />
                          <path
                            d="M89.65,130.79l-3.92,2.66a2.26,2.26,0,0,1,.55-3.25A2.48,2.48,0,0,1,89.65,130.79Z"
                            style={{
                              fill: "rgb(38, 50, 56)",
                              transformOrigin: "87.459864px 131.61675px",
                            }}
                            id="el264zxgu5d05"
                            className="animable"
                          />
                          <path
                            d="M90.38,146.69l6.23,1.5a3.22,3.22,0,0,1-4.17,2.28A3,3,0,0,1,90.38,146.69Z"
                            style={{
                              fill: "rgb(177, 102, 104)",
                              transformOrigin: "93.427473px 148.666738px",
                            }}
                            id="elcurzeddyyxs"
                            className="animable"
                          />
                          <path
                            d="M94.21,150.52a3.36,3.36,0,0,0-3.59-2.73,2.84,2.84,0,0,0-.31.06,2.82,2.82,0,0,0,2.13,2.62A3.56,3.56,0,0,0,94.21,150.52Z"
                            style={{
                              fill: "rgb(242, 143, 143)",
                              transformOrigin: "92.259998px 149.192894px",
                            }}
                            id="eltm0ggiiaz7"
                            className="animable"
                          />
                          <polygon
                            points="95 133.25 96.68 144.2 102.56 141.68 95 133.25"
                            style={{
                              fill: "rgb(242, 143, 143)",
                              transformOrigin: "98.779999px 138.724998px",
                            }}
                            id="eloaxrpguwl3"
                            className="animable"
                          />
                        </g>
                        <path
                          d="M76.77,135.66c2-7.28,7.82-14.74,17.5-16,4.85-.6,8,1.13,9.86,3a11.58,11.58,0,0,1,3,5.56A72.45,72.45,0,0,1,109,140.84a28.67,28.67,0,0,0-.84-15.8c-2.72-8.14-8.44-9.45-15.77-9.31S75.88,123.9,76.77,135.66Z"
                          style={{
                            fill: "rgb(38, 50, 56)",
                            transformOrigin: "93.220951px 128.280191px",
                          }}
                          id="ellbngtenw6oc"
                          className="animable"
                        />
                      </g>
                      <path
                        d="M77.83,141.37S76.57,129.23,82,123c6.79-7.7,16.21-8.79,22.77-2.38,2.38,2.33,5,10.54,4.15,20.2a55.22,55.22,0,0,0,.84-12.45c-1.1-14.25-12.68-20.58-24.2-20s-20,6.43-23.08,16.75c-1.94,6.44-1.45,15.21-.94,24,.72,12.49-2.88,19-2.88,19a24.19,24.19,0,0,1,3,.7,14.93,14.93,0,0,0,7.93,0c8-2.29,9.81-10,8.94-19.53Z"
                        style={{
                          fill: "#3D50FA",
                          transformOrigin: "84.239025px 138.844854px",
                        }}
                        id="elv6lxxwuot3"
                        className="animable"
                      />
                      <g id="elhrsdcz6k026">
                        <path
                          d="M77.83,141.37S76.57,129.23,82,123c6.79-7.7,16.21-8.79,22.77-2.38,2.38,2.33,5,10.54,4.15,20.2a55.22,55.22,0,0,0,.84-12.45c-1.1-14.25-12.68-20.58-24.2-20s-20,6.43-23.08,16.75c-1.94,6.44-1.45,15.21-.94,24,.72,12.49-2.88,19-2.88,19a24.19,24.19,0,0,1,3,.7,14.93,14.93,0,0,0,7.93,0c8-2.29,9.81-10,8.94-19.53Z"
                          style={{
                            fill: "rgb(255, 255, 255)",
                            opacity: "0.4",
                            transformOrigin: "84.239025px 138.844854px",
                          }}
                          className="animable"
                          id="el89f748nybs5"
                        />
                      </g>
                      <path
                        d="M78.67,150.88c.56,1.94,2.46,4.62,6.16,6.52,4.8,2.47,8.21,2.19,11.63,2.09a12,12,0,0,0,8.78-3.85c1.76-1.83,3.76-7.31,3.76-11.85,1.75,11.08,3.51,12,1.75,16.84s-1.6,7.13-1.6,7.13,2.9,11.61-10.37,14.06S77.13,178.6,69.62,169C77,166.31,79.26,159.7,78.67,150.88Z"
                        style={{
                          fill: "#3D50FA",
                          transformOrigin: "90.549635px 163.089851px",
                        }}
                        id="el8a515c6d4us"
                        className="animable"
                      />
                      <g id="elydlobf48w3">
                        <path
                          d="M78.67,150.88c.56,1.94,2.46,4.62,6.16,6.52,4.8,2.47,8.21,2.19,11.63,2.09a12,12,0,0,0,8.78-3.85c1.76-1.83,3.76-7.31,3.76-11.85,1.75,11.08,3.51,12,1.75,16.84s-1.6,7.13-1.6,7.13,2.9,11.61-10.37,14.06S77.13,178.6,69.62,169C77,166.31,79.26,159.7,78.67,150.88Z"
                          style={{
                            fill: "rgb(255, 255, 255)",
                            opacity: "0.6",
                            transformOrigin: "90.549635px 163.089851px",
                          }}
                          className="animable"
                          id="el0joepb4lsm7e"
                        />
                      </g>
                      <g id="elyz9g4uofd9j">
                        <path
                          d="M69.62,169c.59.76,1.19,1.49,1.8,2.2,9.54-3.09,8.76-15.45,7.58-19.42a6.25,6.25,0,0,1-.33-.86C79.26,159.7,77,166.31,69.62,169Z"
                          style={{
                            fill: "#3D50FA",
                            opacity: "0.6",
                            transformOrigin: "74.653331px 161.059998px",
                          }}
                          className="animable"
                          id="elu9chysw0ft"
                        />
                      </g>
                      <g id="ellqeqhns3ctf">
                        <path
                          d="M78.66,155.91a17.94,17.94,0,0,0,15.55,9.7C89.53,167.84,81.69,164.33,78,160Z"
                          style={{
                            fill: "#3D50FA",
                            opacity: "0.6",
                            transformOrigin: "86.105003px 161.10564px",
                          }}
                          className="animable"
                          id="elm26s4ejneg"
                        />
                      </g>
                      <g id="elpy2y5mhyjap">
                        <path
                          d="M109.1,163.59c-4,9.19-17.25,11.43-29.07,7C86.3,176.88,105.56,179.13,109.1,163.59Z"
                          style={{
                            fill: "#3D50FA",
                            opacity: "0.6",
                            transformOrigin: "94.564999px 169.48274px",
                          }}
                          className="animable"
                          id="eli0pexc4jcp"
                        />
                      </g>
                    </g>
                  </g>
                  <rect
                    x="70.61"
                    y="194.15"
                    width="14.39"
                    height="7.24"
                    style={{
                      fill: "rgb(38, 50, 56)",
                      transformOrigin: "77.805px 197.77px",
                    }}
                    id="el2qy8hlq5yx"
                    className="animable"
                  />
                </g>
              </g>
              <g
                id="freepik--Icons--inject-2"
                style={{ transformOrigin: "251.469223px 56.922211px" }}
                className="animable"
              >
                <path
                  id="freepik--conection-icon--inject-2"
                  d="M111.58,72.68c1.09-1.68,2.42-2.61,3.6-2.7l6-20.68a2.73,2.73,0,0,1-1-1c-1.32-2.14-.85-6.27,1.07-9.21s4.54-3.59,5.86-1.44S128,44,126.06,46.9c-1.09,1.68-2.42,2.61-3.6,2.7l-6,20.68a2.73,2.73,0,0,1,1,1,4.64,4.64,0,0,1,.58,1.53l13.26-8.89a11.58,11.58,0,0,1,1.81-5.61c1.91-2.94,4.54-3.59,5.86-1.44s.85,6.27-1.07,9.21-4.53,3.59-5.86,1.44a4.73,4.73,0,0,1-.58-1.53l-13.26,8.88a11.58,11.58,0,0,1-1.81,5.62c-1.91,2.94-4.53,3.59-5.86,1.44S109.66,75.62,111.58,72.68Z"
                  style={{
                    fill: "rgb(235, 235, 235)",
                    transformOrigin: "124.744525px 59.790005px",
                  }}
                  className="animable"
                />
                <path
                  id="freepik--team-icon--inject-2"
                  d="M374.93,50.82c0-4.8-2.92-10.37-6.51-12.45s-6.52.13-6.52,4.93,2.92,10.36,6.52,12.44S374.93,55.61,374.93,50.82ZM356,66.74a4.12,4.12,0,0,0,1.69,3.78L379.18,83c1.11.63,1.93-.25,1.7-1.82l-1.16-7.93c-.66-4.5-3.39-9-6.56-10.86l-9.49-5.48c-3.16-1.82-5.89-.45-6.55,3.29Zm1.88-26.6c0-3.44-2.1-7.45-4.68-8.94s-4.68.09-4.68,3.54,2.09,7.45,4.68,8.94S357.84,43.59,357.84,40.14Zm-13.48,10.6c-.27,1.56-.09,2.11,1.22,2.87l9.5,5.51c.84-3.77,3.05-5.93,5.86-5.19a10.79,10.79,0,0,0-4.38-6.3l-6.81-3.94c-2.28-1.31-4.24-.31-4.72,2.34Zm39.87,9.36c2.58,1.49,4.68-.09,4.68-3.54s-2.1-7.45-4.68-8.94-4.68.09-4.68,3.54S381.64,58.61,384.23,60.1Zm8.12,11.74c-.48-3.22-2.44-6.48-4.71-7.79l-6.82-3.94c-1.94-1.11-3.63-.57-4.38,1.25,3.31,2.82,5.4,7.33,6.42,12.27l8.94,5.14c1.31.76,1.49.41,1.22-1.45Z"
                  style={{
                    fill: "rgb(235, 235, 235)",
                    transformOrigin: "368.729984px 56.922211px",
                  }}
                  className="animable"
                />
              </g>
              <g
                id="freepik--speech-bubbles--inject-2"
                style={{ transformOrigin: "251.43499px 85.435219px" }}
                className="animable"
              >
                <g
                  id="freepik--speech-bubble--inject-2"
                  style={{ transformOrigin: "51.114994px 85.435215px" }}
                  className="animable"
                >
                  <g
                    id="freepik--speech-bubble--inject-2"
                    style={{ transformOrigin: "51.114994px 85.435215px" }}
                    className="animable"
                  >
                    <path
                      d="M27.73,82.14l41.55-24a5.13,5.13,0,0,1,4.7,0l.51.31a5.17,5.17,0,0,1,2.35,4.07V84.64c0,1.5,0,2.7-2.13,3.91L32.94,112.76a5.21,5.21,0,0,1-4.7,0l-.51-.31a5.19,5.19,0,0,1-2.35-4.07V86.21A5.19,5.19,0,0,1,27.73,82.14Z"
                      style={{
                        fill: "rgb(250, 250, 250)",
                        transformOrigin: "51.109997px 85.445095px",
                      }}
                      id="el2pqn8l7edb2"
                      className="animable"
                    />
                    <path
                      d="M74.34,96c-2.13-1-4.49-3.64-4.49-6.36l-6.51,3.82A11.47,11.47,0,0,0,74.2,97.11.6.6,0,0,0,74.34,96Z"
                      style={{
                        fill: "rgb(250, 250, 250)",
                        transformOrigin: "68.997374px 93.487987px",
                      }}
                      id="el8ypvdt3f4i7"
                      className="animable"
                    />
                    <path
                      d="M76.77,61.8c-.28-1-1.19-1.32-2.27-.69l-41.56,24a4.63,4.63,0,0,0-1.66,1.76l-5.21-3a4.71,4.71,0,0,1,1.66-1.76l41.55-24a5.19,5.19,0,0,1,4.7,0l.52.31A5.16,5.16,0,0,1,76.77,61.8Z"
                      style={{
                        fill: "#3D50FA",
                        transformOrigin: "51.420002px 72.208743px",
                      }}
                      id="el6ljpjqixfj7"
                      className="animable"
                    />
                    <g id="eliamxfou6s2">
                      <path
                        d="M76.77,61.8c-.28-1-1.19-1.32-2.27-.69l-41.56,24a4.63,4.63,0,0,0-1.66,1.76l-5.21-3a4.71,4.71,0,0,1,1.66-1.76l41.55-24a5.19,5.19,0,0,1,4.7,0l.52.31A5.16,5.16,0,0,1,76.77,61.8Z"
                        style={{
                          fill: "rgb(255, 255, 255)",
                          opacity: "0.45",
                          transformOrigin: "51.420002px 72.208743px",
                        }}
                        className="animable"
                        id="elm2cyrd9p8l"
                      />
                    </g>
                    <path
                      d="M25.38,108.38a5.19,5.19,0,0,0,2.35,4.07l.51.31a5.23,5.23,0,0,0,4.3.19c-1.11.42-1.95-.21-1.95-1.55V89.23a4.89,4.89,0,0,1,.69-2.32l-5.21-3a4.78,4.78,0,0,0-.69,2.32Z"
                      style={{
                        fill: "#3D50FA",
                        transformOrigin: "28.959998px 98.616473px",
                      }}
                      id="elx47g874sh5n"
                      className="animable"
                    />
                    <g id="el3p1okepyp8">
                      <path
                        d="M25.38,108.38a5.19,5.19,0,0,0,2.35,4.07l.51.31a5.23,5.23,0,0,0,4.3.19c-1.11.42-1.95-.21-1.95-1.55V89.23a4.89,4.89,0,0,1,.69-2.32l-5.21-3a4.78,4.78,0,0,0-.69,2.32Z"
                        style={{
                          fill: "rgb(255, 255, 255)",
                          opacity: "0.25",
                          transformOrigin: "28.959998px 98.616473px",
                        }}
                        className="animable"
                        id="el3p78f5fv4dd"
                      />
                    </g>
                    <path
                      d="M75.55,61.53c.1,0,.37,0,.5.47h0a2.56,2.56,0,0,1,0,.47V84.64c0,1.41,0,2.26-1.76,3.26l-4.6,2.67-.52.3.18.57a9.36,9.36,0,0,0,4.23,5,11,11,0,0,1-1.64.12A10.7,10.7,0,0,1,64.89,94l-.4-.36-.46.27L58.72,97l-7.83,4.55-18.32,10.6-.31.16h-.09a1,1,0,0,1-.27,0c-.49,0-.56-.59-.56-.94V89.23a4,4,0,0,1,.59-2,4,4,0,0,1,1.38-1.48l41.56-24a1.44,1.44,0,0,1,.68-.22m0-.74a2.1,2.1,0,0,0-1,.32l-41.56,24a4.67,4.67,0,0,0-1.66,1.75,4.89,4.89,0,0,0-.69,2.32V111.4c0,1.07.53,1.68,1.31,1.68a1.58,1.58,0,0,0,.47-.07c.07,0,.12,0,.17-.05l.4-.2,18.32-10.61,7.83-4.55,5.31-3.08A11.41,11.41,0,0,0,72,97.32a11.28,11.28,0,0,0,2.21-.21A.6.6,0,0,0,74.34,96a8.61,8.61,0,0,1-4.23-4.78l4.6-2.67c2.11-1.19,2.14-2.41,2.14-3.9V62.47a3.74,3.74,0,0,0-.2-1.17,4.54,4.54,0,0,1,.12.5,1.24,1.24,0,0,0-1.22-1Z"
                      style={{
                        fill: "#3D50FA",
                        transformOrigin: "53.744991px 86.935003px",
                      }}
                      id="elrde4yiccap"
                      className="animable"
                    />
                  </g>
                  <path
                    d="M38.32,95.45a6.06,6.06,0,0,1,.23-1.67,7.56,7.56,0,0,1,.63-1.62,7.13,7.13,0,0,1,.94-1.38,4.47,4.47,0,0,1,1.15-1,2.45,2.45,0,0,1,1.16-.37,1.53,1.53,0,0,1,.94.3,2,2,0,0,1,.63.89A3.93,3.93,0,0,1,44.23,92,6.46,6.46,0,0,1,44,93.71a7.56,7.56,0,0,1-.63,1.62,7.13,7.13,0,0,1-.94,1.38,4.5,4.5,0,0,1-1.16,1,2.41,2.41,0,0,1-1.15.37,1.53,1.53,0,0,1-.94-.3,2,2,0,0,1-.63-.89A3.72,3.72,0,0,1,38.32,95.45Z"
                    style={{
                      fill: "#3D50FA",
                      transformOrigin: "41.273934px 93.744996px",
                    }}
                    id="el826jea2twjg"
                    className="animable"
                  />
                  <path
                    d="M49.87,88.78a6.11,6.11,0,0,1,.23-1.67,8,8,0,0,1,.63-1.62,7.13,7.13,0,0,1,.94-1.38,4.68,4.68,0,0,1,1.15-1A2.32,2.32,0,0,1,54,82.78a1.48,1.48,0,0,1,.94.29,2,2,0,0,1,.63.89,3.93,3.93,0,0,1,.23,1.41A6.46,6.46,0,0,1,55.55,87a7.56,7.56,0,0,1-.63,1.62A7.7,7.7,0,0,1,54,90.05a4.72,4.72,0,0,1-1.16,1,2.39,2.39,0,0,1-1.15.36,1.53,1.53,0,0,1-.94-.3,1.94,1.94,0,0,1-.63-.89A3.72,3.72,0,0,1,49.87,88.78Z"
                    style={{
                      fill: "#3D50FA",
                      transformOrigin: "52.834813px 87.094564px",
                    }}
                    id="el4gmsr8cu8vu"
                    className="animable"
                  />
                  <path
                    d="M61.42,82.11a6.56,6.56,0,0,1,.22-1.67,8.31,8.31,0,0,1,.64-1.61,6.52,6.52,0,0,1,.94-1.39,4.5,4.5,0,0,1,1.15-1,2.32,2.32,0,0,1,1.16-.36,1.43,1.43,0,0,1,.94.3,2.1,2.1,0,0,1,.63.89,3.87,3.87,0,0,1,.23,1.4,6.59,6.59,0,0,1-.23,1.68A9,9,0,0,1,66.47,82a7.36,7.36,0,0,1-.94,1.39,4.72,4.72,0,0,1-1.16,1,2.32,2.32,0,0,1-1.15.36,1.4,1.4,0,0,1-.94-.3,2,2,0,0,1-.64-.89A3.94,3.94,0,0,1,61.42,82.11Z"
                    style={{
                      fill: "#3D50FA",
                      transformOrigin: "64.374128px 80.415247px",
                    }}
                    id="el04an9aym66ov"
                    className="animable"
                  />
                </g>
                <g
                  id="freepik--speech-bubble--inject-2"
                  style={{ transformOrigin: "451.744995px 85.435221px" }}
                  className="animable"
                >
                  <g
                    id="freepik--speech-bubble--inject-2"
                    style={{ transformOrigin: "451.744995px 85.435221px" }}
                    className="animable"
                  >
                    <path
                      d="M475.14,82.14l-41.55-24a5.13,5.13,0,0,0-4.7,0l-.52.31A5.2,5.2,0,0,0,426,62.47V84.64c0,1.5,0,2.7,2.13,3.91l41.78,24.21a5.21,5.21,0,0,0,4.7,0l.51-.31a5.19,5.19,0,0,0,2.35-4.07V86.21A5.19,5.19,0,0,0,475.14,82.14Z"
                      style={{
                        fill: "rgb(250, 250, 250)",
                        transformOrigin: "451.735016px 85.445091px",
                      }}
                      id="elaqltaim8c0a"
                      className="animable"
                    />
                    <path
                      d="M428.53,96c2.13-1,4.49-3.64,4.49-6.36l6.51,3.82a11.49,11.49,0,0,1-10.86,3.66A.6.6,0,0,1,428.53,96Z"
                      style={{
                        fill: "rgb(250, 250, 250)",
                        transformOrigin: "433.866087px 93.491293px",
                      }}
                      id="el6wo31w7enbp"
                      className="animable"
                    />
                    <path
                      d="M426.1,61.8c.28-1,1.18-1.32,2.27-.69l41.56,24a4.61,4.61,0,0,1,1.65,1.76l5.21-3a4.61,4.61,0,0,0-1.65-1.76l-41.55-24a5.19,5.19,0,0,0-4.7,0l-.52.31A5.16,5.16,0,0,0,426.1,61.8Z"
                      style={{
                        fill: "#3D50FA",
                        transformOrigin: "451.444992px 72.208753px",
                      }}
                      id="elztmjlhri4f"
                      className="animable"
                    />
                    <g id="el61qrcwgil3f">
                      <path
                        d="M426.1,61.8c.28-1,1.18-1.32,2.27-.69l41.56,24a4.61,4.61,0,0,1,1.65,1.76l5.21-3a4.61,4.61,0,0,0-1.65-1.76l-41.55-24a5.19,5.19,0,0,0-4.7,0l-.52.31A5.16,5.16,0,0,0,426.1,61.8Z"
                        style={{
                          fill: "rgb(255, 255, 255)",
                          opacity: "0.45",
                          transformOrigin: "451.444992px 72.208753px",
                        }}
                        className="animable"
                        id="eljcpsy8d1s6r"
                      />
                    </g>
                    <path
                      d="M477.49,108.38a5.19,5.19,0,0,1-2.35,4.07l-.51.31a5.23,5.23,0,0,1-4.3.19c1.1.42,1.95-.21,1.95-1.55V89.23a4.89,4.89,0,0,0-.69-2.32l5.21-3a4.78,4.78,0,0,1,.69,2.32Z"
                      style={{
                        fill: "#3D50FA",
                        transformOrigin: "473.909988px 98.616477px",
                      }}
                      id="elt8jjgaiz09p"
                      className="animable"
                    />
                    <g id="elt1zu5gnevk">
                      <path
                        d="M477.49,108.38a5.19,5.19,0,0,1-2.35,4.07l-.51.31a5.23,5.23,0,0,1-4.3.19c1.1.42,1.95-.21,1.95-1.55V89.23a4.89,4.89,0,0,0-.69-2.32l5.21-3a4.78,4.78,0,0,1,.69,2.32Z"
                        style={{
                          fill: "rgb(255, 255, 255)",
                          opacity: "0.25",
                          transformOrigin: "473.909988px 98.616477px",
                        }}
                        className="animable"
                        id="ell5k7plwpfm"
                      />
                    </g>
                    <path
                      d="M427.32,61.53a1.38,1.38,0,0,1,.67.22l41.57,24a4,4,0,0,1,1.38,1.48,4,4,0,0,1,.59,2V111.4c0,.35-.07.94-.56.94a1,1,0,0,1-.27,0h-.09a2.25,2.25,0,0,1-.31-.16L452,101.51,444.15,97l-5.31-3.08-.46-.27L438,94a10.71,10.71,0,0,1-7.1,2.61,11,11,0,0,1-1.64-.12,9.36,9.36,0,0,0,4.23-5l.18-.57-.52-.3-4.6-2.67c-1.77-1-1.77-1.85-1.77-3.26V62.47a2.59,2.59,0,0,1,.05-.47h0c.13-.47.4-.47.5-.47m0-.74h0a1.24,1.24,0,0,0-1.22,1,4.54,4.54,0,0,1,.12-.5,3.74,3.74,0,0,0-.2,1.17V84.64c0,1.49,0,2.71,2.14,3.9l4.6,2.67A8.61,8.61,0,0,1,428.53,96a.6.6,0,0,0,.14,1.12,11.28,11.28,0,0,0,2.21.21,11.41,11.41,0,0,0,7.59-2.8l5.31,3.08,7.83,4.55,18.32,10.61.4.2.16.05a1.69,1.69,0,0,0,.48.07c.78,0,1.31-.61,1.31-1.68V89.23a4.79,4.79,0,0,0-.7-2.32,4.65,4.65,0,0,0-1.65-1.75l-41.56-24a2.13,2.13,0,0,0-1.05-.32Z"
                      style={{
                        fill: "#3D50FA",
                        transformOrigin: "449.154953px 86.940006px",
                      }}
                      id="el1i07nzz7wne"
                      className="animable"
                    />
                  </g>
                  <path
                    d="M464.32,96.86a2,2,0,0,1-.63.89,1.53,1.53,0,0,1-.94.3,2.41,2.41,0,0,1-1.15-.37,4.34,4.34,0,0,1-1.16-1,7.13,7.13,0,0,1-.94-1.38,7.56,7.56,0,0,1-.63-1.62,6.46,6.46,0,0,1-.23-1.67,3.93,3.93,0,0,1,.23-1.41,2,2,0,0,1,.63-.89,1.53,1.53,0,0,1,.94-.3,2.48,2.48,0,0,1,1.16.37,4.47,4.47,0,0,1,1.15,1,7.13,7.13,0,0,1,.94,1.38,7.56,7.56,0,0,1,.63,1.62,6.46,6.46,0,0,1,.23,1.67A3.93,3.93,0,0,1,464.32,96.86Z"
                    style={{
                      fill: "#3D50FA",
                      transformOrigin: "461.595001px 93.729997px",
                    }}
                    id="elebkv3swtoqc"
                    className="animable"
                  />
                  <path
                    d="M452.77,90.19a1.94,1.94,0,0,1-.63.89,1.53,1.53,0,0,1-.94.3,2.39,2.39,0,0,1-1.15-.36,4.54,4.54,0,0,1-1.16-1,7.21,7.21,0,0,1-.94-1.39,7.56,7.56,0,0,1-.63-1.62,6.46,6.46,0,0,1-.23-1.67,3.93,3.93,0,0,1,.23-1.41,2,2,0,0,1,.63-.89,1.46,1.46,0,0,1,.94-.29,2.35,2.35,0,0,1,1.16.36,4.68,4.68,0,0,1,1.15,1,7.13,7.13,0,0,1,.94,1.38,8,8,0,0,1,.63,1.62,6.52,6.52,0,0,1,.23,1.67A3.93,3.93,0,0,1,452.77,90.19Z"
                    style={{
                      fill: "#3D50FA",
                      transformOrigin: "450.044968px 87.064427px",
                    }}
                    id="eliba9rwq4bph"
                    className="animable"
                  />
                  <path
                    d="M441.22,83.52a1.94,1.94,0,0,1-.63.89,1.41,1.41,0,0,1-.94.3,2.29,2.29,0,0,1-1.15-.36,4.72,4.72,0,0,1-1.16-1A7.36,7.36,0,0,1,436.4,82a7.69,7.69,0,0,1-.63-1.61,6.59,6.59,0,0,1-.23-1.68,3.87,3.87,0,0,1,.23-1.4,1.94,1.94,0,0,1,.63-.89,1.43,1.43,0,0,1,.94-.3,2.32,2.32,0,0,1,1.16.36,4.68,4.68,0,0,1,1.15,1,6.92,6.92,0,0,1,.94,1.39,7.69,7.69,0,0,1,.63,1.61,6.16,6.16,0,0,1,.23,1.67A3.72,3.72,0,0,1,441.22,83.52Z"
                    style={{
                      fill: "#3D50FA",
                      transformOrigin: "438.494951px 80.415156px",
                    }}
                    id="elrrwjy9qs4xn"
                    className="animable"
                  />
                </g>
              </g>
              <defs>
                {" "}
                <filter id="active" height="200%">
                  {" "}
                  <feMorphology
                    in="SourceAlpha"
                    result="DILATED"
                    operator="dilate"
                    radius={2}
                  />{" "}
                  <feFlood
                    floodColor="#32DFEC"
                    floodOpacity={1}
                    result="PINK"
                  />{" "}
                  <feComposite
                    in="PINK"
                    in2="DILATED"
                    operator="in"
                    result="OUTLINE"
                  />{" "}
                  <feMerge>
                    {" "}
                    <feMergeNode in="OUTLINE" />{" "}
                    <feMergeNode in="SourceGraphic" />{" "}
                  </feMerge>{" "}
                </filter>{" "}
                <filter id="hover" height="200%">
                  {" "}
                  <feMorphology
                    in="SourceAlpha"
                    result="DILATED"
                    operator="dilate"
                    radius={2}
                  />{" "}
                  <feFlood
                    floodColor="#ff0000"
                    floodOpacity="0.5"
                    result="PINK"
                  />{" "}
                  <feComposite
                    in="PINK"
                    in2="DILATED"
                    operator="in"
                    result="OUTLINE"
                  />{" "}
                  <feMerge>
                    {" "}
                    <feMergeNode in="OUTLINE" />{" "}
                    <feMergeNode in="SourceGraphic" />{" "}
                  </feMerge>{" "}
                  <feColorMatrix
                    type="matrix"
                    values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
                  />{" "}
                </filter>
              </defs>
            </svg>
          </div>
          <div className="col s12 l6 center-align mt15 mb15 secondary-color">
            Nott.one — сервис для поиска и организации событий и проектов.
            Организовывайте крупные мероприятия или небольшие встречи. Nott.one
            сам разошлет приглашения на ваше событие пользователям в округе,
            поможет принять оплату за билеты, если участие платное, и соберет
            обратную связь от участников после мероприятия. Nott.one — это новая
            возможность развивать себя, свое окружение и свою аудиторию. Начните
            уже сегодня!
          </div>
        </div>
        <div className="row nm">
          <div className="col s12 center-align">
            <Button flat modal="close" node="button" className="iq-btn">
              Отлично, поехали!
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Navbar;
